import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { version } from "../Version";
export var Font;
(function (Font) {
    // F96 = 0.096,
    Font[Font["F80"] = 0.08] = "F80";
    // F72 = 0.072,
    // F64 = 0.064,
    Font[Font["F56"] = 0.056] = "F56";
    Font[Font["F48"] = 0.048] = "F48";
    Font[Font["F42"] = 0.042] = "F42";
    Font[Font["F40"] = 0.04] = "F40";
    Font[Font["F36"] = 0.036] = "F36";
    Font[Font["F34"] = 0.034] = "F34";
    Font[Font["F30"] = 0.03] = "F30";
    Font[Font["F32"] = 0.032] = "F32";
    Font[Font["F28"] = 0.028] = "F28";
    Font[Font["F26"] = 0.026] = "F26";
    Font[Font["F25p5"] = 0.0255] = "F25p5";
    Font[Font["F24"] = 0.024] = "F24";
    Font[Font["F22"] = 0.022] = "F22";
    Font[Font["F20"] = 0.02] = "F20";
    Font[Font["F18"] = 0.018] = "F18";
    Font[Font["F16"] = 0.016] = "F16";
    Font[Font["F14"] = 0.014] = "F14";
    Font[Font["F12"] = 0.012] = "F12";
    Font[Font["F10"] = 0.01] = "F10";
    Font[Font["F8"] = 0.008] = "F8";
})(Font || (Font = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Bottom"] = 1] = "Bottom";
    VerticalAlignment[VerticalAlignment["Center"] = 2] = "Center";
})(VerticalAlignment || (VerticalAlignment = {}));
export var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Right"] = 1] = "Right";
    HorizontalAlignment[HorizontalAlignment["Center"] = 2] = "Center";
})(HorizontalAlignment || (HorizontalAlignment = {}));
export class Env {
    static setAssetsUrl(url) {
        Env._assetsUrl = url;
    }
    static getAssetsUrl() {
        return Env._assetsUrl;
    }
    static relativeName(fileName, addVersion = true) {
        if (fileName !== "" && addVersion)
            fileName = `${fileName}?v=${version}`;
        return Env._assetsUrl ? `${Env._assetsUrl}/${fileName}` : `assets/${fileName}`;
    }
    static relativeAnimationsCoinsName(fileName, addVersion = true) {
        return Env.relativeName(`animations/coins/${fileName}`, addVersion);
    }
    static relativeAnimationsHeartsName(fileName, addVersion = true) {
        return Env.relativeName(`animations/hearts/${fileName}`, addVersion);
    }
    static relativeXmasCalendarName(fileName, addVersion = true) {
        return Env.relativeName(`xmasCalendar/${fileName}`, addVersion);
    }
    static relativeCommonName(fileName) {
        return Env.relativeName(`common/${fileName}`);
    }
    static relativeLobbyName(fileName) {
        return Env.relativeName(`lobby/${fileName}`);
    }
    static relativeLoginName(fileName) {
        return Env.relativeLobbyName(`login/${fileName}`);
    }
    static relativeNotificationCenterName(fileName) {
        return Env.relativeName(`notificationCenter/${fileName}`);
    }
    static relativeOnboardingName(fileName) {
        return Env.relativeName(`onboarding/${fileName}`);
    }
    static relativeAnnouncementName(fileName) {
        return Env.relativeName(`announcements/${fileName}`);
    }
    static relativeBroadcastName(fileName) {
        return Env.relativeName(`broadcast/${fileName}`);
    }
    static relativeBroadcastCarouselName(fileName) {
        return Env.relativeBroadcastName(`carousel/${fileName}`);
    }
    static relativeBroadcastNavigationName(fileName) {
        return Env.relativeBroadcastName(`navigation/${fileName}`);
    }
    static relativeBroadcastModelName(fileName) {
        return Env.relativeBroadcastName(`model/${fileName}`);
    }
    static relativeBroadcastTipMenuName(fileName) {
        return Env.relativeBroadcastName(`tipmenu/${fileName}`);
    }
    static relativeBroadcastTipsName(fileName) {
        return Env.relativeBroadcastName(`tips/${fileName}`);
    }
    static relativeBroadcastModeName(fileName) {
        return Env.relativeBroadcastName(`mode/${fileName}`);
    }
    static relativeBroadcastChatName(fileName) {
        return Env.relativeBroadcastName(`chat/${fileName}`);
    }
    static relativeBroadcastComplimentName(fileName) {
        return Env.relativeBroadcastName(`complimentdialog/${fileName}`);
    }
    static relativeBroadcastHelpName(fileName) {
        return Env.relativeBroadcastName(`help/${fileName}`);
    }
    static relativeBroadcastRelatedName(fileName) {
        return Env.relativeBroadcastName(`related/${fileName}`);
    }
    static relativeVideoClipMainName(fileName) {
        return Env.relativeBroadcastName(`videomain/${fileName}`);
    }
    static relativeKeyboardName(filename) {
        return Env.relativeName(`keyboard/${filename}`);
    }
    static relativeEnvironmentName(fileName) {
        return Env.relativeName(`environment/${fileName}`);
    }
    static relativeEnvironmentDialogName(fileName) {
        return Env.relativeName(`lobby/environment/${fileName}`);
    }
    static relativeMessengerName(fileName) {
        return Env.relativeName(`common/messenger/${fileName}`);
    }
}
Env.lobbyY = 0.080 - 0.150; // meters
Env.panel904_Y = 0.044; // meters
Env.broadcastPanelY = {
    navigation: 0.454,
    model: 0.312,
    chat: -0.098,
    user: -0.454,
    privateModeSelector: 0.000,
    subtitles: -0.45,
};
Env.keyboardHeight = 0.340;
Env.broadcastY = 0; // meters
Env.spinnerY = 0; // meters
Env.notificationCenterY = 0.150; // meters
Env.screenDistance = 1.9; // meters
Env.cylinderDistance = 1.95; // meters
Env.menuDistance = 0.8; // meters
Env.dialogsDistance = 0.800;
Env.complimentDistance = 0.700;
Env.notificationCenterDistance = 0.680; // meters
Env.preview = {
    widthPx: 420,
    heightPx: 252,
    height: 0.320,
};
Env.galleryPictureRatio = Env.preview.widthPx / Env.preview.heightPx;
Env.backupPictureHeight = 1.5;
Env.backupPictureWidth = Env.backupPictureHeight * Env.galleryPictureRatio;
Env.redPadding = 0.032;
Env.broadcastMenuWidth = 0.588;
Env.chatHeight = 0.620;
Env.chatMargin = 0.016;
Env._assetsUrl = undefined;
Env.galleryItemHiddenRightPadding = 0.020;
Env.scene = {
    skyboxColor: "#000000",
    get skyboxTextureFile() {
        return Env.relativeName("skybox.svg");
    },
    get emptyDomeTextureUrl() {
        return Env.relativeName("empty_dome.png");
    },
    skyboxGradient: [
        { color: "#CD288B", offset: 0 },
        { color: "#33122E", offset: 0.419853 },
        { color: "#0D0923", offset: 0.508246 },
        { color: "#2869B7", offset: 1 }
    ],
};
Env.camera = {
    near: 0.02,
    far: 10000,
    position: { x: 0, y: 1.23, z: 0 },
    defaultDirection: { x: 0, y: 0, z: 1 }
};
Env.fontFamily = "Arial";
Env.messagePanelLifetimeInMillis = 3000;
Env.broadcastMenuMessageLifetimeInMillis = 3000;
Env.fps = {
    distance: 1.1,
    angle: 60,
    width: 0.064,
    height: 0.064,
    cornerRadius: 0.016,
    backgroundColor: "#1A161CE0",
    text: {
        color: "#B1A3B7",
        fontSize: Font.F36,
        fontWeight: "bold"
    }
};
Env.controllerPointer = {
    ray: {
        length: 0.3,
        diameterNear: 0.006,
        diameterFar: 0.0002,
        alpha: 0.5
    },
    dot: {
        diameter: 0.015
    }
};
Env.logo = {
    get assetsUrl() {
        return Env.relativeName("");
    },
    fileName: `logo.glb?v=${version}`,
    texture: "data:image/jpg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4QBmRXhpZgAATU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAAExAAIAAAAQAAAATgAAAAAAAABgAAAAAQAAAGAAAAABcGFpbnQubmV0IDUuMC4yAP/bAEMAAgEBAQEBAgEBAQICAgICBAMCAgICBQQEAwQGBQYGBgUGBgYHCQgGBwkHBgYICwgJCgoKCgoGCAsMCwoMCQoKCv/bAEMBAgICAgICBQMDBQoHBgcKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCv/AABEIAAQABAMBEgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AP38ooA//9k="
};
Env.common = {
    isNewMark: {
        get icon() {
            return Env.relativeCommonName("is_new_mark.svg");
        },
        width: 0.018 + 0.008,
        height: 0.018 + 0.008,
        padding: {
            right: 0.008,
            top: 0.008,
        },
    },
    infoDialog: {
        width: 0.588,
        height: 0.904,
        background: {
            cornerRadius: 0.032,
            backgroundColor: "#241D26",
            thickness: 0.000,
            // borderColor: "#5F5862",
        },
        closeButton: {
            size: 0.052,
            top: 0.006,
            right: 0.006,
            get normalImg() {
                return Env.relativeLoginName("close_normal.svg");
            },
            get hoverImg() {
                return Env.relativeLoginName("close_hover.svg");
            },
            get pressedImg() {
                return Env.relativeLoginName("close_pressed.svg");
            },
        },
        favoritesLoginWarning: {
            image: {
                width: 0.096,
                height: 0.096,
                top: 0.264,
                get srcStar() {
                    return Env.relativeCommonName("favorite_large_star.svg");
                },
                get srcShoppingCart() {
                    return Env.relativeCommonName("shopping_cart_large.svg");
                },
            },
            caption: {
                color: "#FFFFFF",
                fontSize: Font.F36,
                fontWeight: "700",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                top: 0.384,
                width: 0.476,
            },
            description: {
                color: "#B8B0BC",
                fontSize: Font.F24,
                fontWeight: "500",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                top: 0.484,
                width: 0.476,
            },
            loginButton: {
                rectangleLayout: {
                    width: 0.556,
                    height: 0.080,
                    top: 0.808,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "#2787FA" },
                    hoverState: { color: "#6BAFFF" },
                    pressedState: { color: "#6BAFFF" },
                },
                textLayout: {
                    common: {
                        fontSize: Font.F24,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        width: 0.556,
                        height: 0.064,
                        textWrapping: TextWrapping.Clip,
                        // resizeToFit: true,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                    },
                },
            },
        },
        topUpWarning: {
            image: {
                width: 0.096,
                height: 0.096,
                top: 0.311,
                get src() {
                    return Env.relativeCommonName("top_up_warning.svg");
                },
            },
            caption: {
                color: "#FFFFFF",
                fontSize: Font.F36,
                fontWeight: "700",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                top: 0.431,
                width: 0.476,
            },
            description: {
                color: "#B8B0BC",
                fontSize: Font.F24,
                fontWeight: "500",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                top: 0.484,
                width: 0.476,
            },
            topUpButton: {
                rectangleLayout: {
                    width: 0.556,
                    height: 0.080,
                    top: 0.808,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "#0C9B56" },
                    hoverState: { color: "#0A713F" },
                    pressedState: { color: "#0B5E36" },
                },
                textLayout: {
                    common: {
                        fontSize: Font.F24,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        width: 0.556,
                        height: 0.064,
                        textWrapping: TextWrapping.Clip,
                        // resizeToFit: true,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                    },
                },
            },
        },
        messengerNoMessagesWarning: {
            image: {
                width: 0.096,
                height: 0.096,
                top: 0.301,
                get src() {
                    return Env.relativeCommonName("messenger_no_messages_warning.svg");
                },
            },
            caption: {
                color: "#FFFFFF",
                fontSize: Font.F36,
                fontWeight: "700",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Top,
                textWrapping: TextWrapping.WordWrap,
                top: 0.421,
                width: 0.476,
            },
            description: {
                color: "#B8B0BC",
                fontSize: Font.F24,
                fontWeight: "500",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Top,
                textWrapping: TextWrapping.WordWrap,
                top: 0.479,
                width: 0.476,
            },
            actionButton: {
                rectangleLayout: {
                    width: 0.556,
                    height: 0.080,
                    top: 0.808,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "#2787FA" },
                    hoverState: { color: "#6BAFFF" },
                    pressedState: { color: "#499CFF" },
                },
                textLayout: {
                    common: {
                        fontSize: Font.F24,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        width: 0.556,
                        height: 0.064,
                        textWrapping: TextWrapping.Clip,
                        // resizeToFit: true,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                    },
                },
            },
        },
    },
    profileButton: {
        client: {
            width: {
                min: 0.135,
                restOfTheSpace: 0.024,
            },
            height: 0.052,
            colorLayout: {
                cornerRadiusPx: 0.016,
                common: { borderThickness: 0 },
                normalState: { color: "transparent" },
                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                pressedState: { color: "rgba(255, 255, 255, 0.06)" },
            },
            nickname: {
                left: 0.012,
                top: 0.001,
                fontSize: Font.F20,
                fontWeight: "700",
                color: "#FFFFFF",
                textWrapping: TextWrapping.Clip,
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Left,
                textVerticalAlignment: VerticalAlignment.Center,
            },
            balancePanel: {
                left: 0.012,
                top: 0.027,
                spacing: 0.006,
                balance: {
                    fontSize: Font.F20,
                    fontWeight: "500",
                    color: "#FFFFFF",
                    height: 0.024,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                },
                currency: {
                    width: 0.020,
                    height: 0.020,
                    get img() {
                        return Env.relativeCommonName("token_icon.svg");
                    },
                },
            },
        },
        guest: {
            signInButton: {
                left: 0.000,
                top: 0.000,
                width: 0.137,
                height: 0.052,
                colorLayout: {
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "transparent" },
                    hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                    pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                },
                children: {
                    image: {
                        width: 0.044,
                        height: 0.044,
                        left: 0.004,
                        top: 0.004,
                        get src() {
                            return Env.relativeBroadcastNavigationName("signin.svg");
                        },
                    },
                    label: {
                        fontSize: Font.F20,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        left: 0.048,
                        top: 0.014,
                        width: 0.145 - 0.048,
                        height: 0.024,
                        textWrapping: TextWrapping.Clip,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                    },
                },
            },
            signUpButton: {
                left: 0.182,
                top: 0.000,
                width: 0.223,
                height: 0.052,
                colorLayout: {
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "transparent" },
                    hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                    pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                },
                children: {
                    label: {
                        fontSize: Font.F20,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        left: 0.000,
                        top: 0.000,
                        width: 0.223,
                        height: 0.052,
                        textWrapping: TextWrapping.Clip,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                    },
                },
            },
        },
    },
    messengerButton: {
        width: 0.052,
        height: 0.052,
        activeImageLayout: {
            get normalImg() {
                return Env.relativeCommonName("active_messenger_normal.svg");
            },
            get hoverImg() {
                return Env.relativeCommonName("active_messenger_hover.svg");
            },
            get pressedImg() {
                return Env.relativeCommonName("inactive_messenger_pressed.svg");
            },
            get disabledImg() {
                return Env.relativeCommonName("inactive_messenger_disabled.svg");
            },
        },
        inactiveImageLayout: {
            get normalImg() {
                return Env.relativeCommonName("inactive_messenger_normal.svg");
            },
            get hoverImg() {
                return Env.relativeCommonName("inactive_messenger_hover.svg");
            },
            get pressedImg() {
                return Env.relativeCommonName("inactive_messenger_pressed.svg");
            },
            get disabledImg() {
                return Env.relativeCommonName("inactive_messenger_disabled.svg");
            },
        },
        unreads: {
            background: {
                height: 0.020,
                cornerRadius: 0.010,
                color: "#2787FA",
            },
            textLayout: {
                color: "#FFFFFF",
                fontSize: Font.F16,
                fontWeight: "500",
                resizeToFit: true,
                padding: {
                    left: 0.005,
                    right: 0.005,
                    top: 0.000,
                    bottom: 0.000,
                },
            },
        },
    },
    messengerPanel: {
        background: {
            width: 0.588,
            height: 0.904,
            cornerRadius: 0.032,
            get backgroundImage() { return Env.relativeMessengerName("messenger_background.jpg"); },
        },
        rootGrid: {
            rows: ["0.064m", "1*", "auto", "auto", "auto", "0.016m"],
            // index:    0     1       2       3       4         5
            //               msg    tips   qkMsg   input
            columns: ["1*"],
            // height: 0.904,
        },
        header: {
            headerGrid: {
                rows: ["1*"],
                columns: ["0.006m", "0.052m", "0.016m", "0.388m", "0.016m", "0.052m", "0.052m", "0.006m"],
                // index:       0         1         2         3         4         5         6         7
                background: "#36333C",
                height: 0.064,
            },
            ellipsisSubmenu: {
                width: 0.280,
                height: 0.248 - 0.120, // (0.120 - two deleted menu items)
                offset: {
                    left: 0.588 / 2 - 0.058 - 0.280 / 2,
                    top: 0.904 / 2 - 0.062 - 0.248 / 2 + (0.120 / 2), // (0.120/2 - because of two deleted items)
                    distance: -0.01,
                },
                thickness: 0.002,
                borderColor: "#5F5862",
                item: {
                    colorLayout: {
                        width: 0.280,
                        height: 0.052,
                        common: { borderThickness: 0 },
                        normalState: { color: "#00000000" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                        disabledState: { color: "#00000000" },
                    },
                    text: {
                        textLayout: {
                            left: 0.016,
                            states: [
                                {
                                    state: "common",
                                    style: {
                                        fontSize: Font.F20,
                                        fontWeight: "500",
                                        color: "#FFFFFF",
                                        resizeToFit: true,
                                        textWrapping: TextWrapping.Ellipsis,
                                        horizontalAlignment: HorizontalAlignment.Left,
                                        verticalAlignment: VerticalAlignment.Center,
                                        textHorizontalAlignment: HorizontalAlignment.Left,
                                        textVerticalAlignment: VerticalAlignment.Center,
                                    }
                                },
                                {
                                    state: "disabled",
                                    style: { color: "#8E8793" }
                                },
                            ]
                        },
                    },
                },
            },
            chatListButton: {
                size: 0.052,
                activeImageLayout: {
                    get normalImg() {
                        return Env.relativeMessengerName("active_chatlist_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeMessengerName("active_chatlist_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeMessengerName("inactive_chatlist_pressed.svg");
                    },
                },
                inactiveImageLayout: {
                    get normalImg() {
                        return Env.relativeMessengerName("inactive_chatlist_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeMessengerName("inactive_chatlist_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeMessengerName("inactive_chatlist_pressed.svg");
                    },
                },
            },
            modelSection: {
                maxWidth: 0.388,
                height: 0.048,
                avatar: {
                    photoStatusContainerHeight: 0.048,
                    photo: {
                        diameter: 0.032,
                        left: 0.000,
                        top: 0.004,
                        outlineDiameter: 0.040,
                        outlineThickness: 0.002,
                    },
                    status: {
                        fontSize: Font.F8,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        padding: {
                            left: 0.002,
                            top: 0.002,
                            right: 0.002,
                            bottom: 0.002,
                        },
                        cornerRadius: 0.002,
                        resizeToFit: true,
                        background: {
                            away: "#564D5B",
                            live: "#0C9B56",
                            private: "#F18333",
                            offline: "#0000007F",
                            uninitialized: "#0000007F",
                        },
                    },
                },
                bannedAvatar: {
                    width: 0.040,
                    height: 0.040,
                    get src() { return Env.relativeMessengerName("banned_avatar.svg"); },
                },
                topLine: {
                    height: 0.024,
                    left: 0.052,
                    top: 0.000,
                    star: {
                        width: 0.032,
                        paddingRight: 0.008,
                        get src() { return Env.relativeMessengerName("favorite_small_star.svg"); },
                    },
                    modelNickname: {
                        color: "#FFFFFF",
                        fontSize: Font.F20,
                        fontWeight: "700",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Center,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textVerticalAlignment: VerticalAlignment.Center,
                        textWrapping: TextWrapping.Clip,
                    },
                },
                status: {
                    left: 0.052,
                    top: 0.024,
                    color: "#B8B0BC",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                },
            },
            ellipsisButton: {
                size: 0.052,
                get normalImg() {
                    return Env.relativeMessengerName("ellipsis_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeMessengerName("ellipsis_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeMessengerName("ellipsis_pressed.svg");
                },
            },
            closeButton: {
                size: 0.052,
                get normalImg() {
                    return Env.relativeLoginName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeLoginName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeLoginName("close_pressed.svg");
                },
            },
        },
        chat: {
            top: 0.064,
            warning: {
                caption: {
                    color: "#FFFFFF",
                    fontSize: Font.F36,
                    fontWeight: "700",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Top,
                    textWrapping: TextWrapping.WordWrap,
                    top: 0.2705,
                    width: 0.460,
                },
                description: {
                    color: "#B8B0BC",
                    fontSize: Font.F24,
                    fontWeight: "500",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Top,
                    textWrapping: TextWrapping.WordWrap,
                    top: 0.3245,
                    width: 0.460,
                },
            },
            warningPopup: {
                backgroundColor: "#F026AB",
                timeoutMs: 3000,
                fontColor: "white",
                fontSize: Font.F22,
                height: 0.080,
                width: 0.588,
                cornerRadius: 0.032,
            },
            scrollView: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.000,
                        top: 0,
                        bottom: 0
                    },
                },
                speed: 0.5,
            },
            chatStackPanel: {
                spacing: 0.008,
                // topGap: 0.002,
                // bottomGap: 0.008, // + 0.008 spacing => 0.016
            },
            jumpDown: {
                width: 0.052,
                height: 0.064,
                right: 0.016,
                bottom: 0.016,
                button: {
                    get normalImg() {
                        return Env.relativeCommonName("jump_down_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeCommonName("jump_down_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeCommonName("jump_down_pressed.svg");
                    },
                },
                unreads: {
                    background: {
                        height: 0.020,
                        cornerRadius: 0.010,
                        color: "#2787FA",
                    },
                    textLayout: {
                        color: "#FFFFFF",
                        fontSize: Font.F16,
                        fontWeight: "500",
                        resizeToFit: true,
                        padding: {
                            left: 0.005,
                            right: 0.005,
                            top: 0.000,
                            bottom: 0.000,
                        },
                    },
                },
            },
            messageContainer: {
                width: 0.588,
                minHeight: 0.044,
                dateLine: {
                    height: 0.040,
                    dateText: {
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "#B8B0BC",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Center,
                        verticalAlignment: VerticalAlignment.Center,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                        textWrapping: TextWrapping.Clip,
                    },
                },
                newMessagesLine: {
                    height: 0.040,
                    caption: {
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "white",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Center,
                        verticalAlignment: VerticalAlignment.Center,
                        textHorizontalAlignment: HorizontalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                        textWrapping: TextWrapping.Clip,
                    },
                    line: {
                        width: 0.189,
                        height: 0.001,
                        color: "white",
                        padding: 0.016,
                    },
                },
                modelMessage: {
                    avatar: {
                        width: 0.032,
                        height: 0.032,
                        cornerRadius: 0.016,
                        left: 0.020,
                        top: -0.004,
                    },
                    bubble: {
                        width: 0.400,
                        left: 0.064,
                        cornerRadius: 0.016,
                        background: "#3A1F31",
                    },
                    messageText: {
                        fontSize: Font.F24,
                        fontWeight: "500",
                        color: "#FFA06A",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.WordWrap,
                        width: 0.296,
                        left: 0.016,
                        padding: {
                            top: 0.008,
                            bottom: 0.008,
                        },
                    },
                    linkColor: "#2787FA",
                    timeText: {
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "#8E8793",
                        resizeToFit: false,
                        horizontalAlignment: HorizontalAlignment.Right,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Right,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.Clip,
                        width: 0.400,
                        padding: {
                            right: 0.016,
                            bottom: 0.008,
                        },
                    },
                },
                userTips: {
                    bubble: {
                        width: 0.400,
                        left: -0.016,
                        cornerRadius: 0.016,
                        borderThickness: 0.002,
                        borderColor: "#FFDD56",
                    },
                    currency: {
                        width: 0.020,
                        height: 0.020,
                        left: 0.014,
                        get src() {
                            return Env.relativeCommonName("token_icon.svg");
                        },
                    },
                    tipsText: {
                        fontSize: Font.F24,
                        fontWeight: "500",
                        color: "#ECCB49",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.Clip,
                        width: 0.268,
                        left: 0.044,
                        padding: {
                            left: 0.000,
                            right: 0.000,
                            top: 0.008,
                            bottom: 0.006,
                        },
                    },
                    timeText: {
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "#8E8793",
                        resizeToFit: false,
                        horizontalAlignment: HorizontalAlignment.Right,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Right,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.Clip,
                        width: 0.400,
                        padding: {
                            right: 0.016,
                            bottom: 0.007,
                        },
                    },
                },
                userMessage: {
                    bubble: {
                        width: 0.400,
                        left: -0.016,
                        cornerRadius: 0.016,
                        background: "#1F2B3A",
                    },
                    messageText: {
                        fontSize: Font.F24,
                        fontWeight: "500",
                        color: "#A6C2F9",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.WordWrap,
                        width: 0.264,
                        padding: {
                            left: 0.016,
                            right: 0.016,
                            top: 0.008,
                            bottom: 0.008,
                        },
                    },
                    linkColor: "#2787FA",
                    messageStatus: {
                        width: 0.024,
                        height: 0.024,
                        left: 0.296,
                        top: -0.008, // (VerticalAlignment.Bottom)
                        get imgSent() { return Env.relativeMessengerName("message_sent.svg"); },
                        get imgRead() { return Env.relativeMessengerName("message_read.svg"); },
                    },
                    timeText: {
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "#8E8793",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Bottom,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textVerticalAlignment: VerticalAlignment.Bottom,
                        textWrapping: TextWrapping.Clip,
                        left: 0.328,
                        padding: {
                            bottom: 0.008,
                        },
                    },
                },
            },
            send: {
                width: 0.044,
                height: 0.044,
                horizontalAlignment: HorizontalAlignment.Right,
                verticalAlignment: VerticalAlignment.Bottom,
                padding: {
                    right: 0.004,
                    bottom: 0.004,
                },
                get normalImg() {
                    return Env.relativeBroadcastChatName("send_default.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastChatName("send_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastChatName("send_hover.svg");
                },
                get disabledImg() {
                    return Env.relativeBroadcastChatName("send_disabled.svg");
                },
            },
            input: {
                maxSymbols: 256,
                width: 0.556,
                left: 0.016,
                adaptHeightToChildren: true,
                horizontalAlignment: HorizontalAlignment.Left,
                contentPadding: { horizontal: 0.06, vertical: 0.012 },
                cursorLayout: {
                    width: 0.001,
                    height: 0.028,
                },
                backgroundLayout: { useArc: true, cornerRadius: 0.026 },
                states: [
                    {
                        state: "common",
                        style: {
                            isCursorEnabled: false,
                            textStyle: {
                                fontSize: Font.F24,
                                fontWeight: "500",
                                color: "white",
                                resizeToFit: true,
                                textWrapping: TextWrapping.WordWrap,
                                textHorizontalAlignment: HorizontalAlignment.Left,
                                horizontalAlignment: HorizontalAlignment.Left,
                                verticalAlignment: VerticalAlignment.Top,
                                textVerticalAlignment: VerticalAlignment.Top,
                            },
                            placeholderStyle: {
                                fontSize: Font.F24,
                                fontWeight: "500",
                                color: "#B8B0BC",
                                resizeToFit: true,
                                textHorizontalAlignment: HorizontalAlignment.Left,
                                horizontalAlignment: HorizontalAlignment.Left,
                                verticalAlignment: VerticalAlignment.Top,
                                textVerticalAlignment: VerticalAlignment.Top,
                            },
                            backgroundStyle: {
                                color: "#5A515E",
                                borderThickness: 0
                            },
                            cursorStyle: {
                                color: "white",
                                borderThickness: 0,
                            }
                        }
                    },
                    {
                        state: "focused",
                        style: {
                            isCursorEnabled: true,
                            backgroundStyle: {
                                color: "#7F7383",
                            }
                        }
                    },
                    {
                        state: "disabled",
                        style: {
                            isCursorEnabled: false,
                            placeholderStyle: {
                                color: "#544C56",
                            },
                            backgroundStyle: {
                                color: "#2A242D",
                            }
                        }
                    }
                ],
                maxLines: 8,
            },
            inactiveInputStub: {
                width: 0.556,
                paddingTop: 0.016,
                background: "rgba(90, 81, 94, 0.50)",
                cornerRadius: 0.026,
                separator: {
                    width: 0.556,
                    height: 0.001,
                    color: "#5F5862",
                },
                lockImg: {
                    width: 0.044,
                    height: 0.052,
                    paddingTop: 0.008, //44+8=52
                    left: 0.004,
                    top: -0.004,
                    get src() {
                        return Env.relativeMessengerName("lock.svg");
                    },
                },
                text: {
                    width: 0.556,
                    color: "rgba(255, 255, 255, 0.2)",
                    fontSize: Font.F24,
                    fontWeight: "500",
                    resizeToFit: true,
                    padding: {
                        left: 0.060,
                        right: 0.004,
                        top: 0.004,
                        bottom: 0.004,
                    },
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                },
            },
        },
        tips: {
            height: 0.076,
            separator: {
                width: 0.556,
                height: 0.001,
                color: "#5F5862",
            },
            valuesStackPanel: {
                top: 0.016,
                height: 0.052,
                spacing: 0.008,
            },
            customTip: {
                tipsKeyboard: {
                    width: 0.196,
                    height: 0.276,
                    // left: 0.384,
                    offset: 0.008,
                },
                input: {
                    maxLength: 9,
                    filter: /^\d*$/,
                    substitution: /[^\d]/g,
                    width: 0.316,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    contentPadding: { left: 0.016, right: 0.063, top: 0.014, bottom: 0.014 },
                    cursorLayout: {
                        width: 0.001,
                        height: 0.02,
                    },
                    backgroundLayout: { useArc: true, cornerRadius: 0.026 },
                    states: [
                        {
                            state: "common",
                            style: {
                                isCursorEnabled: false,
                                textStyle: {
                                    fontSize: Font.F20,
                                    fontWeight: "700",
                                    color: "white",
                                    resizeToFit: true,
                                    textWrapping: TextWrapping.WordWrap,
                                    textHorizontalAlignment: HorizontalAlignment.Left,
                                    horizontalAlignment: HorizontalAlignment.Left,
                                },
                                placeholderStyle: {
                                    fontSize: Font.F20,
                                    fontWeight: "700",
                                    color: "#B1A3B7",
                                    resizeToFit: true,
                                    textHorizontalAlignment: HorizontalAlignment.Left,
                                    horizontalAlignment: HorizontalAlignment.Left,
                                },
                                backgroundStyle: {
                                    color: "#5A515E",
                                    borderThickness: 0
                                },
                                cursorStyle: {
                                    color: "white",
                                    borderThickness: 0,
                                }
                            }
                        },
                        {
                            state: "focused",
                            style: {
                                isCursorEnabled: true,
                                backgroundStyle: {
                                    color: "#7F7383",
                                    borderThickness: 0
                                }
                            }
                        }
                    ],
                    maxLines: 1,
                },
            },
        },
        quickMessages: {
            height: 0.056,
            stackPanel: {
                height: 0.040,
                left: 0.016,
                spacing: 0.004,
            },
            item: {
                buttonLayout: {
                    cornerRadiusPx: 0.020,
                    useArc: true,
                    common: { borderThickness: 0.002, borderColor: "#5F5862" },
                    normalState: { color: "#241D26" },
                    hoverState: { color: "#3C353E" },
                    pressedState: { color: "#332E35" },
                },
                textLayout: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: true,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                    },
                    textWrapping: TextWrapping.Clip,
                },
            },
        },
    },
    messengerChatListPanel: {
        background: {
            width: 0.424,
            height: 0.904,
            cornerRadius: 0.032,
            get backgroundImage() { return Env.relativeMessengerName("messenger_chats_background.svg"); },
        },
        header: {
            background: "#36333C",
            height: 0.064,
            caption: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
            },
        },
        body: {
            height: 0.840,
            pinnedPanel: {
                height: 0.121,
                top: 0.064,
                model: {
                    top: 0.016,
                },
                separator: {
                    width: 0.393,
                    height: 0.001,
                    top: 0.112,
                    color: "#5F5862",
                },
            },
            chatList: {
                scrollView: {
                    fullHeight: 0.840,
                    shortHeight: 0.840 - 0.121,
                    colors: {
                        background: "transparent",
                        bar: "rgba(255, 255, 255, 0.20)",
                        hoverBar: "rgba(255, 255, 255, 0.10)",
                        pressedBar: "rgba(255, 255, 255, 0.06)",
                    },
                    verticalBar: {
                        size: 0.006,
                        padding: {
                            left: 0.008,
                            right: 0.008,
                            top: 0,
                            bottom: 0.024,
                        },
                    },
                    speed: 0.5,
                },
                stackPanel: {
                    topGapHeight: 0.016,
                    bottomGapHeight: 0.016,
                    spacing: 0.002,
                },
            },
        },
        item: {
            width: 0.393,
            height: 0.080,
            buttonLayout: {
                cornerRadiusPx: 0.016,
                normalState: { color: "transparent" },
                hoverState: { color: "#3C353E" },
                pressedState: { color: "#332E35" },
                disabledState: { color: "#36333C" },
            },
            avatar: {
                left: 0.016,
                photoStatusContainerHeight: 0.048,
                photo: {
                    diameter: 0.032,
                    left: 0.000,
                    top: 0.004,
                    outlineDiameter: 0.040,
                    outlineThickness: 0.002,
                },
                status: {
                    fontSize: Font.F8,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    padding: {
                        left: 0.002,
                        top: 0.002,
                        right: 0.002,
                        bottom: 0.002,
                    },
                    cornerRadius: 0.002,
                    resizeToFit: true,
                    background: {
                        away: "#564D5B",
                        live: "#0C9B56",
                        private: "#F18333",
                        offline: "#0000007F",
                        uninitialized: "#0000007F",
                    },
                },
            },
            unavailableAvatar: {
                width: 0.040,
                height: 0.040,
                left: 0.016,
                get src() { return Env.relativeMessengerName("unavailable_avatar.svg"); },
                letter: {
                    width: 0.040,
                    height: 0.040,
                    left: 0.016,
                    fontSize: Font.F20,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    resizeToFit: false,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    horizontalTextAlignment: HorizontalAlignment.Center,
                    verticalTextAlignment: VerticalAlignment.Center,
                },
            },
            topLine: {
                left: 0.072,
                top: 0.016,
                width: 0.336,
                height: 0.024,
                grid: {
                    rows: ["1*"],
                    columns: ["auto", "1*", "auto", "0.088m"],
                },
                star: {
                    width: 0.032,
                    height: 0.024,
                    paddingRight: 0.008,
                    get src() { return Env.relativeMessengerName("favorite_small_star.svg"); },
                },
                modelNickname: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "700",
                    resizeToFit: false,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Ellipsis,
                },
                statusIcon: {
                    width: 0.032,
                    height: 0.024,
                    paddingRight: 0.008,
                    get imgSent() { return Env.relativeMessengerName("message_sent.svg"); },
                    get imgRead() { return Env.relativeMessengerName("message_read.svg"); },
                    get imgUnread() { return Env.relativeMessengerName("message_unread.svg"); },
                },
                time: {
                    color: "#8E8793",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: false,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                },
            },
            status: {
                draft: {
                    color: "#F96060",
                },
                tips: {
                    color: "#ECCB49",
                },
                text: {
                    left: 0.072,
                    top: 0.040,
                    width: 0.304,
                    height: 0.024,
                    color: "#B8B0BC",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: false,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Ellipsis,
                },
            },
        },
    },
    messengerLinkWarningDialog: {
        width: 0.400,
        height: 0.418,
        background: {
            color: "#241D26",
            cornerRadius: 0.032,
            border: {
                thickness: 0.002,
                color: "#5F5862",
            },
        },
        closeButton: {
            width: 0.052,
            height: 0.052,
            left: -0.006,
            top: 0.006,
            imageLayout: {
                get normalImg() {
                    return Env.relativeBroadcastTipMenuName("message/close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastTipMenuName("message/close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastTipMenuName("message/close_pressed.svg");
                },
            }
        },
        warningImage: {
            width: 0.032,
            height: 0.032,
            top: 0.034,
            get src() { return Env.relativeMessengerName("link_warning.svg"); },
        },
        caption: {
            color: "#FFFFFF",
            fontSize: Font.F24,
            fontWeight: "700",
            resizeToFit: true,
            verticalAlignment: VerticalAlignment.Top,
            top: 0.092,
        },
        description: {
            color: "#B8B0BC",
            fontSize: Font.F20,
            fontWeight: "500",
            resizeToFit: true,
            verticalAlignment: VerticalAlignment.Top,
            textWrapping: TextWrapping.WordWrap,
            top: 0.136,
        },
        proceedButton: {
            width: 0.368,
            height: 0.052,
            top: 0.288,
            imageLayout: {
                cornerRadiusPx: 0.016,
                normalState: { color: "#2787FA" },
                hoverState: { color: "#6BAFFF" },
                pressedState: { color: "#499CFF" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" }
            },
        },
        cancelButton: {
            width: 0.368,
            height: 0.052,
            top: 0.350,
            imageLayout: {
                cornerRadiusPx: 0.016,
                normalState: { color: "#5A515E" },
                hoverState: { color: "#7F7383" },
                pressedState: { color: "#68606B" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" }
            },
        },
    },
    messengerConfig: {
        paramLimitChats: 999,
        avatarResolve: {
            retryAttempts: 5,
            retryDelayMs: 1000,
        },
    }
};
Env.lobby = {
    magentaPadding: 0.008,
    greenPadding: 0.016,
    redPadding: Env.redPadding,
    bluePadding: 0.064,
    panel: {
        center: { x: 0, y: Env.lobbyY - 0.02, z: Env.screenDistance },
        padding: {
            bottom: 0.05 + Env.redPadding * 2,
            top: 0.05 + Env.redPadding
        }
    },
    get environmentsUrl() {
        return Env.relativeEnvironmentName("environments.json");
    },
    messengerPanel: {
        position: { x: 0, y: Env.panel904_Y, z: Env.menuDistance },
    },
    messengerChatListPanel: {
        position: { x: -0.588 / 2 - 0.004 - 0.424 / 2, y: Env.panel904_Y, z: Env.menuDistance },
    },
    environmentDialog: {
        position: { x: 0, y: Env.panel904_Y, z: Env.menuDistance },
        background: {
            width: 0.588,
            height: 0.904,
            cornerRadius: 0.032,
            backgroundColor: "#241D26",
        },
        mainGrid: {
            rows: ["0.064m", "1*"],
            columns: ["1*"],
        },
        headerGrid: {
            rows: ["auto"],
            columns: ["1*", "auto"],
            background: "#36333C",
            height: 0.064,
        },
        header: {
            color: "#FFFFFF",
            fontSize: Font.F24,
            fontWeight: "700",
            resizeToFit: true,
            padding: {
                left: 0.058,
            },
        },
        close: {
            size: 0.052,
            padding: 0.006,
            get normalImg() {
                return Env.relativeLoginName("close_normal.svg");
            },
            get hoverImg() {
                return Env.relativeLoginName("close_hover.svg");
            },
            get pressedImg() {
                return Env.relativeLoginName("close_pressed.svg");
            },
        },
        scrollView: {
            colors: {
                background: "transparent",
                bar: "#FFFFFF33",
                hoverBar: "#FFFFFF33",
                pressedBar: "#FFFFFF33",
            },
            verticalBar: {
                padding: {
                    left: 0.008,
                    top: 0.008,
                    bottom: 0.024,
                    right: 0.008,
                },
                size: 0.008
            },
            speed: 2,
        },
        environmentItem: {
            width: 0.294,
            height: 0.330,
            outlineRectangle: {
                width: 0.254,
                height: 0.254,
                left0: 0.024,
                left1: 0.016,
                top: 0.024,
                cornerRadius: 0.008,
                activeThickness: 0.004,
                hoverColor: "#2787FA",
            },
            overlayActiveRectangle: {
                background: "rgba(26, 22, 28, 0.56)",
            },
            currentEnvironmentMark: {
                width: 0.064,
                height: 0.064,
                get img() {
                    return Env.relativeEnvironmentDialogName("current_environment.svg");
                },
            },
            loadableEnvironmentMark: {
                width: 0.064,
                height: 0.064,
                get img() {
                    return Env.relativeEnvironmentDialogName("loadable_environment.svg");
                },
            },
            loadingMark: {
                width: 0.064,
                height: 0.064,
                get img() {
                    return Env.relativeEnvironmentDialogName("loading.png");
                },
                periodMillis: 1000,
            },
            isNewMark: {
                width: 0.018,
                height: 0.018,
                top: 0.016,
                right: 0.012,
                get img() {
                    return Env.relativeCommonName("is_new_mark.svg");
                },
            },
            caption: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "500",
                resizeToFit: true,
                background: "black",
                horizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textWrapping: TextWrapping.Ellipsis,
                textVerticalAlignment: VerticalAlignment.Center,
                top: 0.294,
                left: 0.024,
                width: 0.254,
            },
        },
    },
    login: {
        // position: {x: 0, y: Env.loginY, z: Env.dialogsDistance - 0.01},
        position: { x: 0, y: Env.panel904_Y, z: Env.menuDistance },
        margin: 0.032,
        titleFontSize: Font.F36,
        labelFontSize: Font.F30,
        marginAfterLabel: 0.008,
        marginAfterErrorMessage: 0.038,
        marginAfterUsernameInput: 0.011,
        timeout: 10000,
        textColor: "white",
        errorMessage: {
            textColor: "#F02849",
            fontSize: Font.F24
        },
        // input: {
        //     height: 0.052,
        //     fontSize: Font.F30,
        //     get normalImg() {return Env.relativeLoginName("input_field_normal.svg");},
        //     get hoverImg() {return Env.relativeLoginName("input_field_hover.svg");},
        //     textPadding: 0.015
        // },
        background: {
            width: 0.588,
            height: 0.904,
            cornerRadius: 0.032,
            backgroundColor: "#241D26"
        },
        close: {
            size: 0.052,
            padding: 0.006,
            get normalImg() {
                return Env.relativeLoginName("close_normal.svg");
            },
            get hoverImg() {
                return Env.relativeLoginName("close_hover.svg");
            },
            get pressedImg() {
                return Env.relativeLoginName("close_pressed.svg");
            },
        },
        signUpSignInButton: {
            cornerRadiusPx: 0.016,
            width: 0.556,
            height: 0.08,
            padding: 0.016,
            normalState: {
                color: "#2787FA",
            },
            pressedState: {
                color: "#6BAFFF",
            },
            hoverState: {
                color: "#6BAFFF",
            },
            disabledState: {
                color: "#36333C",
            },
            text: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
                resizeToFit: true
            }
        },
        keyboard: {
            position: { x: 0, y: Env.panel904_Y, z: Env.dialogsDistance - 0.01 },
            angleInDegrees: 20
        },
        mainGrid: {
            rows: ["0.064m", "1*"],
            columns: ["1*"]
        },
        headerGrid: {
            rows: ["auto"],
            columns: ["auto", "1*", "auto"],
            background: "#36333C"
        },
        back: {
            size: 0.052,
            padding: 0.006,
            get normalImg() {
                return Env.relativeLoginName("back_normal.svg");
            },
            get hoverImg() {
                return Env.relativeLoginName("back_hover.svg");
            },
            get pressedImg() {
                return Env.relativeLoginName("back_pressed.svg");
            },
        },
        header: {
            color: "#FFFFFF",
            fontSize: Font.F24,
            fontWeight: "bold",
            resizeToFit: true,
        },
        modeSelector: {
            imageLayout: {
                cornerRadiusPx: 0,
                states: [
                    {
                        state: "common",
                        style: {
                            color: "#36333C",
                            borderThickness: { bottom: 0.003 },
                            borderColor: "#2787FA",
                        }
                    },
                    {
                        state: "normal",
                        style: {
                            borderThickness: 0,
                        }
                    }
                ]
            },
            textLayout: {
                states: [
                    {
                        state: "common",
                        style: {
                            color: "#B8B0BC",
                            fontSize: Font.F20,
                            fontWeight: "bold",
                            resizeToFit: true,
                            height: 0.064
                        }
                    },
                    {
                        state: "toggled",
                        style: {
                            color: "#FFFFFF",
                            fontSize: Font.F20,
                            fontWeight: "bold",
                            resizeToFit: true,
                            height: 0.064
                        }
                    },
                    {
                        state: "toggledHover",
                        style: {
                            color: "#FFFFFF",
                            fontSize: Font.F20,
                            fontWeight: "bold",
                            resizeToFit: true,
                            height: 0.064
                        }
                    },
                    {
                        state: "pressed",
                        style: {
                            color: "#FFFFFF",
                            fontSize: Font.F20,
                            fontWeight: "bold",
                            resizeToFit: true,
                            height: 0.064
                        }
                    }
                ],
                default: {
                    height: 0.064
                }
            }
        },
        signUpsignInPanel: {
            top: 0.08,
            spacing: 0.056,
            gridLayout: { rows: ["1*", "auto"], columns: ["1*"] }
        },
        input: {
            layout: {
                width: 0.46,
                height: 0.064,
                contentPadding: { left: 0.076 },
                cursorLayout: {
                    width: 0.002,
                    height: 0.028,
                },
                backgroundLayout: { useArc: true, cornerRadius: 0.016 },
                states: [
                    {
                        state: "common",
                        style: {
                            isCursorEnabled: false,
                            textStyle: {
                                color: "#FFFFFF",
                                fontSize: Font.F24,
                                fontWeight: "500",
                                resizeToFit: true,
                                horizontalAlignment: HorizontalAlignment.Left
                            },
                            placeholderStyle: {
                                color: "#B8B0BC",
                                fontSize: Font.F24,
                                fontWeight: "500",
                                resizeToFit: true,
                                horizontalAlignment: HorizontalAlignment.Left
                            },
                            backgroundStyle: {
                                color: "#36333C",
                                borderThickness: 0
                            },
                            cursorStyle: {
                                color: "white",
                                borderThickness: 0,
                            }
                        }
                    },
                    {
                        state: "focused",
                        style: {
                            isCursorEnabled: true,
                            backgroundStyle: {
                                color: "#1D3F67F0",
                                borderThickness: 0
                            }
                        }
                    },
                    {
                        state: "invalid",
                        style: {
                            backgroundStyle: {
                                color: "#6B3030F0",
                                borderThickness: 0
                            }
                        }
                    }
                ],
            },
            left: 0.064,
            backgroundColor: "#36333C",
            invalidBackgroundColor: "#6B3030F0",
            padding: {
                left: 0.076,
                top: 0.018,
                right: 0.012,
                bottom: 0.018,
                rightPassword: 0.076,
            },
            errorText: {
                color: "#F96060",
                fontSize: Font.F20,
                fontWeight: "700",
                height: 0.056,
                width: 0.46,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                textWrapping: TextWrapping.WordWrap
            },
            keyboardOffset: 0.008,
        },
        userAgreement: {
            width: 0.46,
            height: 0.16,
            spacing: 0.012,
            checkbox: {
                width: 0.048,
                height: 0.048,
                padding: {
                    left: 0.016,
                },
                get states() {
                    return [
                        {
                            state: "common",
                            style: Env.relativeLoginName("checkbox_off.svg"),
                        },
                        {
                            state: "normal",
                            style: Env.relativeLoginName("checkbox_off.svg"),
                        },
                        {
                            state: "hover",
                            style: Env.relativeLoginName("checkbox_off.svg"),
                        },
                        {
                            state: "pressed",
                            style: Env.relativeLoginName("checkbox_on.svg"),
                        },
                        {
                            state: "toggled",
                            style: Env.relativeLoginName("checkbox_on.svg"),
                        },
                        {
                            state: "toggledHover",
                            style: Env.relativeLoginName("checkbox_on.svg"),
                        },
                        {
                            state: "toggledPressed",
                            style: Env.relativeLoginName("checkbox_off.svg"),
                        },
                    ];
                }
            },
            text: {
                color: "#B8B0BC",
                fontSize: Font.F20,
                fontWeight: "500",
                resizeToFit: true,
                textHorizontalAlignment: HorizontalAlignment.Left,
            }
        },
        legalText: {
            color: "#B8B0BC",
            fontSize: Font.F20,
            fontWeight: "500",
            resizeToFit: true,
            textHorizontalAlignment: HorizontalAlignment.Left,
            textWrapping: TextWrapping.WordWrap,
        },
        legalTextContainer: {
            padding: 0.008,
            terms: {
                get image() {
                    return Env.relativeLoginName("terms.png");
                },
                width: 0.544,
                height: 8.870,
            },
            policy: {
                get image() {
                    return Env.relativeLoginName("policy.png");
                },
                width: 0.544,
                height: 5.766,
            },
            speed: 2
        },
        loader: {
            get logo() {
                return Env.relativeLoginName("loader.svg");
            },
            width: 0.144,
            height: 0.078,
            interval: 300,
            dot: {
                number: 3,
                activeColor: "#FFFFFF",
                inactiveColor: "#5A515E",
                diameter: 0.014,
                spacing: 0.015,
                padding: {
                    left: 0.036,
                    top: 0.019
                }
            }
        },
        icons: {
            width: 0.052,
            height: 0.052,
            padding: 0.012,
            get email() {
                return Env.relativeLoginName("email.svg");
            },
            get username() {
                return Env.relativeLoginName("username.svg");
            },
            get password() {
                return Env.relativeLoginName("password.svg");
            },
            get showPassword() {
                return Env.relativeLoginName("show_password.svg");
            },
            showPasswordButton: {
                useArc: true,
                cornerRadiusPx: 0.04,
                common: {
                    color: "#FFFFFF1A",
                },
                normalState: {
                    color: "transparent",
                }
            }
        },
        validationIcons: {
            width: 0.032,
            height: 0.032,
            padding: 0.012,
            get success() {
                return Env.relativeLoginName("validation_success.svg");
            },
            get fail() {
                return Env.relativeLoginName("validation_fail.svg");
            },
        },
        successScreen: {
            icon: {
                width: 0.144,
                height: 0.144,
                get image() {
                    return Env.relativeLoginName("auth_success.svg");
                }
            },
            textLayout: {
                fontSize: Font.F40,
                fontWeight: "700",
                color: "#FFFFFF",
                resizeToFit: true
            }
        },
        validationRules: {
            email: [
                (v) => /.*@.*\.\w+/.test(v),
                (v) => v.length <= 255,
                (v) => v.length > 0,
            ],
            username: [
                (v) => !/[^\w\d]/.test(v),
                (v) => v.length <= 255,
                (v) => v.length >= 4,
                (v) => v.length > 0,
            ],
            password: [
                (v) => [...v].reduce((a, c) => {
                    return a.includes(c) ? a : a + c;
                }, "").length >= 3,
                (v) => !/(.)\1{3,}/.test(v),
                (v) => /^[a-zA-Z\d\"\№\;\:\!\@\#\$\%\^\&\*\(\)\_\+\=\-\?\>\<\,\.\/]{5,255}$/i.test(v),
                (v) => !/\s/.test(v),
                (v) => v.length <= 255,
                (v) => v.length >= 5,
                (v) => v.length > 0,
            ],
            passwordContains: (v, i) => i.length === 0 || !v.includes(i),
        }
    },
    header: {
        height: 0.056 * 4,
        width: 0.464 * 4,
        logo: {
            get path() {
                return Env.relativeLobbyName("logo.svg");
            },
        },
        signIn: {
            imageLayout: {
                width: 0.196,
                cornerRadiusPx: 0.020,
                normalState: { color: "#00000001" },
                hoverState: { color: "#332936" },
                pressedState: { color: "#4D4052" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                hover: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                pressed: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                disabled: { color: "#B1A3B7", fontSize: Font.F28, fontWeight: "bold" }
            },
        },
        signUp: {
            imageLayout: {
                width: 0.196,
                cornerRadiusPx: 0.020,
                normalState: { color: "#2787FA" },
                hoverState: { color: "#13427A" },
                pressedState: { color: "#60A7FC" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                hover: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                pressed: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                disabled: { color: "#B1A3B7", fontSize: Font.F28, fontWeight: "bold" }
            },
        },
        topUp: {
            imageLayout: {
                width: 0.196,
                cornerRadiusPx: 0.020,
                normalState: { color: "#36A534" },
                hoverState: { color: "#07371A" },
                pressedState: { color: "#52BA7B" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                hover: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                pressed: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                disabled: { color: "#B1A3B7", fontSize: Font.F28, fontWeight: "bold" }
            },
        },
        profile: {
            button: {
                width: 0.096,
                get disabledImg() {
                    return Env.relativeLobbyName("profile_normal.svg");
                },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                disabled: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" }
            },
        },
        logout: {
            imageLayout: {
                width: 0.196,
                cornerRadiusPx: 0.020,
                normalState: { color: "#00000001" },
                hoverState: { color: "#332936" },
                pressedState: { color: "#4D4052" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                hover: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                pressed: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "bold" },
                disabled: { color: "#B1A3B7", fontSize: Font.F28, fontWeight: "bold" }
            },
        },
        balance: {
            width: 0.280,
            color: "white",
            fontSize: Font.F28,
        }
    },
    tabs: {
        height: 0.068,
        margin: {
            top: 0.052,
            bottom: 0.052,
        },
        live: {
            width: 0.521 + 0.012,
            allModels: {
                width: 0.248 + 0.012 + 0.012,
                get image() {
                    return Env.relativeLobbyName("tab_all_videos.svg");
                },
            },
            favorites: {
                width: 0.249 + 0.012,
                get image() {
                    return Env.relativeLobbyName("tab_favorites.svg");
                },
            },
        },
        videos: {
            width: 0.513,
            allVideos: {
                width: 0.237 + 0.012,
                get image() {
                    return Env.relativeLobbyName("tab_all_videos.svg");
                },
            },
            purchased: {
                width: 0.252 + 0.012,
                get image() {
                    return Env.relativeLobbyName("tab_purchased.svg");
                },
            },
        },
        tab: {
            // widthTabAllVideos: 0.249,
            // widthTabPurchased: 0.264,
            buttonLayout: {
                cornerRadiusPx: 0.034,
                useArc: true,
                padding: {
                    left: 0.006,
                    right: 0.006,
                },
                common: { color: "transparent", borderThickness: 0 },
                pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                toggledState: { color: "rgba(255, 255, 255, 0.16)" },
                toggledPressedState: { color: "rgba(255, 255, 255, 0.16)" },
                toggledHoverState: { color: "rgba(255, 255, 255, 0.32)" },
            },
            imageLayout: {
                width: 0.074,
                height: 0.068,
                padding: {
                    left: 0.014,
                    right: 0.008,
                    top: 0.008,
                    bottom: 0.008,
                },
                // get scrAllVideos() {
                //     return Env.relativeLobbyName("tab_all_videos.svg")
                // },
                // get scrPurchased() {
                //     return Env.relativeLobbyName("tab_purchased.svg")
                // },
            },
            fontStyle: {
                verticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
                horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
                textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
                left: 0.074,
                color: "#FFFFFF",
                resizeToFit: true,
                fontSize: Font.F32,
                fontWeight: "700",
            },
        },
    },
    gallery: {
        // columns: 4,
        // rows: 3,
        size: { columns: 4, rows: 3 },
        gapBetweenGalleryItems: 0.044,
        angularGapBetweenGalleryItems: 1.5,
        reloadIntervalMs: 30_000,
        center: { x: 0, y: Env.lobbyY, z: Env.cylinderDistance },
        focusedItemOffset: 0.05,
        galleryItem: {
            hiddenRightPadding: Env.galleryItemHiddenRightPadding,
            deltaX: Env.galleryItemHiddenRightPadding / 2,
            meshWidth: 0.528 + Env.galleryItemHiddenRightPadding,
            width: 0.528,
            height: 0.424,
            depth: 0.500,
            image: {
                cornerRadius: 0.016,
                width: 0.528,
                height: 0.320,
            },
            skeleton: {
                image: {
                    background: "#241D26",
                    cornerRadius: 0.016,
                    width: 0.528,
                    height: 0.320,
                    // get tempSrc() {
                    //     return Env.relativeLobbyName("temp.png");
                    // },
                },
                full: {
                    line1: {
                        width: 0.279,
                        height: 0.028,
                        left: 0.000,
                        top: 0.335,
                        background: "rgba(255, 255, 255, 0.08)",
                    },
                    line2: {
                        width: 0.497,
                        height: 0.020,
                        left: 0.000,
                        top: 0.382,
                        background: "rgba(255, 255, 255, 0.08)",
                    },
                },
            },
            live: {
                labels: {
                    top: 0.012,
                    left: 0.012,
                    status: {
                        icon: {
                            get image() {
                                return Env.relativeLobbyName("glasses.svg");
                            },
                            width: 0.036,
                            height: 0.036,
                            padding: {
                                left: 0.008,
                                top: 0,
                                bottom: 0,
                                right: 0,
                            },
                        },
                        customPadding: {
                            leftWithIcon: 0.008,
                            leftWithoutIcon: 0.012,
                        },
                        fontSize: Font.F20,
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        cornerRadius: 0.004,
                        resizeToFit: true,
                        padding: {
                            left: 0.012,
                            top: 0.005,
                            right: 0.012,
                            bottom: 0.005,
                        },
                        away: "#564D5B",
                        live: "#0C9B56",
                        private: "#F18333",
                        offline: "#0000007F",
                    },
                    mask: {
                        get image() {
                            return Env.relativeLobbyName("mask.svg");
                        },
                        width: 0.056,
                        height: 0.056,
                        left: 0.012,
                        top: 0.252
                    },
                    viewers: {
                        icon: {
                            get image() {
                                return Env.relativeLobbyName("viewers_icon.svg");
                            },
                            width: 0.024,
                            height: 0.024,
                            padding: {
                                left: 0.012
                            }
                        },
                        height: 0.036,
                        fontSize: Font.F20,
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        background: "#0000007F",
                        cornerRadius: 0.004,
                        paddingLeft: 0.008,
                        resizeToFit: true,
                        verticalAlignment: VerticalAlignment.Center,
                        textVerticalAlignment: VerticalAlignment.Center,
                        padding: {
                            left: 0.008,
                            top: 0.005,
                            right: 0.012,
                            bottom: 0.005,
                        },
                    },
                    spyNow: {
                        right: 0.012,
                        top: 0.012,
                        cornerRadius: 0.004,
                        height: 0.036,
                        background: "#8464DD",
                        icon: {
                            get image() {
                                return Env.relativeLobbyName("spy_now_icon.svg");
                            },
                            padding: {
                                left: 0.008,
                                right: 0.008,
                            },
                            width: 0.040,
                            height: 0.024,
                        },
                        text: {
                            fontSize: Font.F20,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            verticalAlignment: VerticalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.012,
                                right: 0.040,
                            },
                        },
                    },
                    resolution: {
                        left: 0.012,
                        top: 0.056,
                        cornerRadius: 0.004,
                        height: 0.036,
                        background: "#FF2C56",
                        text: {
                            fontSize: Font.F24,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            verticalAlignment: VerticalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.011,
                                right: 0.011,
                            },
                        },
                    },
                },
                text: {
                    full: {
                        name: {
                            top: 0.329,
                            width: 0.528 - 0.052,
                            color: "white",
                            fontSize: Font.F36,
                            fontWeight: "700",
                            textWrapping: TextWrapping.Ellipsis,
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Left,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            left: 0.000,
                            paddingRight: 0.024,
                        },
                        favoriteButton: {
                            colorLayout: {
                                left: 0.476,
                                top: 0.324,
                                horizontalAlignment: HorizontalAlignment.Left,
                                verticalAlignment: VerticalAlignment.Top,
                                width: 0.052,
                                height: 0.052,
                                useArc: true,
                                cornerRadiusPx: 0.026,
                                common: { borderThickness: 0 },
                                normalState: { color: "transparent" },
                                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                                pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                            },
                            children: {
                                width: 0.052,
                                height: 0.052,
                                get uncheckedImage() {
                                    return Env.relativeCommonName("favorite_off.svg");
                                },
                                get checkedImage() {
                                    return Env.relativeCommonName("favorite_on.svg");
                                },
                                get disabledImage() {
                                    return Env.relativeCommonName("favorite_disabled.svg");
                                },
                            },
                        },
                        info: {
                            top: 0.376,
                            height: 0.032,
                            fontSize: Font.F28,
                            fontWeight: "400",
                            color: "#FFFFFF",
                            textWrapping: TextWrapping.Ellipsis,
                            maxLines: 1,
                            horizontalAlignment: HorizontalAlignment.Left,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textVerticalAlignment: VerticalAlignment.Top,
                            padding: {
                                bottom: 0.004,
                            },
                        },
                    },
                    compact: {
                        gradient: {
                            width: 0.528,
                            height: 0.320,
                            get image() {
                                return Env.relativeLobbyName("thumbnail_gradient.svg");
                            },
                        },
                        modelLine: {
                            width: 0.504,
                            height: 0.052,
                            name: {
                                width: 0.428,
                                color: "white",
                                fontSize: Font.F36,
                                fontWeight: "700",
                                textWrapping: TextWrapping.Ellipsis,
                                resizeToFit: true,
                                horizontalAlignment: HorizontalAlignment.Left,
                                verticalAlignment: VerticalAlignment.Center,
                                textHorizontalAlignment: HorizontalAlignment.Left,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                            favoriteButton: {
                                colorLayout: {
                                    left: 0.452,
                                    top: 0.000,
                                    horizontalAlignment: HorizontalAlignment.Left,
                                    verticalAlignment: VerticalAlignment.Top,
                                    width: 0.052,
                                    height: 0.052,
                                    useArc: true,
                                    cornerRadiusPx: 0.026,
                                    common: { borderThickness: 0 },
                                    normalState: { color: "transparent" },
                                    hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                                    pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                                },
                                children: {
                                    width: 0.052,
                                    height: 0.052,
                                    get uncheckedImage() {
                                        return Env.relativeCommonName("favorite_off.svg");
                                    },
                                    get checkedImage() {
                                        return Env.relativeCommonName("favorite_on.svg");
                                    },
                                    get disabledImage() {
                                        return Env.relativeCommonName("favorite_disabled.svg");
                                    },
                                },
                                // width: 0.052,
                                // height: 0.052,
                                // left: 0.452,
                                // top: 0.000,
                            },
                        },
                        info: {
                            width: 0.504,
                            height: 0.064,
                            fontSize: Font.F28,
                            fontWeight: "400",
                            color: "rgba(255, 255, 255, 0.72)",
                            textWrapping: TextWrapping.WordWrapEllipsis,
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Top,
                        },
                    },
                },
            },
            video: {
                // Slightly bigger than galleryItem size.
                width: 0.530,
                height: 0.322,
                previewMeshYOffset: 0.052,
                cornerRadius: 0.016,
                title: {
                    color: "white",
                    fontSize: Font.F28,
                    fontWeight: "700",
                    textWrapping: TextWrapping.Ellipsis,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    left: 0.000,
                    top: 0.330,
                    padding: {
                        left: 0.012,
                    },
                },
                modelNickname: {
                    width: 0.528,
                    height: 0.034,
                    left: 0.000,
                    top: 0.376,
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        useArc: true,
                        normalState: { color: "transparent" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                        disabledState: { color: "transparent" },
                    },
                    textLayout: {
                        color: "white",
                        fontSize: Font.F28,
                        fontWeight: "400",
                        textWrapping: TextWrapping.Ellipsis,
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Center,
                        left: 0.000,
                        width: 0.528,
                        padding: {
                            left: 0.012,
                            right: 0.012,
                        },
                    },
                },
                labels: {
                    padding: 0.012,
                    spacing: 0.008,
                    purchased: {
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
                        verticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
                        height: 0.036,
                        top: 0.000,
                        left: 0.000,
                        background: "#2787FA",
                        cornerRadius: 0.004,
                        text: {
                            color: "white",
                            fontSize: Font.F20,
                            fontWeight: "700",
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Left,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.012,
                                right: 0.012,
                            },
                        },
                    },
                    free: {
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
                        verticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
                        height: 0.036,
                        top: 0.000,
                        left: 0.000,
                        background: "rgba(0, 0, 0, 0.50)",
                        cornerRadius: 0.004,
                        text: {
                            color: "white",
                            fontSize: Font.F20,
                            fontWeight: "700",
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Left,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.012,
                                right: 0.012,
                            },
                        },
                    },
                    duration: {
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_RIGHT,
                        verticalAlignment: Control.VERTICAL_ALIGNMENT_BOTTOM,
                        height: 0.036,
                        top: 0.000,
                        left: 0.000,
                        background: "rgba(0, 0, 0, 0.50)",
                        cornerRadius: 0.004,
                        text: {
                            color: "white",
                            fontSize: Font.F20,
                            fontWeight: "700",
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Right,
                            textHorizontalAlignment: HorizontalAlignment.Right,
                            verticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.012,
                                right: 0.012,
                            },
                        },
                    },
                },
                // bookmarkButton: {
                //     width: 0.052,
                //     height: 0.052,
                //     left: 0.476,
                //     top: 0.368,
                //     inactiveBookmarkLayout: {
                //         get normalImg() {return Env.relativeLobbyName("bookmark_inactive_normal.svg");},
                //         get hoverImg() {return Env.relativeLobbyName("bookmark_inactive_hover.svg");},
                //         get pressedImg() {return Env.relativeLobbyName("bookmark_inactive_pressed.svg");},
                //         get disabledImg() {return Env.relativeLobbyName("bookmark_inactive_normal.svg");},
                //         get pressedHoverImg() {return Env.relativeLobbyName("bookmark_inactive_pressed.svg");},
                //     },
                //     activeBookmarkLayout: {
                //         get normalImg() {return Env.relativeLobbyName("bookmark_active_normal.svg");},
                //         get hoverImg() {return Env.relativeLobbyName("bookmark_active_hover.svg");},
                //         get pressedImg() {return Env.relativeLobbyName("bookmark_active_pressed.svg");},
                //         get disabledImg() {return Env.relativeLobbyName("bookmark_active_normal.svg");},
                //         get pressedHoverImg() {return Env.relativeLobbyName("bookmark_active_pressed.svg");},
                //     },
                // },
            },
        },
        defaultPreview: {
            get path() {
                // return Env.relativeLobbyName("default_profile-photo.svg");
                // return Env.relativeLobbyName("default_profile-photo.jpg");
                return Env.relativeLobbyName("default_profile-photo.png");
            },
            get stubPath() {
                return Env.relativeLobbyName("skeleton_thumbnail.svg");
            },
            widthPx: Env.preview.widthPx,
            heightPx: Env.preview.heightPx
        }
    },
    footer: {
        //center: {x: 0, y: lobbyY - 0.6, z: screenDistance},
        meshY: -0.538,
        meshZ: Env.menuDistance,
        height: 0.052,
        width: 0.524,
        buttonWidth: 0.052,
        spacing: 0.004,
        pageButtonRange: 3,
        arrowButtonGap: 0.008,
        arrowBack: {
            get img() {
                return Env.relativeLobbyName("arrow_back_normal.svg");
            },
            layout: {
                cornerRadiusPx: 0.026,
                useArc: true,
                normalState: { color: "transparent" },
                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                pressedState: { color: "rgba(255, 255, 255, 0.24)" },
            },
        },
        arrowForward: {
            get img() {
                return Env.relativeLobbyName("arrow_forward_normal.svg");
            },
            layout: {
                cornerRadiusPx: 0.026,
                useArc: true,
                normalState: { color: "transparent" },
                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                pressedState: { color: "rgba(255, 255, 255, 0.24)" },
            },
        },
        pageButton: {
            layout: {
                cornerRadiusPx: 0.026,
                useArc: true,
                normalState: { color: "#00000001" },
                hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                pressedState: { color: "rgba(255, 255, 255, 0.24)" },
                toggledState: { color: "rgba(255, 255, 255, 0.16)" },
                toggledHoverState: { color: "rgba(255, 255, 255, 0.12)" },
            },
            text: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
            }
        },
    },
    userPanel2: {
        meshDistance: Env.menuDistance,
        meshY: Env.broadcastPanelY.user,
        width: 0.588,
        height: 0.084,
        // background: "#1A161CE0",
        background: "#241D26",
        cornerRadius: 0.032,
        signoutPanel: {
            width: 0.240,
            height: 0.076,
            offsetY: 0.004,
            background: "rgba(32, 27, 34, 0.96)",
            item: {
                leftPadding: 0.008,
                width: 0.228,
                height: 0.052,
                layout: {
                    cornerRadiusPx: 0.008,
                    common: { color: "#FFFFFF1A" },
                    normalState: { color: "transparent" },
                },
                image: {
                    width: 0.052,
                    height: 0.052,
                    get src() {
                        return Env.relativeCommonName("logout.svg");
                    },
                },
                text: {
                    fontSize: Font.F20,
                    fontWeight: "500",
                    color: "#FFFFFF",
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                    padding: {
                        left: 0.008,
                    },
                }
            },
        },
        gaps: {
            width8: 0.008,
            width16: 0.016,
        },
        guestPanel: {
            left: 0.016,
            top: 0,
            width: 0.137,
            height: 0.052,
        },
        clientPanel: {
            maxWidth: 0.209,
            height: 0.052,
            left: 0.016,
            top: 0.000,
        },
        getTokensButton: {
            width: 0.135,
            height: 0.052,
            colorLayout: {
                cornerRadiusPx: 0.016,
                common: { borderThickness: 0 },
                normalState: { color: "#0C9B56" },
                hoverState: { color: "#0A713F" },
                pressedState: { color: "#0B5E36" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                disabled: { color: "#B1A3B7", fontSize: Font.F20, fontWeight: "700" },
            },
        },
        separator: {
            width: 0.002,
            height: 0.052,
            cornerRadius: 0.001,
            color: "#5F5862",
        },
        environmentButton: {
            width: 0.052,
            height: 0.052,
            activeImageLayout: {
                get normalImg() {
                    return Env.relativeCommonName("active_environment_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeCommonName("active_environment_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeCommonName("inactive_environment_pressed.svg");
                },
            },
            inactiveImageLayout: {
                get normalImg() {
                    return Env.relativeCommonName("inactive_environment_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeCommonName("inactive_environment_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeCommonName("inactive_environment_pressed.svg");
                },
            },
        },
        helpButton: {
            width: 0.052,
            height: 0.052,
            activeImageLayout: {
                get normalImg() {
                    return Env.relativeCommonName("active_help_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeCommonName("active_help_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeCommonName("inactive_help_pressed.svg");
                },
            },
            inactiveImageLayout: {
                get normalImg() {
                    return Env.relativeCommonName("inactive_help_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeCommonName("inactive_help_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeCommonName("inactive_help_pressed.svg");
                },
            },
        },
        exitXrButton: {
            width: 0.052,
            height: 0.052,
            imageLayout: {
                get normalImg() {
                    return Env.relativeCommonName("exit_xr_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeCommonName("exit_xr_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeCommonName("exit_xr_pressed.svg");
                },
            },
        },
    },
    onboarding: {
        position: {
            x: 0,
            y: 0,
            z: 1.3,
            // z: 0.8,
        },
        rotation: 0,
        width: 0.588,
        height: 0.904,
        cornerRadius: 0.032,
        // backgroundColor: "#1A161CE0",
        backgroundColor: "#241D26",
        closeButton: {
            width: 0.052,
            height: 0.052,
            right: 0.006,
            top: 0.006,
            get normalImg() {
                return Env.relativeOnboardingName("close_normal.svg");
            },
            get hoverImg() {
                return Env.relativeOnboardingName("close_hover.svg");
            },
            get pressedImg() {
                return Env.relativeOnboardingName("close_pressed.svg");
            },
        },
        backButton: {
            width: 0.052,
            height: 0.052,
            left: 0.006,
            top: 0.006,
            get normalImg() {
                return Env.relativeOnboardingName("back_normal.svg");
            },
            get hoverImg() {
                return Env.relativeOnboardingName("back_hover.svg");
            },
            get pressedImg() {
                return Env.relativeOnboardingName("back_pressed.svg");
            },
        },
        blockScreen: {
            position: 1.35,
            // position: 1,
            width: 3,
            height: 2,
            background: "#00000000",
        },
        page: {
            fontSize: Font.F24,
            color: "#FFFFFF",
            top: 0.018,
            width: 0.436,
            height: 0.028,
            verticalAlignment: VerticalAlignment.Top,
            horizontalAlignment: HorizontalAlignment.Center,
            textHorizontalAlignment: HorizontalAlignment.Center,
            fontWeight: "700",
        },
        nextButton: {
            bottom: 0.016,
            width: 0.556,
            height: 0.08,
            imageLayout: {
                cornerRadiusPx: 0.016,
                normalState: { color: "#2787FA" },
                hoverState: { color: "#6BAFFF" },
                pressedState: { color: "#499CFF" },
            },
            textLayout: {
                common: { color: "#FFFFFF", fontSize: Font.F28, fontWeight: "700" },
                disabled: { color: "#B8B0BC", fontSize: Font.F28, fontWeight: "700" }
            }
        },
        firstSlide: {
            stackPanel: {
                top: 0.064,
                spacing: 0.032,
            },
            logo: {
                get image() {
                    return Env.relativeOnboardingName("logo.svg");
                },
                left: 0.064,
                width: 0.460,
                height: 0.248,
            },
            header: {
                fontSize: Font.F56,
                color: "#FFFFFF",
                left: 0.064,
                verticalAlignment: VerticalAlignment.Top,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                resizeToFit: true,
                fontWeight: "700",
            },
            text: {
                fontSize: Font.F28,
                color: "#FFFFFF",
                left: 0.064,
                top: 0.520,
                verticalAlignment: VerticalAlignment.Top,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                resizeToFit: true,
                fontWeight: "normal",
            },
        },
        slide: {
            text: {
                fontSize: Font.F36,
                color: "#FFFFFF",
                left: 0.064,
                top: 0.504,
                width: 0.460,
                height: 0.304,
                verticalAlignment: VerticalAlignment.Top,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                resizeToFit: false,
                fontWeight: "700"
            },
            image: {
                path(idx) {
                    return Env.relativeOnboardingName(`slide${idx}.jpg`);
                },
                left: 0.016,
                top: 0.104,
                width: 0.556,
                height: 0.400,
                radius: 0.016,
            },
        },
        lastSlide: {
            text: {
                fontSize: Font.F36,
                color: "#FFFFFF",
                left: 0.064,
                top: 0.504,
                width: 0.460,
                height: 0.304,
                verticalAlignment: VerticalAlignment.Top,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
                resizeToFit: false,
                fontWeight: "700"
            },
            image: {
                path(idx) {
                    return Env.relativeOnboardingName(`slide${idx}.jpg`);
                },
                left: 0.016,
                top: 0.104,
                width: 0.556,
                height: 0.400,
                radius: 0.016,
            },
            extraImages: [{
                    get path() {
                        return Env.relativeOnboardingName(`hearts.svg`);
                    },
                    left: 0.5,
                    top: 0.552,
                    width: 0.064,
                    height: 0.064,
                }]
        },
    },
    announcementStreamTypes: {
        slides: [
            {
                header: {
                    fontSize: Font.F24,
                    color: "#FFFFFF",
                    width: 0.472,
                    height: 0.052,
                    left: 0.058,
                    top: 0.006,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    fontWeight: "700",
                },
                image: {
                    get src() {
                        return Env.relativeAnnouncementName(`stream_types_announcement.jpg`);
                    },
                    left: 0.016,
                    top: 0.096,
                    width: 0.556,
                    height: 0.680,
                    radius: 0.016,
                },
            },
        ],
    },
    // announcementFavorites: {
    //     slides: [
    //         {
    //             header: {
    //                 fontSize: Font.F24,
    //                 color: "#FFFFFF",
    //                 width: 0.472,
    //                 height: 0.052,
    //                 left: 0.058,
    //                 top: 0.006,
    //                 verticalAlignment: VerticalAlignment.Top,
    //                 horizontalAlignment: HorizontalAlignment.Left,
    //                 textHorizontalAlignment: HorizontalAlignment.Center,
    //                 fontWeight: "700",
    //             },
    //             image: {
    //                 get src() {
    //                     return Env.relativeAnnouncementName(`favorites_announcement.jpg`);
    //                 },
    //                 left: 0.016,
    //                 top: 0.096,
    //                 width: 0.556,
    //                 height: 0.680,
    //                 radius: 0.016,
    //             },
    //         },
    //     ],
    // },
    announcementRelatedBroadcasts: {
        slides: [
            {
                header: {
                    fontSize: Font.F24,
                    color: "#FFFFFF",
                    width: 0.472,
                    height: 0.052,
                    left: 0.058,
                    top: 0.006,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    fontWeight: "700",
                },
                image: {
                    get src() {
                        return Env.relativeAnnouncementName(`related_broadcasts_announcement.jpg`);
                    },
                    left: 0.016,
                    top: 0.096,
                    width: 0.556,
                    height: 0.680,
                    radius: 0.016,
                },
            },
        ],
    },
    // announcementVod: {
    //     slides: [
    //         {
    //             header: {
    //                 fontSize: Font.F24,
    //                 color: "#FFFFFF",
    //                 width: 0.472,
    //                 height: 0.052,
    //                 left: 0.058,
    //                 top: 0.006,
    //                 verticalAlignment: VerticalAlignment.Top,
    //                 horizontalAlignment: HorizontalAlignment.Left,
    //                 textHorizontalAlignment: HorizontalAlignment.Center,
    //                 fontWeight: "700",
    //             },
    //             image: {
    //                 get src() {
    //                     return Env.relativeAnnouncementName(`vod_announcement.webp`);
    //                 },
    //                 left: 0.016,
    //                 top: 0.096,
    //                 width: 0.556,
    //                 height: 0.680,
    //                 radius: 0.016,
    //             },
    //         },
    //     ],
    // },
    // announcementMessenger: {
    //     slides: [
    //         {
    //             header: {
    //                 fontSize: Font.F24,
    //                 color: "#FFFFFF",
    //                 width: 0.472,
    //                 height: 0.052,
    //                 left: 0.058,
    //                 top: 0.006,
    //                 verticalAlignment: VerticalAlignment.Top,
    //                 horizontalAlignment: HorizontalAlignment.Left,
    //                 textHorizontalAlignment: HorizontalAlignment.Center,
    //                 fontWeight: "700",
    //             },
    //             image: {
    //                 get src() {
    //                     return Env.relativeAnnouncementName(`messenger_announcement.jpg`);
    //                 },
    //                 left: 0.016,
    //                 top: 0.096,
    //                 width: 0.556,
    //                 height: 0.680,
    //                 radius: 0.016,
    //             },
    //         },
    //     ],
    // },
    announcementPt: {
        slides: [
            {
                header: {
                    fontSize: Font.F24,
                    color: "#FFFFFF",
                    width: 0.472,
                    height: 0.052,
                    left: 0.058,
                    top: 0.006,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    fontWeight: "700",
                },
                image: {
                    get src() {
                        return Env.relativeAnnouncementName(`pt_announcement.webp`);
                    },
                    left: 0.016,
                    top: 0.096,
                    width: 0.556,
                    height: 0.680,
                    radius: 0.016,
                },
            },
        ],
    },
    upcomingEvents: {
        mesh: {
            panelPosition: { x: 0, y: Env.lobbyY, z: Env.cylinderDistance },
            headerPosition: { x: 0, y: Env.lobbyY, z: Env.cylinderDistance },
            rotationAnglePadding: 1.5,
            focusedOffset: -0.05,
        },
        // headerMesh: {
        //     height: 0.096,
        //     yOffset: 0.024,
        // },
        // header: {
        //     color: "#FFFFFF",
        //     fontSize: Font.F36,
        //     fontWeight: "700",
        //     horizontalAlignment: HorizontalAlignment.Center,
        //     verticalAlignment: VerticalAlignment.Center,
        //     resizeToFit: true,
        // },
        // headerHeight: 0.096,
        cornerRadius: 0.016,
        labelLive: {
            left: 0.016,
            top: 0.016,
            circle: {
                width: 0.032,
                height: 0.032,
                color: "#FF6347",
            },
            background: {
                cornerRadius: 0.004,
                color: "#0C9B56",
            },
            text: {
                horizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Center,
                fontSize: Font.F30,
                fontWeight: "bold",
                color: "#FFFFFF",
                cornerRadius: 0.004,
                resizeToFit: true,
                padding: {
                    left: 0.012,
                    top: 0.005,
                    right: 0.012,
                    bottom: 0.005,
                },
            },
        },
    },
    models: {
        mesh: {
            width: 0.718,
            panelPosition: { x: 0, y: Env.lobbyY, z: Env.cylinderDistance },
            rotationAnglePadding: 1.5,
        },
        backgroundPanel: {
            padding: 0.020,
            cornerRadius: 0.016,
            color: "#241D26",
        },
        header: {
            height: 0.106,
            horizontalAlignment: HorizontalAlignment.Center,
            verticalAlignment: VerticalAlignment.Top,
            textHorizontalAlignment: HorizontalAlignment.Center,
            textVerticalAlignment: VerticalAlignment.Center,
            fontSize: Font.F36,
            fontWeight: "700",
            color: "#FFFFFF",
            resizeToFit: true,
            padding: {
                top: 0.042,
                bottom: 0.022,
                left: 0.030,
                right: 0.030,
            },
        },
        itemsGroupMargin: {
            top: 0.032,
            bottom: 0.032,
        },
        item: {
            width: 0.718 - 0.020 - 0.020,
            height: 0.068,
            buttonLayout: {
                useArc: false,
                cornerRadiusPx: 0.016,
                states: [
                    { state: "common", style: { color: "transparent" } },
                    { state: "hover", style: { color: "rgba(255, 255, 255, 0.12)" } },
                    { state: "pressed", style: { color: "rgba(255, 255, 255, 0.06)" } },
                ]
            },
            gridLayout: {
                rows: ["1*"],
                columns: ["3*", "1*"]
            },
            modelNickname: {
                color: "#FFFFFF",
                fontSize: Font.F28,
                fontWeight: "400",
                horizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Center,
                horizontalTextAlignment: HorizontalAlignment.Left,
                padding: {
                    left: 0.024,
                    right: 0.008,
                },
                resizeToFit: true,
            },
            videosLabel: {
                color: "#FFFFFF",
                fontSize: Font.F28,
                fontWeight: "400",
                horizontalAlignment: HorizontalAlignment.Right,
                verticalAlignment: VerticalAlignment.Center,
                horizontalTextAlignment: HorizontalAlignment.Right,
                padding: {
                    left: 0.008,
                    right: 0.016,
                },
                resizeToFit: true,
            },
        },
        pagination: {
            left: 0.107,
            height: 0.096 + 0.020,
            spacing: 0.040,
            padding: {
                bottom: 0.020,
            },
            buttons: {
                width: 0.096,
                height: 0.096,
                first: {
                    get normalImg() {
                        return Env.relativeLobbyName("models_pagination_first_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeLobbyName("models_pagination_first_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeLobbyName("models_pagination_first_pressed.svg");
                    },
                },
                previous: {
                    get normalImg() {
                        return Env.relativeLobbyName("models_pagination_previous_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeLobbyName("models_pagination_previous_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeLobbyName("models_pagination_previous_pressed.svg");
                    },
                },
                next: {
                    get normalImg() {
                        return Env.relativeLobbyName("models_pagination_next_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeLobbyName("models_pagination_next_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeLobbyName("models_pagination_next_pressed.svg");
                    },
                },
                last: {
                    get normalImg() {
                        return Env.relativeLobbyName("models_pagination_last_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeLobbyName("models_pagination_last_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeLobbyName("models_pagination_last_pressed.svg");
                    },
                },
            },
        },
    },
    selectedModel: {
        backgroundPanel: {
            cornerRadius: 0.016,
            color: "#241D26",
        },
        modelNickname: {
            color: "#FFFFFF",
            fontSize: Font.F40,
            fontWeight: "700",
            horizontalAlignment: HorizontalAlignment.Center,
            verticalAlignment: VerticalAlignment.Top,
            top: 0.781,
            resizeToFit: true,
        },
        videoClipCount: {
            color: "#FFFFFF",
            fontSize: Font.F36,
            fontWeight: "400",
            horizontalAlignment: HorizontalAlignment.Center,
            verticalAlignment: VerticalAlignment.Top,
            top: 0.853,
            resizeToFit: true,
        },
        modelProfileComponent: {
            top: 0.176,
            photoStatusContainerHeight: 0.533,
            photo: {
                diameter: 0.480,
                outlineDiameter: 0.512,
                outlineThickness: 0.008,
            },
            status: {
                fontSize: Font.F40,
                fontWeight: "700",
                color: "#FFFFFF",
                padding: {
                    left: 0.012,
                    top: 0.006,
                    right: 0.012,
                    bottom: 0.006,
                },
                cornerRadius: 0.004,
                resizeToFit: true,
                background: {
                    away: "#564D5B",
                    live: "#0C9B56",
                    private: "#F18333",
                    offline: "#0000007F",
                },
            },
        },
        openLiveBroadcastButton: {
            top: 1.015,
            onlineWidth: 0.358,
            offlineWidth: 0.324,
            height: 0.096,
            colorLayout: {
                cornerRadiusPx: 0.016,
                common: { borderThickness: 0 },
                normalState: { color: "#2787FA" },
                hoverState: { color: "#6BAFFF" },
                pressedState: { color: "#499CFF" },
            },
            textLayout: {
                normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "700" },
                hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "700" },
                pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "700" },
                disabled: { color: "#B1A3B7", fontSize: Font.F36, fontWeight: "700" },
            }
        },
    },
    tagsPanel: {
        width: 0.718,
        mesh: {
            panelPosition: { x: 0, y: Env.lobbyY, z: Env.cylinderDistance },
            rotationAnglePadding: 1.3,
            background: "#241D26",
            cornerRadius: 0.016,
        },
        scrollView: {
            colors: {
                background: "transparent",
                bar: "#FFFFFF33",
                hoverBar: "#FFFFFF33",
                pressedBar: "#FFFFFF33",
                // background: "#FF000020",
                // bar: "#FFFFFFFF",
                // hoverBar: "#FF0000FF",
                // pressedBar: "#00FFFFFF",
            },
            verticalBar: {
                padding: {
                    left: 0.008,
                    top: 0.008,
                    bottom: 0.008,
                    right: 0.000,
                },
                size: 0.008
            },
            speed: 2
        },
        categoriesPanel: {
            width: 0.718 - 0.020 - 0.020,
            header: {
                fontSize: Font.F32,
                fontWeight: "700",
                color: "#FFFFFF",
                horizontalAlignment: HorizontalAlignment.Left,
                resizeToFit: true,
                padding: {
                    top: 0.032,
                    bottom: 0.012,
                },
            },
            tag: {
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F32,
                    fontWeight: "400",
                    height: 0.036,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    padding: {
                        left: 0.020,
                        right: 0.020,
                        top: 0.016,
                        bottom: 0.016,
                    },
                },
                layout: {
                    states: [
                        {
                            state: "common", style: {
                                color: "rgba(255, 255, 255, 0.08)",
                                paddingTopPx: 0.004,
                                paddingBottomPx: 0.004,
                                paddingLeftPx: 0.004,
                                paddingRightPx: 0.004,
                            }
                        },
                        { state: "hover", style: { color: "rgba(255, 255, 255, 0.3)" } },
                        { state: "pressed", style: { color: "#6BAFFF" } },
                        { state: "tagged", style: { color: "#2787FA" } },
                        { state: "disabled", style: { color: "#5A515E" } },
                    ],
                    cornerRadiusPx: 0.07,
                    useArc: true,
                },
                height: 0.068,
                margin: 0.008,
            },
            // tabs: {
            //     width: 0.718,
            //     height: 0.080,
            //     tab: {
            //         width: 0.180,
            //         buttonLayout: {
            //             width: 0.180,
            //             height: 0.080,
            //             common: {color: "transparent"},
            //             normalState: {
            //                 borderColor: "rgba(255, 255, 255, 0.2)",
            //                 borderThickness: {bottom: 0.004},
            //                 color: "transparent"
            //             },
            //             pressedState: {borderColor: "#2787FA", color: "rgba(255, 255, 255, 0.06)"},
            //             hoverState: {borderColor: "#2787FA", color: "rgba(255, 255, 255, 0.12)"},
            //             toggledState: {borderColor: "#2787FA", borderThickness: {bottom: 0.004}},
            //             toggledPressedState: {
            //                 borderColor: "#2787FA",
            //                 borderThickness: {bottom: 0.004},
            //                 color: "rgba(255, 255, 255, 0.06)"
            //             },
            //             toggledHoverState: {
            //                 borderColor: "#2787FA",
            //                 borderThickness: {bottom: 0.004},
            //                 color: "rgba(255, 255, 255, 0.12)"
            //             },
            //         },
            //         fontStyle: {
            //             horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
            //             textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
            //             width: 0.180,
            //             height: 0.080,
            //             color: "#FFFFFF",
            //             resizeToFit: false,
            //             fontSize: 0.032,
            //             fontWeight: "700",
            //         },
            //     },
            // },
        },
        selectedTagsPanel: {
            height: 0.148,
            padding: {
                top: 0.032,
                bottom: 0.040,
            },
            background: "transparent",
            tag: {
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F32,
                    fontWeight: "400",
                    height: 0.036,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    padding: {
                        left: 0.02,
                        right: 0.002,
                        top: 0.016,
                        bottom: 0.016,
                    },
                },
                layout: {
                    states: [
                        {
                            state: "common", style: {
                                color: "#2787FA",
                                paddingTopPx: 0.004,
                                paddingBottomPx: 0.004,
                                paddingLeftPx: 0.004,
                                paddingRightPx: 0.004,
                            }
                        },
                        { state: "hover", style: { color: "#6BAFFF" } },
                        { state: "pressed", style: { color: "#2787FA" } },
                        { state: "untagged", style: { color: "rgba(255, 255, 255, 0.08)" } },
                    ],
                    cornerRadiusPx: 0.07,
                    useArc: true,
                },
                removeTagIcon: {
                    height: 0.052,
                    width: 0.052,
                    paddingRight: 0.008,
                    get url() {
                        return Env.relativeLobbyName("remove_tag.svg");
                    },
                },
                height: 0.068,
                margin: 0.008,
            },
        },
        unselectedTagsPanel: {
            header: {
                fontSize: Font.F32,
                fontWeight: "700",
                color: "#FFFFFF",
                horizontalAlignment: HorizontalAlignment.Left,
                resizeToFit: true,
                padding: {
                    top: 0.04,
                    bottom: 0.012,
                },
            },
            tag: {
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F32,
                    fontWeight: "400",
                    height: 0.036,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    padding: {
                        left: 0.020,
                        right: 0.020,
                        top: 0.016,
                        bottom: 0.016,
                    },
                },
                layout: {
                    states: [
                        {
                            state: "common", style: {
                                color: "rgba(255, 255, 255, 0.08)",
                                paddingTopPx: 0.004,
                                paddingBottomPx: 0.004,
                                paddingLeftPx: 0.004,
                                paddingRightPx: 0.004,
                            }
                        },
                        { state: "hover", style: { color: "rgba(255, 255, 255, 0.3)" } },
                        { state: "pressed", style: { color: "#6BAFFF" } },
                        { state: "tagged", style: { color: "#2787FA" } },
                        { state: "disabled", style: { color: "#5A515E" } },
                    ],
                    cornerRadiusPx: 0.07,
                    useArc: true,
                },
                clearAllLayout: {
                    states: [
                        {
                            state: "common", style: {
                                color: "transparent",
                                paddingTopPx: 0.004,
                                paddingBottomPx: 0.004,
                                paddingLeftPx: 0.004,
                                paddingRightPx: 0.004,
                            }
                        },
                        { state: "hover", style: { color: "rgba(255, 255, 255, 0.3)" } },
                        { state: "pressed", style: { color: "rgba(255, 255, 255, 0.08)" } },
                    ],
                    cornerRadiusPx: 0.07,
                    useArc: true,
                },
                height: 0.068,
                margin: 0.008,
            },
        },
        // unselectedTagsPanel: {
        //     header: {
        //         fontSize: Font.F32,
        //         fontWeight: "700",
        //         color: "#FFFFFF",
        //         horizontalAlignment: HorizontalAlignment.Left,
        //         resizeToFit: true,
        //         padding: {
        //             top: 0.04,
        //             bottom: 0.012,
        //         },
        //     },
        //     tag: {
        //         text: {
        //             color: "#FFFFFF",
        //             // fontSize: Font.F32,
        //             fontSize: Font.F20,
        //             // fontWeight: "400",
        //             fontWeight: "500",
        //             // height: 0.036,
        //             height: 0.024,
        //             resizeToFit: true,
        //             horizontalAlignment: HorizontalAlignment.Left,
        //             horizontalTextAlignment: HorizontalAlignment.Left,
        //             padding: {
        //                 // left: 0.020,
        //                 // right: 0.020,
        //                 // top: 0.016,
        //                 // bottom: 0.016,
        //                 left: 0.012,
        //                 right: 0.012,
        //                 top: 0.008,
        //                 bottom: 0.008,
        //             },
        //         },
        //         layout: {
        //             states: [
        //                 {
        //                     state: "common", style: {
        //                         color: "rgba(255, 255, 255, 0.08)",
        //                         paddingTopPx: 0.004,
        //                         paddingBottomPx: 0.004,
        //                         paddingLeftPx: 0.004,
        //                         paddingRightPx: 0.004,
        //                     }
        //                 },
        //                 {state: "hover", style: {color: "rgba(255, 255, 255, 0.3)"}},
        //                 {state: "pressed", style: {color: "#6BAFFF"}},
        //                 {state: "tagged", style: {color: "#2787FA"}},
        //                 {state: "disabled", style: {color: "#5A515E"}},
        //             ],
        //             // cornerRadiusPx: 0.07,
        //             cornerRadiusPx: 0.020,
        //             useArc: true,
        //         },
        //         clearAllLayout: {
        //             states: [
        //                 {
        //                     state: "common", style: {
        //                         color: "transparent",
        //                         paddingTopPx: 0.004,
        //                         paddingBottomPx: 0.004,
        //                         paddingLeftPx: 0.004,
        //                         paddingRightPx: 0.004,
        //                     }
        //                 },
        //                 {state: "hover", style: {color: "rgba(255, 255, 255, 0.3)"}},
        //                 {state: "pressed", style: {color: "rgba(255, 255, 255, 0.08)"}},
        //             ],
        //             cornerRadiusPx: 0.07,
        //             useArc: true,
        //         },
        //         // height: 0.068,
        //         height: 0.040,
        //         margin: 0.008,
        //     },
        // },
        noTagsPanel: {
            width: 0.560,
            height: 0.552,
            image: {
                get url() {
                    return Env.relativeLobbyName("no_tags.svg");
                },
                width: 0.120,
                height: 0.120 + 0.092 + 0.032,
                padding: {
                    top: 0.092,
                    bottom: 0.032,
                },
            },
            description: {
                color: "#FFFFFF",
                fontSize: Font.F32,
                fontWeight: "700",
                width: 0.560,
                height: 0.080,
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                horizontalTextAlignment: HorizontalAlignment.Center,
            },
            clearTagGroupsButton: {
                width: 0.291,
                height: 0.056 + 0.080 + 0.092,
                padding: {
                    top: 0.056,
                    bottom: 0.092,
                },
                rectangleLayout: {
                    cornerRadiusPx: 0.016,
                    common: { borderThickness: 0 },
                    normalState: { color: "#2787FA" },
                    hoverState: { color: "#6BAFFF" },
                    pressedState: { color: "#499CFF" },
                },
                caption: {
                    color: "#FFFFFF",
                    fontSize: Font.F28,
                    fontWeight: "700",
                    // width: 0.560,
                    // height: 0.080,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    horizontalTextAlignment: HorizontalAlignment.Center,
                    verticalTextAlignment: VerticalAlignment.Center,
                },
            },
        },
        lobbyMode: {
            tabs: {
                width: 0.678,
                height: 0.096,
                top: 0.020,
                background: {
                    color: "rgba(255, 255, 255, 0.08)",
                    cornerRadius: 0.016,
                },
                images: {
                    width: 0.052,
                    height: 0.052,
                    get liveImg() { return Env.relativeLobbyName("lobby_mode_tab_live.svg"); },
                    get videosImg() { return Env.relativeLobbyName("lobby_mode_tab_videos.svg"); },
                },
                tab: {
                    width: 0.339,
                    buttonLayout: {
                        width: 0.339,
                        height: 0.096,
                        cornerRadiusPx: 0.016,
                        common: { color: "transparent", borderThickness: 0 },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        toggledState: { color: "rgba(39, 135, 250, 1)" },
                        toggledPressedState: { color: "rgba(39, 135, 250, 1)" },
                        toggledHoverState: { color: "rgba(39, 135, 250, 1)" },
                    },
                    fontStyle: {
                        verticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
                        textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
                        height: 0.096,
                        color: "#FFFFFF",
                        resizeToFit: true,
                        fontSize: 0.036,
                        fontWeight: "700",
                        padding: {
                            left: 0.010,
                        },
                    },
                    states: [
                        {
                            state: "common",
                            // style: {color: "rgba(255, 255, 255, 0.72)"},
                            style: { color: "white" },
                        },
                        {
                            state: "pressed",
                            // style: {color: "rgba(255, 255, 255, 0.72)"},
                            style: { color: "white" },
                        },
                        {
                            state: "hover",
                            // style: {color: "rgba(255, 255, 255, 0.72)"},
                            style: { color: "white" },
                        },
                        {
                            state: "toggled",
                            style: { color: "white" },
                        },
                        {
                            state: "toggledPressed",
                            style: { color: "white" },
                        },
                        {
                            state: "toggledHover",
                            style: { color: "white" },
                        },
                    ],
                },
            },
        },
        liveTags: {
            padding: {
                left: 0.020,
                right: 0.020,
                gap: 0.032,
            },
        },
        videoTags: {
            padding: {
                left: 0.020,
                right: 0.020,
                gap: 0.032,
            },
            header: {
                fontSize: Font.F32,
                fontWeight: "700",
                color: "#FFFFFF",
                horizontalAlignment: HorizontalAlignment.Left,
                resizeToFit: true,
                padding: {
                    bottom: 0.012,
                },
            },
        },
        purchases: {
            banner: {
                width: 0.678,
                height: 1.200,
                top: 0.024,
                get src() {
                    return Env.relativeLobbyName("purchased_videos_banner.webp");
                },
            },
            // description: {
            //     width: 0.678,
            //     height: 0.058,
            //     top: 0.3865,
            //     fontSize: Font.F48,
            //     fontWeight: "700",
            //     color: "#FFFFFF",
            //     horizontalAlignment: HorizontalAlignment.Center,
            //     verticalAlignment: VerticalAlignment.Top,
            //     textHorizontalAlignment: HorizontalAlignment.Center,
            //     textVerticalAlignment: VerticalAlignment.Center,
            //     resizeToFit: true,
            // },
        },
    },
};
Env._menuDragAndDrop = {
    width: 0.19,
    height: 0.04,
    gap: 0.004,
    distance: Env.menuDistance,
    indicatorWidth: 0.16,
    indicatorHeight: 0.01,
    margin: 0.008,
    cornerRadius: 0.03,
    states: [
        {
            state: "common", style: {
                color: "rgba(255, 255, 255, 0.56)",
                borderThickness: 0
            }
        },
        {
            state: "pressed", style: {
                color: "#FFFFFF",
            }
        },
        {
            state: "hover", style: {
                color: "#FFFFFF",
            }
        },
    ],
    // dragBackground: "#241D2666",
    dragBackground: "#241D26A0",
    dragCornerRadius: 0.032,
};
Env.broadcast = {
    projectionMeshScale: 10,
    backupPicture: {
        position: { x: 0, y: Env.broadcastY, z: 2 },
        width: Env.backupPictureWidth,
        height: Env.backupPictureHeight,
        blur: 50,
        darkFilterColor: "#00000080",
        // textPanel: {
        //     width: 0.6,
        //     height: 0.2,
        //     bottomMargin: 0.05,
        //     fontSize: Font.F48,
        //     fontColor: "#FFFFFF",
        //     margin: 0.044,
        //     backgroundColor: "#1A161CE0",
        //     cornerRadius: 0.032
        // },
        modelNickname: {
            fontSize: Font.F40,
            fontWeight: "700",
            color: "#FFFFFF",
            padding: {
                bottom: 0.016,
            },
            resizeToFit: true,
        },
        streamTime: {
            fontSize: Font.F36,
            fontWeight: "400",
            color: "#B8B0BC",
            padding: {
                bottom: 0.016,
            },
            resizeToFit: true,
        },
        profilePhotoVerticalGap: 0.016,
        profilePhoto: {
            photoStatusContainerHeight: 0.528,
            photo: {
                diameter: 0.480,
                outlineDiameter: 0.512,
                outlineThickness: 0.008,
            },
            status: {
                fontSize: Font.F40,
                fontWeight: "700",
                color: "#FFFFFF",
                padding: {
                    left: 0.012,
                    top: 0.006,
                    right: 0.012,
                    bottom: 0.006,
                },
                cornerRadius: 0.004,
                resizeToFit: true,
                background: {
                    away: "#564D5B",
                    live: "#0C9B56",
                    private: "#F18333",
                    offline: "#343434",
                },
            },
        },
        infoLine1: {
            fontSize: Font.F36,
            fontWeight: "700",
            color: "#FFFFFF",
            padding: {
                top: 0.016,
            },
            resizeToFit: true,
        },
        infoLine2: {
            fontSize: Font.F36,
            fontWeight: "700",
            color: "#FFFFFF",
            padding: {
                top: 0.016,
            },
            resizeToFit: true,
        },
        infoLine3: {
            fontSize: Font.F36,
            fontWeight: "400",
            color: "#B8B0BC",
            padding: {
                top: 0.016,
            },
            resizeToFit: true,
        },
        startSpyShowButton: {
            rectangleLayout: {
                width: 0.253,
                height: 0.094,
                padding: {
                    top: 0.032,
                },
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                cornerRadiusPx: 0.016,
                common: { borderThickness: 0 },
                normalState: { color: "#8464DD" },
                hoverState: { color: "#6549B1" },
                pressedState: { color: "#523998" },
            },
            textLayout: {
                common: {
                    fontSize: Font.F36,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    textWrapping: TextWrapping.Clip,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                },
            },
        },
        leaveRoomButton: {
            rectangleLayout: {
                width: 0.349,
                height: 0.096,
                padding: {
                    top: 0.032,
                },
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                cornerRadiusPx: 0.016,
                common: { borderThickness: 0 },
                normalState: { color: "#2787FA" },
                hoverState: { color: "#6BAFFF" },
                pressedState: { color: "#499CFF" },
            },
            textLayout: {
                common: {
                    fontSize: Font.F36,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    textWrapping: TextWrapping.Clip,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                },
            },
        },
        gapUnderButton: 0.072 - 0.016,
        relatedBroadcasts: {
            height: 0.320 + 0.016 * 2,
            unselectedPadding: 0.016,
            spacing: 0.048 - 0.016 * 2,
        },
    },
    animation: {
        coins: {
            get sceneUrl() {
                return Env.relativeAnimationsCoinsName("coins.glb");
            },
            get soundUrl() {
                return Env.relativeAnimationsCoinsName("coins2.mp3", false);
            },
        },
        hearts: {
            hearts3: {
                get sceneUrl() {
                    return Env.relativeAnimationsHeartsName("hearts3.glb");
                },
            },
            hearts5: {
                get sceneUrl() {
                    return Env.relativeAnimationsHeartsName("hearts5.glb");
                },
            },
            hearts8: {
                get sceneUrl() {
                    return Env.relativeAnimationsHeartsName("hearts8.glb");
                },
            },
        },
    },
    menu: {
        backgroundColor: "#241D26",
        cornerRadius: 0.032,
        position: {
            center: { x: 0, y: Env.broadcastY, z: Env.menuDistance },
            sidePanelCenter: { x: 0, y: Env.broadcastY + 0.044, z: Env.menuDistance },
            leftPositionAngle: -45,
            rightPositionAngle: 45
        },
        defaultRotationAngle: 45,
        keyboard: {
            // position: { x: 0, y: Env.broadcastY - 0.65, z: Env.menuDistance },    // (with BroadcastMenuMode panel)
            // position: {x: 0, y: Env.broadcastY - 0.547, z: Env.menuDistance},        // (without BroadcastMenuMode panel)
            position: { x: 0, y: Env.panel904_Y - 0.904 / 2 - 0.004 - 0.084 - 0.004 - Env.keyboardHeight / 2, z: Env.menuDistance },
            angleInDegrees: 30
        },
        width: Env.broadcastMenuWidth,
        // height: 0.876,
        height: 0.904,
        gapBetweenPanels: 0.004,
        navigation: {
            verticalOffset: Env.broadcastPanelY.navigation,
            height: 0.084,
            leftButtonGroup: {
                left: 0.016,
                spacing: 0.008,
                soundButton: {
                    width: 0.052,
                    height: 0.052,
                    enabledImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("unmuted_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("unmuted_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("unmuted_pressed.svg");
                        }
                    },
                    disabledImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("muted_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("muted_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("muted_pressed.svg");
                        }
                    }
                },
                streamsButton: {
                    width: 0.052,
                    height: 0.052,
                    imageLayout2D: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("status_2d_outline.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("status_2d_outline_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("status_2d_outline_pressed.svg");
                        },
                    },
                    imageLayout3D: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_outline.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_outline_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_outline_pressed.svg");
                        },
                    },
                    imageLayout3D6K: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_6k_outline.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_6k_outline_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("status_vr_6k_outline_pressed.svg");
                        },
                    },
                },
                subtitlesButton: {
                    width: 0.052,
                    height: 0.052,
                    get normalImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_off.svg");
                    },
                    get disabledImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_off.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_off_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_off_pressed.svg");
                    },
                    get toggledImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_on.svg");
                    },
                    get toggledDisabledImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_on.svg");
                    },
                    get toggledHoverImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_on_hover.svg");
                    },
                    get toggledPressedImg() {
                        return Env.relativeBroadcastNavigationName("subtitles_on_pressed.svg");
                    },
                },
                passthroughButton: {
                    width: 0.052,
                    height: 0.052,
                    get normalImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_normal.svg");
                    },
                    get disabledImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_disabled.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_pressed.svg");
                    },
                    get toggledImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_toggled.svg");
                    },
                    get toggledDisabledImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_toggled_disabled.svg");
                    },
                    get toggledHoverImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_toggled_hover.svg");
                    },
                    get toggledPressedImg() {
                        return Env.relativeBroadcastNavigationName("passthrough_toggled_pressed.svg");
                    }
                }
            },
            rightButtonGroup: {
                right: 0.016,
                spacing: 0.008,
                lobbyButton: {
                    width: 0.052,
                    height: 0.052,
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("home_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("home_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("home_pressed.svg");
                        }
                    },
                },
                relatedButton: {
                    width: 0.052,
                    height: 0.052,
                    enabledImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("related_active_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("related_active_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("related_active_pressed.svg");
                        }
                    },
                    disabledImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("related_inactive_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("related_inactive_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("related_inactive_pressed.svg");
                        }
                    }
                },
                previousBroadcastButton: {
                    width: 0.052,
                    height: 0.052,
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("prev_broadcast_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("prev_broadcast_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("prev_broadcast_pressed.svg");
                        }
                    },
                },
                nextBroadcastButton: {
                    width: 0.052,
                    height: 0.052,
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastNavigationName("next_broadcast_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastNavigationName("next_broadcast_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastNavigationName("next_broadcast_pressed.svg");
                        }
                    },
                },
            },
            submenus: {
                volume: {
                    width: 0.224,
                    height: 0.088,
                    offsetLeft: -(0.588 - 0.224) / 2,
                    offsetTop: (0.084 + 0.088) / 2 + 0.004,
                    caption: {
                        color: "#FFFFFF",
                        fontSize: Font.F20,
                        fontWeight: "500",
                        verticalAlignment: VerticalAlignment.Top,
                        verticalTextAlignment: VerticalAlignment.Top,
                        resizeToFit: true,
                        padding: {
                            top: 0.016,
                        },
                    },
                    soundLevel: {
                        left: 0.024,
                        top: 0.052,
                        width: 0.176,
                        height: 0.012,
                        get backgroundImage() {
                            return Env.relativeBroadcastNavigationName("volume_indicator_bg.png");
                        },
                        get foregroundImage() {
                            return Env.relativeBroadcastNavigationName("volume_indicator_fg.png");
                        },
                        foregroundColor: "#ffffff"
                    },
                },
                streams: {
                    width: 0.240,
                    height: 0.120,
                    offsetLeft: (0.240 - 0.588) / 2,
                    offsetTop: (0.084 + 0.120) / 2 + 0.004,
                    item: {
                        colorLayout: {
                            width: 0.240,
                            height: 0.052,
                            common: { borderThickness: 0 },
                            normalState: { color: "#00000000" },
                            hoverState: { color: "#FFFFFF1F" },
                            pressedState: { color: "#FFFFFF0F" },
                        },
                        checkbox: {
                            width: 0.052,
                            height: 0.052,
                            left: 0.016,
                            top: 0.000,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            get image() {
                                return Env.relativeBroadcastNavigationName("checkbox.svg");
                            },
                        },
                        text: {
                            textLayout: {
                                left: 0.076,
                                states: [
                                    {
                                        state: "common",
                                        style: {
                                            fontSize: Font.F20,
                                            fontWeight: "500",
                                            color: "#FFFFFF",
                                            resizeToFit: true,
                                            textWrapping: TextWrapping.Ellipsis,
                                            horizontalAlignment: HorizontalAlignment.Left,
                                            verticalAlignment: VerticalAlignment.Center,
                                            textHorizontalAlignment: HorizontalAlignment.Left,
                                            textVerticalAlignment: VerticalAlignment.Center,
                                        }
                                    },
                                    {
                                        state: "disabled",
                                        style: { color: "#5F5862" }
                                    },
                                ]
                            },
                        },
                    },
                },
            },
        },
        subtitles: {
            verticalOffset: Env.broadcastPanelY.subtitles,
            distance: 0.6,
            pitchInDegrees: 30,
            width: 0.488,
            height: 0.100,
            cornerRadius: 0.032,
            background: "#241D26",
            grid: { rows: ["1*"], columns: ["1*"] },
            gridControl: {
                horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
                verticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
                clipChildren: false,
                isHitTestVisible: true,
                adaptWidthToChildren: true,
                adaptHeightToChildren: true,
            },
            text: {
                style: {
                    textWrapping: TextWrapping.WordWrapEllipsis,
                    fontFamily: Env.fontFamily,
                    color: "#F5F6F8",
                    fontSize: 0.020,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    maxLines: 3,
                    padding: { top: 0.013, right: 0.049, bottom: 0.013, left: 0.013 },
                }
            },
            placeholder: {
                text: "Live captions",
                style: {
                    textWrapping: TextWrapping.WordWrap,
                    fontFamily: Env.fontFamily,
                    color: "#A69EAC",
                    fontSize: 0.020,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                    padding: { top: 0.013, right: 0.049, bottom: 0.013, left: 0.013 },
                },
            },
            closeButton: {
                width: 0.032,
                height: 0.032,
                top: 0.004,
                right: 0.012,
                get normalImg() {
                    return Env.relativeBroadcastChatName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastChatName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastChatName("close_pressed.svg");
                },
            },
            languagePill: {
                width: 0.032,
                height: 0.032,
                offsetBelowClose: 0.010,
                button: {
                    cornerRadiusPx: 72,
                    common: { borderThickness: 0 },
                    normalState: { color: "#241D26" },
                    hoverState: { color: "#FFFFFF29" },
                    pressedState: { color: "#FFFFFF29" },
                },
            },
            languageLabel: {
                style: {
                    fontFamily: Env.fontFamily,
                    color: "#FFFFFF",
                    fontSize: 0.016,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                }
            },
            languageList: {
                width: 0.200,
                height: 0.180,
                cornerRadius: 0.020,
                background: "#1F1723",
                spacing: 0,
                padding: { left: 0.000, right: 0.000, top: 0.000, bottom: 0.000 },
                offset: { left: 0.020, top: 0.000 },
                row: {
                    width: 0.172,
                    height: 0.042,
                    cornerRadius: 0,
                    background: "transparent",
                    hoverBackground: "#FFFFFF29",
                    selectedBackground: "#FFFFFF",
                    color: "#F5F6F8",
                    selectedColor: "#1F1723",
                    fontSize: 0.018,
                    padding: { left: 0.018, right: 0.018 },
                    get checkIcon() {
                        return Env.relativeBroadcastNavigationName("checkbox.svg");
                    },
                    textStyle: {
                        fontFamily: Env.fontFamily,
                        color: "#F5F6F8",
                        fontSize: 0.018,
                        resizeToFit: true,
                        verticalAlignment: VerticalAlignment.Center,
                        horizontalAlignment: HorizontalAlignment.Left,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                    },
                },
            },
            handle: {
                indicatorWidth: 0.16,
                indicatorHeight: 0.008,
                width: 0.19,
                height: 0.04,
                cornerRadius: 0.03,
                color: "#C3C0C6",
                states: [
                    { state: "normal", style: { color: "#C3C0C6", borderThickness: 0 } },
                    { state: "hover", style: { color: "#FFFFFF", borderThickness: 0 } },
                    { state: "pressed", style: { color: "#FFFFFF", borderThickness: 0 } },
                ],
            },
        },
        model: {
            verticalOffset: Env.broadcastPanelY.model,
            height: 0.192,
            header: {
                height: 0.112,
                profileButton: {
                    colorLayout: {
                        left: 0.016,
                        top: 0.016,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        width: 0.460,
                        height: 0.080,
                        cornerRadiusPx: 0.016,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "#3C353E" },
                        pressedState: { color: "#332E35" },
                        toggledState: { color: "#332E35" },
                    },
                    children: {
                        avatar: {
                            width: 0.064,
                            height: 0.064,
                            left: 0.008,
                            top: 0.008,
                            imageDiameter: 0.052,
                            states: {
                                offline: {
                                    color: "transparent",
                                    imageDiameter: 0.064,
                                },
                                online: {
                                    color: "#0C9B56",
                                    imageDiameter: 0.052,
                                },
                                private: {
                                    color: "#F18333",
                                    imageDiameter: 0.052,
                                },
                                spy: {
                                    color: "#8464DD",
                                    imageDiameter: 0.052,
                                },
                                away: {
                                    color: "#564D5B",
                                    imageDiameter: 0.052,
                                },
                            },
                        },
                        modelNickname: {
                            fontSize: Font.F28,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            width: 0.372,
                            height: 0.032,
                            left: 0.088,
                            top: 0.010,
                            resizeToFit: true,
                            textWrapping: TextWrapping.Ellipsis,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                        hintLine: {
                            fontSize: Font.F20,
                            fontWeight: "500",
                            color: "#FFFFFF",
                            width: 0.372,
                            height: 0.024,
                            left: 0.088,
                            top: 0.045,
                            resizeToFit: true,
                            textWrapping: TextWrapping.Ellipsis,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
                favoriteButton: {
                    colorLayout: {
                        left: 0.492,
                        top: 0.016,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        width: 0.080,
                        height: 0.080,
                        cornerRadiusPx: 0.016,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "#3C353E" },
                        pressedState: { color: "#332E35" },
                    },
                    children: {
                        width: 0.052,
                        height: 0.052,
                        get uncheckedImage() {
                            return Env.relativeCommonName("favorite_off.svg");
                        },
                        get checkedImage() {
                            return Env.relativeCommonName("favorite_on.svg");
                        },
                        get disabledImage() {
                            return Env.relativeCommonName("favorite_disabled.svg");
                        },
                    },
                },
            },
            body: {
                height: 0.080,
                canStartPrivateShow: {
                    startPrivateShowButton: {
                        rectangleLayout: {
                            width: 0.556,
                            height: 0.064,
                            left: 0.016,
                            top: 0.000,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            cornerRadiusPx: 0.016,
                            common: { borderThickness: 0 },
                            normalState: { color: "#F18333" },
                            hoverState: { color: "#B85D1B" },
                            pressedState: { color: "#994C15" },
                        },
                        textLayout: {
                            common: {
                                fontSize: Font.F22,
                                fontWeight: "700",
                                color: "#FFFFFF",
                                width: 0.556,
                                height: 0.064,
                                textWrapping: TextWrapping.Ellipsis,
                                textHorizontalAlignment: HorizontalAlignment.Center,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                        },
                    },
                },
                canCancelPrivateShowRequest: {
                    cancelPrivateShowRequestButton: {
                        rectangleLayout: {
                            width: 0.556,
                            height: 0.064,
                            left: 0.016,
                            top: 0.000,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            cornerRadiusPx: 0.016,
                            common: { borderThickness: 0 },
                            normalState: { color: "#5A515E" },
                            hoverState: { color: "#7F7383" },
                            pressedState: { color: "#68606B" },
                        },
                        textLayout: {
                            common: {
                                fontSize: Font.F22,
                                fontWeight: "700",
                                color: "#FFFFFF",
                                width: 0.556,
                                height: 0.064,
                                textWrapping: TextWrapping.Ellipsis,
                                textHorizontalAlignment: HorizontalAlignment.Center,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                        },
                    },
                },
                canStopPrivateShow: {
                    stopPrivateShowButton: {
                        rectangleLayout: {
                            width: 0.556,
                            height: 0.064,
                            left: 0.016,
                            top: 0.000,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            cornerRadiusPx: 0.016,
                            common: { borderThickness: 0 },
                            normalState: { color: "#5A515E" },
                            hoverState: { color: "#7F7383" },
                            pressedState: { color: "#68606B" },
                        },
                        textLayout: {
                            common: {
                                fontSize: Font.F22,
                                fontWeight: "700",
                                color: "#FFFFFF",
                                width: 0.556,
                                height: 0.064,
                                textWrapping: TextWrapping.Ellipsis,
                                textHorizontalAlignment: HorizontalAlignment.Center,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                        },
                    },
                },
                canStartSpyShow: {
                    info: {
                        width: 0.556,
                        height: 0.064,
                        left: 0.016,
                        top: 0.000,
                        cornerRadius: 0.016,
                        background: "#36333C",
                        text: {
                            fontSize: Font.F20,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            width: 0.206,
                            height: 0.064,
                            left: 0.016,
                            textWrapping: TextWrapping.WordWrap,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                        price: {
                            fontSize: Font.F24,
                            fontWeight: "500",
                            color: "#FFFFFF",
                            width: 0.091,
                            height: 0.064,
                            left: 0.016 + 0.206,
                            textWrapping: TextWrapping.WordWrap,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Right,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                        currency: {
                            width: 0.020,
                            height: 0.020,
                            left: 0.319,
                            top: 0.022,
                            get src() {
                                return Env.relativeCommonName("token_icon.svg");
                            },
                        },
                        priceDescription: {
                            fontSize: Font.F18,
                            fontWeight: "500",
                            color: "#B8B0BC",
                            width: 0.052,
                            height: 0.064,
                            left: 0.349,
                            textWrapping: TextWrapping.Clip,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                        startSpyShowButton: {
                            rectangleLayout: {
                                width: 0.144,
                                height: 0.064,
                                left: 0.412,
                                top: 0.000,
                                horizontalAlignment: HorizontalAlignment.Left,
                                verticalAlignment: VerticalAlignment.Top,
                                cornerRadiusPx: 0.016,
                                common: { borderThickness: 0 },
                                normalState: { color: "#8464DD" },
                                hoverState: { color: "#6549B1" },
                                pressedState: { color: "#523998" },
                            },
                            textLayout: {
                                common: {
                                    fontSize: Font.F22,
                                    fontWeight: "700",
                                    color: "#FFFFFF",
                                    width: 0.144,
                                    height: 0.064,
                                    textWrapping: TextWrapping.Clip,
                                    textHorizontalAlignment: HorizontalAlignment.Center,
                                    textVerticalAlignment: VerticalAlignment.Center,
                                },
                            },
                        },
                    },
                },
                canStopSpyShow: {
                    stopSpyShowButton: {
                        rectangleLayout: {
                            width: 0.556,
                            height: 0.064,
                            left: 0.016,
                            top: 0.000,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            cornerRadiusPx: 0.016,
                            common: { borderThickness: 0 },
                            normalState: { color: "#5A515E" },
                            hoverState: { color: "#7F7383" },
                            pressedState: { color: "#68606B" },
                        },
                        textLayout: {
                            common: {
                                fontSize: Font.F22,
                                fontWeight: "700",
                                color: "#FFFFFF",
                                width: 0.556,
                                height: 0.064,
                                textWrapping: TextWrapping.Ellipsis,
                                textHorizontalAlignment: HorizontalAlignment.Center,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                        },
                    },
                },
            },
            messageDialogPrv: {
                width: 0.360,
                height: 0.180,
            },
        },
        tipMenu: {
            width: 0.424,
            height: 0.904,
            header: {
                height: 0.128,
                background: "#36333C",
                caption: {
                    width: 0.232,
                    height: 0.028,
                    top: 0.018,
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    textWrapping: TextWrapping.Ellipsis,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                },
                closeButton: {
                    width: 0.064,
                    height: 0.064,
                    padding: {
                        left: 0.006,
                        right: 0.006,
                        top: 0.006,
                        bottom: 0.006
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipMenuName("close_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipMenuName("close_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipMenuName("close_pressed.svg");
                        },
                    }
                },
                tabs: {
                    width: 0.384,
                    height: 0.876 - 0.032,
                    top: 0.064,
                    buttonLayout: {
                        common: { color: "transparent" },
                        normalState: { color: "transparent", borderColor: "transparent", borderThickness: { bottom: 0 } },
                        pressedState: { borderColor: "#2787FA", color: "#FFFFFF10" },
                        hoverState: { borderColor: "#2787FA", color: "#FFFFFF1F" },
                        toggledState: { borderColor: "#2787FA", borderThickness: { bottom: 0.003 } },
                        toggledPressedState: { borderColor: "#2787FA", color: "#FFFFFF10" },
                        toggledHoverState: {
                            borderColor: "#2787FA",
                            borderThickness: { bottom: 0.003 },
                            color: "#FFFFFF1F"
                        },
                    },
                    selectedTabFontStyle: {
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
                        height: 0.064,
                        color: "#FFFFFF",
                        resizeToFit: true,
                        fontSize: 0.020,
                        fontWeight: "700",
                    },
                    unselectedTabFontStyle: {
                        horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
                        height: 0.064,
                        color: "#B8B0BC",
                        resizeToFit: true,
                        fontSize: 0.020,
                        fontWeight: "700",
                    },
                },
            },
            toggleRow: {
                height: 0.04,
                padding: {
                    top: 0.072,
                    left: 0.032,
                    right: 0.032,
                },
                grid: { columns: ["0.5*", "0.5*"], rows: ["1*"] },
                buttonActivities: {
                    cornerRadiusPx: 0.016,
                    common: { color: "#00000000", paddingRightPx: 0.004 },
                    pressedState: { borderColor: "#8D6DE8", borderThickness: 0.003 },
                    toggledHoverState: { borderColor: "#8D6DE8", borderThickness: 0.003 },
                    hoverState: { borderColor: "#4D4052", borderThickness: 0.003 },
                },
                buttonToys: {
                    cornerRadiusPx: 0.016,
                    common: { color: "#00000000", paddingLeftPx: 0.004 },
                    pressedState: { borderColor: "#8D6DE8", borderThickness: 0.003 },
                    toggledHoverState: { borderColor: "#8D6DE8", borderThickness: 0.003 },
                    hoverState: { borderColor: "#4D4052", borderThickness: 0.003 },
                },
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "bold",
                }
            },
            tipMenuHeader: {
                descriptionColumnHeader: {
                    width: 0.192,
                    height: 0.02,
                    color: "#B1A3B7",
                    fontSize: Font.F14,
                    fontWeight: "",
                    padding: {
                        left: 0.032,
                        right: 0.000,
                        top: 0.0,
                        bottom: 0.004
                    }
                },
                tokensColumnHeader: {
                    width: 0.192,
                    height: 0.02,
                    color: "#B1A3B7",
                    fontSize: Font.F14,
                    fontWeight: "",
                    padding: {
                        left: 0.000,
                        right: 0.032,
                        top: 0,
                        bottom: 0.004
                    }
                },
            },
            toysMenuHeader: {
                vibrationColumnHeader: {
                    width: 0.192,
                    height: 0.02,
                    color: "#B1A3B7",
                    fontSize: Font.F14,
                    fontWeight: "",
                    padding: {
                        left: 0.032,
                        right: 0.000,
                        top: 0,
                        bottom: 0.004
                    }
                },
                durationColumnHeader: {
                    width: 0.304,
                    height: 0.02,
                    color: "#B1A3B7",
                    fontSize: Font.F14,
                    fontWeight: "",
                    padding: {
                        left: 0.208,
                        right: 0.000,
                        top: 0,
                        bottom: 0.004
                    }
                },
                tokensColumnHeader: {
                    width: 0.096,
                    height: 0.02,
                    color: "#B1A3B7",
                    fontSize: Font.F14,
                    fontWeight: "",
                    padding: {
                        left: 0.000,
                        right: 0.032,
                        top: 0,
                        bottom: 0.004
                    }
                },
            },
            scrollView: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.008,
                        top: 0.008,
                        bottom: 0.032
                    },
                },
                speed: 1
            },
            emptyRow: {
                height: 0.024,
            },
            item: {
                defaultHeight: 0.048,
                color: {
                    normal: "#FFFFFF00",
                    publicHover: "#FFFFFF1A",
                    publicPressed: "#FFFFFF1A",
                    privateHover: "#FFFFFF1A",
                    privatePressed: "#FFFFFF1A",
                },
                description: {
                    color: {
                        normal: "#FFFFFF",
                        publicHover: "#FFFFFF",
                        privateHover: "#FFFFFF"
                    },
                    fontSize: Font.F20,
                    fontWeight: "700",
                    top: 0.012,
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    },
                },
                price: {
                    height: 0.024,
                    color: {
                        normal: "#FFFFFF",
                        publicHover: "#FFFFFF",
                        privateHover: "#FFFFFF"
                    },
                    fontSize: Font.F20,
                    fontWeight: "500",
                    top: 0.012,
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                currency: {
                    width: 0.024,
                    height: 0.024,
                    top: 0.012,
                    get image() {
                        return Env.relativeCommonName("token_icon.svg");
                    },
                },
                lock: {
                    width: 0.024,
                    height: 0.024,
                    top: 0.012,
                    images: {
                        get lockedNormal() {
                            return Env.relativeBroadcastTipMenuName("tiplock_locked_normal.svg");
                        },
                        // get lockedHover() {return Env.relativeBroadcastTipMenuName("tiplock_locked_hover.svg");},
                        get unlockedNormal() {
                            return Env.relativeBroadcastTipMenuName("tiplock_unlocked_normal.svg");
                        },
                        // get unlockedHover() {return Env.relativeBroadcastTipMenuName("tiplock_unlocked_hover.svg");},
                    }
                },
                gaps: {
                    gap1: 0.024,
                    gap2: 0.008,
                    gap3: 0.008,
                    gap4: 0.008,
                    gap5: 0.024,
                }
            },
            toysMenuItem: {
                height: 0.048,
                buttonLayout: {
                    useArc: false,
                    states: [
                        { state: "common", style: { color: "transparent" } },
                        { state: "hover", style: { color: "#3C353E" } },
                        { state: "pressed", style: { color: "#332E35" } },
                    ]
                },
                gridLayout: {
                    rows: ["1*"],
                    columns: ["32*", "138*", "56*", "74*", "38*", "36*"]
                },
                padding: {
                    left: 0.024,
                    right: 0.024,
                },
                icon: {
                    width: 0.032,
                    height: 0.032,
                    images: {
                        get low() {
                            return Env.relativeBroadcastTipMenuName("toys_low.svg");
                        },
                        get high() {
                            return Env.relativeBroadcastTipMenuName("toys_high.svg");
                        },
                        get medium() {
                            return Env.relativeBroadcastTipMenuName("toys_medium.svg");
                        },
                        get ultrahigh() {
                            return Env.relativeBroadcastTipMenuName("toys_ultrahigh.svg");
                        },
                        get wave() {
                            return Env.relativeBroadcastTipMenuName("toys_wave.svg");
                        },
                        get pulse() {
                            return Env.relativeBroadcastTipMenuName("toys_pulse.svg");
                        },
                        get fireworks() {
                            return Env.relativeBroadcastTipMenuName("toys_fireworks.svg");
                        },
                        get earthquake() {
                            return Env.relativeBroadcastTipMenuName("toys_earthquake.svg");
                        },
                        get random() {
                            return Env.relativeBroadcastTipMenuName("toys_random.svg");
                        },
                        get randomtime() {
                            return Env.relativeBroadcastTipMenuName("toys_random.svg");
                        },
                        get clear() {
                            return Env.relativeBroadcastTipMenuName("toys_clear.svg");
                        },
                        get pause() {
                            return Env.relativeBroadcastTipMenuName("toys_pause.svg");
                        },
                    },
                    getToysMenuItemIcon(mode, vibration) {
                        const i = Env.broadcast.menu.tipMenu.toysMenuItem.icon.images;
                        if (mode === "basic") {
                            const v = Number.parseInt(vibration);
                            if (v <= 5)
                                return i.low;
                            else if (v <= 10)
                                return i.medium;
                            else if (v <= 15)
                                return i.high;
                            else
                                return i.ultrahigh;
                        }
                        if (vibration in i)
                            return i[vibration];
                        return "";
                    }
                },
                vibration: {
                    colors: {
                        low: "#B1A3B7",
                        medium: "#AF80FF",
                        high: "#FF74B7",
                        ultraHigh: "#FF5F5F",
                        special: "#58CE95",
                        default: "#FFFFFF",
                    },
                    getToysMenuItemColor(vibration) {
                        const c = Env.broadcast.menu.tipMenu.toysMenuItem.vibration.colors;
                        if (/\d{1,2}/.test(vibration)) {
                            const v = Number.parseInt(vibration);
                            if (v <= 5)
                                return c.low;
                            else if (v <= 10)
                                return c.medium;
                            else if (v <= 15)
                                return c.high;
                            else
                                return c.ultraHigh;
                        }
                        // if (mode === "special")
                        return c.special;
                        // return c.default;
                    },
                    fontSize: Font.F20,
                    fontWeight: "700",
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left
                },
                duration: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Right,
                    textHorizontalAlignment: HorizontalAlignment.Right
                },
                price: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Right,
                    textHorizontalAlignment: HorizontalAlignment.Right,
                    resizeToFit: true,
                    textWrapping: TextWrapping.Clip,
                    padding: {
                    // left: 0.004,
                    }
                },
                priceContainer: {
                    width: 0.066,
                    overtravel: 0.005,
                    speed: 0.05
                },
                currency: {
                    width: 0.024,
                    height: 0.024,
                    top: 0.012,
                    get image() {
                        return Env.relativeCommonName("token_icon.svg");
                    },
                },
                downArrow: {
                    width: 0.024,
                    height: 0.024,
                    top: 0.012,
                    get image() {
                        return Env.relativeBroadcastTipMenuName("down_arrow.svg");
                    },
                    get flippedImage() {
                        return Env.relativeBroadcastTipMenuName("up_arrow.svg");
                    },
                },
                dropdown: {
                    mesh: {
                        width: 0.392,
                        height: 0.072
                    },
                    slider: {
                        layout: {
                            cornerRadiusPx: 0.056,
                            useArc: true,
                            borderColor: "#5F5862",
                            borderThickness: 0.002,
                            backgroundColor: "#36333C",
                        },
                        minusButton: {
                            width: 0.052,
                            height: 0.052,
                            get normalImg() {
                                return Env.relativeBroadcastTipMenuName("minus_normal.svg");
                            },
                            get hoverImg() {
                                return Env.relativeBroadcastTipMenuName("minus_hover.svg");
                            },
                            get pressedImg() {
                                return Env.relativeBroadcastTipMenuName("minus_pressed.svg");
                            },
                        },
                        plusButton: {
                            width: 0.052,
                            height: 0.052,
                            get normalImg() {
                                return Env.relativeBroadcastTipMenuName("plus_normal.svg");
                            },
                            get hoverImg() {
                                return Env.relativeBroadcastTipMenuName("plus_hover.svg");
                            },
                            get pressedImg() {
                                return Env.relativeBroadcastTipMenuName("plus_pressed.svg");
                            },
                        },
                        slider: {
                            background: "#5F5862",
                            color: "#2787FA",
                            thumbColor: "#FFFFFF",
                            width: 0.252,
                            height: 0.028,
                            barOffset: 0.011,
                            cornerRadius: 0.0025,
                        },
                        spacing: 0.008,
                    },
                    button: {
                        layout: {
                            useArc: true,
                            cornerRadiusPx: 0.04,
                            padding: 0.004,
                            states: [
                                { state: "common", style: { color: "#36333C" } },
                                { state: "hover", style: { color: "#5A515E" } },
                                { state: "toggled", style: { color: "#7F7383" } },
                                { state: "toggledHover", style: { color: "#7F7383" } },
                                { state: "toggledPressed", style: { color: "#68606B" } },
                            ]
                        },
                        spacing: 0.008,
                        padding: {
                            left: 0.016,
                            right: 0.008
                        },
                    },
                    maxValue: 9999999,
                    leaveTimeout: 1200
                }
            },
            message: {
                width: 0.360,
                height: 0.180,
                heightShort: 0.237,
                heightTall: 0.312,
                z: -0.04,
                backgroundColor: "#36333C",
                borderColor: "#5F5862",
                borderThickness: 0.002,
                selectorImageLayout: {
                    get normalImg() {
                        return Env.relativeBroadcastTipMenuName("message/private_mode_normal.svg");
                    },
                    get selectedImg() {
                        return Env.relativeBroadcastTipMenuName("message/private_mode_selected.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastTipMenuName("message/private_mode_hover.svg");
                    }
                },
                selectorPadding: {
                    left: 0.016,
                    right: 0.016,
                    bottom: 0.016
                },
                selectorElementPadding: {},
                selectorElementLayout: {
                    line1: {
                        color: "#E6E6E6",
                        fontSize: Font.F18,
                        fontWeight: "700",
                        padding: {
                            left: 0.016,
                            top: 0.012
                        }
                    },
                    line2: {
                        color: "#B3B3B3",
                        fontSize: Font.F18,
                        fontWeight: "700",
                        padding: {
                            left: 0.016,
                            bottom: 0.012
                        }
                    },
                    line3: {
                        color: "#E6E6E6",
                        fontSize: Font.F18,
                        fontWeight: "700",
                        padding: {
                            right: 0.016
                        }
                    },
                },
                selectorElementHeight: 0.067,
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    textWrapping: TextWrapping.WordWrapEllipsis,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true
                },
                closeButton: {
                    width: 0.058,
                    height: 0.058,
                    padding: {
                        left: 0,
                        right: 0.006,
                        top: 0.006,
                        bottom: 0
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_pressed.svg");
                        },
                    }
                },
                actionButton: {
                    left: 0,
                    top: 0.110,
                    width: 0.360,
                    height: 0.070,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                        top: 0.002,
                        bottom: 0.016
                    },
                    signIn: {
                        imageLayout: {
                            cornerRadiusPx: 0.016,
                            normalState: { color: "#2787FA" },
                            hoverState: { color: "#6BAFFF" },
                            pressedState: { color: "#499CFF" },
                        },
                        textLayout: {
                            normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" }
                        }
                    },
                    topUp: {
                        imageLayout: {
                            cornerRadiusPx: 0.016,
                            normalState: { color: "#0C9B56" },
                            hoverState: { color: "#0A713F" },
                            pressedState: { color: "#0B5E36" },
                        },
                        textLayout: {
                            normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" }
                        }
                    },
                    privateShow: {
                        imageLayout: {
                            cornerRadiusPx: 0.016,
                            normalState: { color: "#F18333" },
                            hoverState: { color: "#B85D1B" },
                            pressedState: { color: "#994C15" },
                        },
                        textLayout: {
                            normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" },
                            disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "700" }
                        }
                    },
                    confirmLeave: {
                        imageLayout: {
                            cornerRadiusPx: 0.016,
                            normalState: { color: "#2787FA" },
                            hoverState: { color: "#6BAFFF" },
                            pressedState: { color: "#499CFF" },
                        },
                        textLayout: {
                            normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" }
                        }
                    },
                    purchase: {
                        imageLayout: {
                            // get normalImg() {return Env.relativeBroadcastTipMenuName("message/alert_send_tip_normal.svg");},
                            // get hoverImg() {return Env.relativeBroadcastTipMenuName("message/alert_send_tip_hover.svg");},
                            // get pressedImg() {return Env.relativeBroadcastTipMenuName("message/alert_send_tip_pressed.svg");},
                            cornerRadiusPx: 0.016,
                            normalState: { color: "#B8A81B" },
                            hoverState: { color: "#584C06" },
                            pressedState: { color: "#C8B44C" },
                        },
                        textLayout: {
                            normal: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            hover: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            pressed: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" },
                            disabled: { color: "#FFFFFF", fontSize: Font.F20, fontWeight: "bold" }
                        }
                    }
                }
            },
            sendTipDialog: {
                width: 0.360,
                height: 0.180,
                backgroundColor: "#36333C",
                borderColor: "#5F5862",
                borderThickness: 0.002,
                header: {
                    width: 0.360,
                    height: 0.028,
                    left: 0,
                    top: 0.024,
                    padding: {
                        left: 0.072,
                        right: 0.072,
                        top: 0,
                        bottom: 0
                    },
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    verticalAlignment: VerticalAlignment.Top
                },
                amountGroup: {
                    height: 0.036,
                    top: 0.060,
                    amount: {
                        height: 0.036,
                        fontSize: Font.F32,
                        fontWeight: "400",
                        color: "#FFFFFF",
                        resizeToFit: true,
                        horizontalAlignment: HorizontalAlignment.Left,
                        textHorizontalAlignment: HorizontalAlignment.Right,
                    },
                    currency: {
                        width: 0.026 + 0.009,
                        height: 0.026,
                        padding: {
                            left: 0.009,
                        },
                        get image() {
                            return Env.relativeCommonName("token_icon.svg");
                        },
                    },
                },
                closeButton: {
                    width: 0.058,
                    height: 0.058,
                    padding: {
                        left: 0,
                        right: 0.006,
                        top: 0.006,
                        bottom: 0
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_pressed.svg");
                        },
                    }
                },
                actionButton: {
                    left: 0,
                    top: 0.110,
                    width: 0.360,
                    height: 0.070,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                        top: 0.002,
                        bottom: 0.016
                    },
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#FFDD56" },
                        hoverState: { color: "#CDA230" },
                        pressedState: { color: "#CDA230" },
                    },
                    textLayout: {
                        normal: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        hover: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        pressed: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        disabled: { color: "#000000", fontSize: Font.F20, fontWeight: "700" }
                    }
                },
            },
            toyTipDialog: {
                width: 0.360,
                height: 0.320,
                backgroundColor: "#36333C",
                borderColor: "#5F5862",
                borderThickness: 0.002,
                purchase: {
                    left: 0,
                    top: 0.250,
                    width: 0.360,
                    height: 0.070,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                        top: 0.002,
                        bottom: 0.016
                    },
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#FFDD56" },
                        hoverState: { color: "#CDA230" },
                        pressedState: { color: "#CDA230" },
                    },
                    textLayout: {
                        normal: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        hover: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        pressed: { color: "#000000", fontSize: Font.F20, fontWeight: "700" },
                        disabled: { color: "#000000", fontSize: Font.F20, fontWeight: "700" }
                    }
                },
                header: {
                    width: 0.360,
                    height: 0.028,
                    left: 0,
                    top: 0.024,
                    padding: {
                        left: 0.060,
                        right: 0.060,
                        top: 0,
                        bottom: 0
                    },
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "700",
                    verticalAlignment: VerticalAlignment.Top
                },
                modeText: {
                    width: 0.360,
                    height: 0.024,
                    left: 0,
                    top: 0.076,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                        top: 0,
                        bottom: 0
                    },
                    fontSize: Font.F20,
                    fontWeight: "700",
                    verticalAlignment: VerticalAlignment.Top
                },
                priceText: {
                    width: 0.360,
                    height: 0.024,
                    left: 0,
                    top: 0.104,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                        top: 0,
                        bottom: 0
                    },
                    color: "#B8B0BC",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    verticalAlignment: VerticalAlignment.Top
                },
                closeButton: {
                    width: 0.058,
                    height: 0.058,
                    padding: {
                        left: 0,
                        right: 0.006,
                        top: 0.006,
                        bottom: 0
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipMenuName("message/close_pressed.svg");
                        },
                    }
                },
                tipValueGrid: {
                    top: 0.156,
                    height: 0.064,
                    width: 0.296,
                    left: 0.032,
                    layout: {
                        rows: ["1*"],
                        columns: ["0.064m", "0.168m", "0.064m"]
                    },
                    minusButton: {
                        width: 0.064,
                        height: 0.064,
                        imageLayout: {
                            get normalImg() {
                                return Env.relativeBroadcastTipMenuName("message/minus_normal.svg");
                            },
                            get hoverImg() {
                                return Env.relativeBroadcastTipMenuName("message/minus_hover.svg");
                            },
                            get pressedImg() {
                                return Env.relativeBroadcastTipMenuName("message/minus_pressed.svg");
                            },
                            get disabledImg() {
                                return Env.relativeBroadcastTipMenuName("message/minus_disabled.svg");
                            },
                        },
                    },
                    plusButton: {
                        width: 0.064,
                        height: 0.064,
                        imageLayout: {
                            get normalImg() {
                                return Env.relativeBroadcastTipMenuName("message/plus_normal.svg");
                            },
                            get hoverImg() {
                                return Env.relativeBroadcastTipMenuName("message/plus_hover.svg");
                            },
                            get pressedImg() {
                                return Env.relativeBroadcastTipMenuName("message/plus_pressed.svg");
                            },
                            get disabledImg() {
                                return Env.relativeBroadcastTipMenuName("message/plus_disabled.svg");
                            },
                        },
                    },
                    price: {
                        top: 0,
                        height: 0.036,
                        text: {
                            height: 0.036,
                            fontSize: Font.F32,
                            fontWeight: "400",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            horizontalAlignment: HorizontalAlignment.Left,
                            textHorizontalAlignment: HorizontalAlignment.Right,
                        },
                        currency: {
                            width: 0.026 + 0.009,
                            height: 0.026,
                            padding: {
                                left: 0.009,
                            },
                            get image() {
                                return Env.relativeCommonName("token_icon.svg");
                            },
                        },
                    },
                },
            },
            empty: {
                icon: {
                    get activities() {
                        return Env.relativeBroadcastTipMenuName("activities.svg");
                    },
                    get toys() {
                        return Env.relativeBroadcastTipMenuName("toys.svg");
                    },
                    width: 0.08,
                    height: 0.08,
                    top: 0.262,
                },
                line1: {
                    fontSize: Font.F28,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    top: 0.366,
                    width: 0.384,
                    height: 0.64,
                    verticalAlignment: VerticalAlignment.Top,
                    textVerticalAlignment: VerticalAlignment.Top
                },
                line2: {
                    fontSize: Font.F20,
                    fontWeight: "500",
                    color: "#B8B0BC",
                    top: 0.442,
                    width: 0.312,
                    resizeToFit: true,
                    verticalAlignment: VerticalAlignment.Top,
                    textWrapping: 1
                }
            }
        },
        tips: {
            verticalOffset: 0.090,
            panel: {
                height: 0.096,
                tipButtonsLeftGap: 0.028,
                tipButtonsRightGap: 0.032
            },
            sendPanel: {
                smallButton: {
                    width: 0.072,
                    padding: {
                        left: 0.004,
                        right: 0.004,
                        top: 0.016,
                        bottom: 0.016
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipsName("tip_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipsName("tip_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                    },
                    textLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        disabled: { color: "#B1A3B7", fontSize: Font.F36, fontWeight: "bold" }
                    },
                    selectedImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeBroadcastTipsName("tip_pressed.svg");
                        },
                    },
                    selectedTextLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        disabled: { color: "#B1A3B7", fontSize: Font.F36, fontWeight: "bold" }
                    }
                },
                customButton: {
                    width: 0.136,
                    padding: {
                        left: 0.004,
                        right: 0.004,
                        top: 0.016,
                        bottom: 0.016
                    },
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                    },
                    textLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        disabled: { color: "#B1A3B7", fontSize: Font.F36, fontWeight: "bold" }
                    },
                    selectedImageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeBroadcastTipsName("custom_tip_pressed.svg");
                        },
                    },
                    selectedTextLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F36, fontWeight: "bold" },
                        disabled: { color: "#B1A3B7", fontSize: Font.F36, fontWeight: "bold" }
                    }
                },
                sendButton: {
                    width: 0.168,
                    padding: {
                        left: 0.004,
                        right: 0.004,
                        top: 0.016,
                        bottom: 0.016
                    },
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#B8A81B" },
                        hoverState: { color: "#584C06" },
                        pressedState: { color: "#C8B44C" },
                        disabledState: { color: "#332936" },
                    },
                    textLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        disabled: { color: "#B1A3B7", fontSize: Font.F22, fontWeight: "bold" }
                    }
                },
            },
            // keyboard: {
            //     width: 0.196,
            //     height: 0.264,
            //     left: 0.384,
            //     keysMargin: {
            //         left: 0.014,
            //         top: 0.012
            //     },
            //     cornerRadius: 0.032,
            //     backgroundColor: "#332936",
            //     keySize: {
            //         width: 0.056,
            //         height: 0.060,
            //         padding: {
            //             left: 0.002,
            //             right: 0.002,
            //             top: 0.004,
            //             bottom: 0.004
            //         }
            //     },
            //     keyDigit: {
            //         imageLayout: {
            //             get normalImg() {return Env.relativeBroadcastTipsKeyboardName("key_normal.svg");},
            //             get hoverImg() {return Env.relativeBroadcastTipsKeyboardName("key_hover.svg");},
            //             get pressedImg() {return Env.relativeBroadcastTipsKeyboardName("key_pressed.svg");},
            //             get disabledImg() {return Env.relativeBroadcastTipsKeyboardName("key_pressed.svg");},
            //         },
            //         textLayout: {
            //             normal: { color: "#E6E6E6", fontSize: Font.F24 },
            //             hover: { color: "#E6E6E6", fontSize: Font.F24 },
            //             pressed: { color: "#1A1A1A", fontSize: Font.F24 },
            //             disabled: { color: "#1A1A1A", fontSize: Font.F24 }
            //         }
            //     },
            //     keyBackspace: {
            //         imageLayout: {
            //             get normalImg() {return Env.relativeBroadcastTipsKeyboardName("backspace_normal.svg");},
            //             get hoverImg() {return Env.relativeBroadcastTipsKeyboardName("backspace_hover.svg");},
            //             get pressedImg() {return Env.relativeBroadcastTipsKeyboardName("backspace_pressed.svg");},
            //             get disabledImg() {return Env.relativeBroadcastTipsKeyboardName("backspace_pressed.svg");},
            //         }
            //     },
            //     keyOk: {
            //         imageLayout: {
            //             get normalImg() {return Env.relativeBroadcastTipsKeyboardName("ok_normal.svg");},
            //             get hoverImg() {return Env.relativeBroadcastTipsKeyboardName("key_hover.svg");},
            //             get pressedImg() {return Env.relativeBroadcastTipsKeyboardName("key_pressed.svg");},
            //             get disabledImg() {return Env.relativeBroadcastTipsKeyboardName("key_pressed.svg");},
            //         },
            //         textLayout: {
            //             normal: { color: "#E6E6E6", fontSize: Font.F20, fontWeight: "bold" },
            //             hover: { color: "#E6E6E6", fontSize: Font.F20, fontWeight: "bold" },
            //             pressed: { color: "#1A1A1A", fontSize: Font.F20, fontWeight: "bold" },
            //             disabled: { color: "#1A1A1A", fontSize: Font.F20, fontWeight: "bold" }
            //         }
            //     },
            // },
            questionPanel: {
                height: 0.096,
                text: {
                    width: 0.330,
                    padding: {
                        left: 0.032,
                        right: 0.002,
                        top: 0.004,
                        bottom: 0.004
                    },
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "normal"
                },
                rejectButton: {
                    width: 0.122,
                    height: 0.096,
                    left: 0.330,
                    top: 0,
                    padding: {
                        left: 0.002,
                        right: 0.008,
                        top: 0.016,
                        bottom: 0.016
                    },
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#332936" },
                        hoverState: { color: "#1F1A21" },
                        pressedState: { color: "#493D4D" },
                    },
                    textLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        disabled: { color: "#4D4D4D", fontSize: Font.F22, fontWeight: "bold" }
                    }
                },
                confirmButton: {
                    width: 0.136,
                    height: 0.096,
                    left: 0.452,
                    top: 0,
                    padding: {
                        left: 0.008,
                        right: 0.016,
                        top: 0.016,
                        bottom: 0.016
                    },
                    imageLayout: {
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#B8A81B" },
                        hoverState: { color: "#584C06" },
                        pressedState: { color: "#C8B44C" },
                    },
                    textLayout: {
                        normal: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        hover: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        pressed: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold" },
                        disabled: { color: "#4D4D4D", fontSize: Font.F22, fontWeight: "bold" }
                    }
                },
            },
        },
        chat: {
            verticalOffset: Env.broadcastPanelY.chat,
            spacing: 0.004,
            margin: Env.chatMargin,
            background: {
                height: Env.chatHeight
            },
            toysMenuNotification: {
                cutOffDate: "2023-03-20T12:00:00Z",
                button: {
                    width: 0.556,
                    height: 0.080,
                    padding: {
                        vertical: 0.012
                    },
                    get normalImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_pressed.svg");
                    },
                },
                closeButton: {
                    width: 0.04,
                    height: 0.04,
                    top: 0.171,
                    left: 0.544,
                    get normalImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_close.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_close.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("toys_menu_notification_close.svg");
                    },
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top
                },
                text: {
                    common: {
                        fontSize: Font.F20,
                        fontWeight: "700",
                        color: "white",
                        resizeToFit: true,
                        textWrapping: TextWrapping.WordWrap,
                    }
                }
            },
            scrollView: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.000,
                        top: 0,
                        bottom: 0
                    },
                },
                speed: 0.5,
            },
            popUp: {
                backgroundColor: "#4D4D4D",
                timeoutMs: 3000,
                fontColor: "#E6E6E6",
                fontSize: Font.F24,
                height: 0.096,
                width: 0.588,
                cornerRadius: 0.032,
            },
            text: {
                modelColor: "#FFA06A",
                myColor: "#A6C2F9",
                clientColor: "#FFFFFF",
                systemColor: "#ECCB49",
                systemBackgroundColor: "#36333C",
                fontSize: Font.F24,
                fontWeight: "500",
                height: 0.304,
                width: Env.broadcastMenuWidth - 2 * Env.chatMargin,
                cornerRadius: 0.004,
                special: {
                    padding: {
                        top: 0.008,
                        bottom: 0.008,
                    },
                },
            },
            bottomPanel: {
                height: 0.052,
                margin: 0.004,
                clear: {
                    get normalImg() {
                        return Env.relativeBroadcastChatName("clear_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("clear_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("clear_pressed.svg");
                    },
                },
                mic: {
                    width: 0.044,
                    height: 0.044,
                    get normalImg() {
                        return Env.relativeBroadcastChatName("mic_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("mic_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("mic_pressed.svg");
                    },
                    get disabledImg() {
                        return Env.relativeBroadcastChatName("mic_disabled.svg");
                    },
                },
                send: {
                    width: 0.044,
                    height: 0.044,
                    horizontalAlignment: HorizontalAlignment.Right,
                    verticalAlignment: VerticalAlignment.Bottom,
                    padding: {
                        right: 0.004,
                        bottom: 0.004,
                    },
                    get normalImg() {
                        return Env.relativeBroadcastChatName("send_default.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("send_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("send_hover.svg");
                    },
                },
                showKeyboard: {
                    get normalImg() {
                        return Env.relativeBroadcastChatName("keyboard_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastChatName("keyboard_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastChatName("keyboard_pressed.svg");
                    },
                },
                input: {
                    maxSymbols: 256,
                    width: 0.556,
                    adaptHeightToChildren: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    contentPadding: { horizontal: 0.06, vertical: 0.012 },
                    cursorLayout: {
                        width: 0.001,
                        height: 0.028,
                    },
                    backgroundLayout: { useArc: true, cornerRadius: 0.026 },
                    states: [
                        {
                            state: "common",
                            style: {
                                isCursorEnabled: false,
                                textStyle: {
                                    fontSize: Font.F24,
                                    fontWeight: "500",
                                    color: "white",
                                    resizeToFit: true,
                                    textWrapping: TextWrapping.WordWrap,
                                    textHorizontalAlignment: HorizontalAlignment.Left,
                                    horizontalAlignment: HorizontalAlignment.Left,
                                    verticalAlignment: VerticalAlignment.Top,
                                    textVerticalAlignment: VerticalAlignment.Top,
                                },
                                placeholderStyle: {
                                    fontSize: Font.F24,
                                    fontWeight: "500",
                                    color: "#B8B0BC",
                                    resizeToFit: true,
                                    textHorizontalAlignment: HorizontalAlignment.Left,
                                    horizontalAlignment: HorizontalAlignment.Left,
                                    verticalAlignment: VerticalAlignment.Top,
                                    textVerticalAlignment: VerticalAlignment.Top,
                                },
                                backgroundStyle: {
                                    color: "#5A515E",
                                    borderThickness: 0
                                },
                                cursorStyle: {
                                    color: "white",
                                    borderThickness: 0,
                                }
                            }
                        },
                        {
                            state: "focused",
                            style: {
                                isCursorEnabled: true,
                                backgroundStyle: {
                                    color: "#7F7383",
                                }
                            }
                        },
                        {
                            state: "disabled",
                            style: {
                                isCursorEnabled: false,
                                placeholderStyle: {
                                    color: "#544C56",
                                },
                                backgroundStyle: {
                                    color: "#2A242D",
                                }
                            }
                        }
                    ],
                    maxLines: 8,
                },
                inputDisabledIcon: {
                    get src() {
                        return Env.relativeBroadcastChatName("input_disabled.svg");
                    },
                    width: 0.033,
                    height: 0.033,
                    padding: 0.011,
                },
                keyboardButton: {
                    width: 0.068,
                    padding: {
                        left: 0.008,
                        right: 0.008
                    }
                },
                clearButton: {
                    width: 0.052
                },
                micButton: {
                    width: 0.052,
                    left: 0.004
                },
                sendButton: {
                    width: 0.052,
                    right: 0.004
                },
            },
            grid: {
                rows: ["1*", "auto", "0.008m", "auto", "auto", "auto"],
                columns: ["1*"],
                padding: 0.016,
            },
            sendTips: {
                header: {
                    color: "#FFFFFF",
                    fontSize: Font.F16,
                    fontWeight: "700",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    padding: {
                        top: 0.012,
                        bottom: 0.012,
                    }
                },
                tipMenu: {
                    button: {
                        width: 0.12,
                        height: 0.052,
                        cornerRadiusPx: 0.016,
                        states: [
                            { state: "normal", style: { color: "#FFDD56" } },
                            { state: "hover", style: { color: "#CDA230" } },
                            { state: "pressed", style: { color: "#AC8623" } },
                            {
                                state: "toggled",
                                style: {
                                    color: "transparent",
                                    borderThickness: 0.002,
                                    borderColor: "#FFDD56"
                                }
                            },
                            {
                                state: "toggledHover",
                                style: {
                                    color: "transparent",
                                    borderThickness: 0.002,
                                    borderColor: "#CDA230"
                                }
                            },
                            {
                                state: "toggledPressed",
                                style: {
                                    color: "transparent",
                                    borderThickness: 0.002,
                                    borderColor: "#AC8623"
                                }
                            },
                            { state: "disabled", style: { color: "#5A515E", borderThickness: 0 } },
                        ]
                    },
                    text: {
                        common: {
                            resizeToFit: true,
                            fontSize: Font.F20,
                            fontWeight: "700",
                            color: "#000000"
                        },
                        toggled: { color: "#FFFFFF" },
                        toggledHover: { color: "#B8B0BC" },
                        toggledPressed: { color: "#998B9F" },
                        disabled: { color: "#B8B0BC" },
                    }
                },
                tips: {
                    imageLayout: {
                        width: 0.052,
                        height: 0.052,
                        get states() {
                            return [
                                {
                                    state: "common",
                                    style: Env.relativeBroadcastTipsName("tip_normal.svg"),
                                },
                                {
                                    state: "normal",
                                    style: Env.relativeBroadcastTipsName("tip_normal.svg"),
                                },
                                {
                                    state: "hover",
                                    style: Env.relativeBroadcastTipsName("tip_hover.svg"),
                                },
                                {
                                    state: "pressed",
                                    style: Env.relativeBroadcastTipsName("tip_pressed.svg"),
                                },
                            ];
                        }
                    },
                    textLayout: {
                        states: [
                            {
                                state: "common",
                                style: {
                                    fontSize: Font.F18,
                                    fontWeight: "800",
                                    color: "#FFFFFF"
                                }
                            },
                            {
                                state: "hover",
                                style: { color: "#FFFFFFCC" }
                            },
                            {
                                state: "pressed",
                                style: { color: "#FFFFFFA8" }
                            }
                        ]
                    },
                    values: [20, 50, 100, 200],
                },
                customTip: {
                    input: {
                        maxLength: 9,
                        filter: /^\d*$/,
                        substitution: /[^\d]/g,
                        width: 0.187,
                        height: 0.052,
                        horizontalAlignment: HorizontalAlignment.Left,
                        contentPadding: { left: 0.016, right: 0.063, top: 0.014, bottom: 0.014 },
                        cursorLayout: {
                            width: 0.001,
                            height: 0.02,
                        },
                        backgroundLayout: { useArc: true, cornerRadius: 0.026 },
                        states: [
                            {
                                state: "common",
                                style: {
                                    isCursorEnabled: false,
                                    textStyle: {
                                        fontSize: Font.F20,
                                        fontWeight: "700",
                                        color: "white",
                                        resizeToFit: true,
                                        textWrapping: TextWrapping.WordWrap,
                                        textHorizontalAlignment: HorizontalAlignment.Left,
                                        horizontalAlignment: HorizontalAlignment.Left,
                                    },
                                    placeholderStyle: {
                                        fontSize: Font.F20,
                                        fontWeight: "700",
                                        color: "#B1A3B7",
                                        resizeToFit: true,
                                        textHorizontalAlignment: HorizontalAlignment.Left,
                                        horizontalAlignment: HorizontalAlignment.Left,
                                    },
                                    backgroundStyle: {
                                        color: "#5A515E",
                                        borderThickness: 0
                                    },
                                    cursorStyle: {
                                        color: "white",
                                        borderThickness: 0,
                                    }
                                }
                            },
                            {
                                state: "focused",
                                style: {
                                    isCursorEnabled: true,
                                    backgroundStyle: {
                                        color: "#7F7383",
                                        borderThickness: 0
                                    }
                                }
                            }
                        ],
                        maxLines: 1,
                    },
                    sendButton: {
                        width: 0.052,
                        height: 0.052,
                        get states() {
                            return [
                                {
                                    state: "common",
                                    style: Env.relativeBroadcastTipsName("send_tip_normal.svg"),
                                },
                                {
                                    state: "normal",
                                    style: Env.relativeBroadcastTipsName("send_tip_normal.svg"),
                                },
                                {
                                    state: "hover",
                                    style: Env.relativeBroadcastTipsName("send_tip_hover.svg"),
                                },
                                {
                                    state: "pressed",
                                    style: Env.relativeBroadcastTipsName("send_tip_pressed.svg"),
                                },
                            ];
                        }
                    }
                },
                spacing: 0.008,
                padding: 0.012,
            },
            dividerLine: {
                background: "#5F5862",
                height: 0.001,
            },
            tipsKeyboard: {
                width: 0.196,
                height: 0.276,
                left: 0.384,
                offset: 0.008,
            },
            hideKeyboard: {
                width: 0.112,
                height: 0.04,
                offset: 0.004,
                get states() {
                    return [
                        { state: "common", style: Env.relativeBroadcastChatName("keyboard_hide_normal.svg") },
                        { state: "hover", style: Env.relativeBroadcastChatName("keyboard_hide_hover.svg") },
                        { state: "pressed", style: Env.relativeBroadcastChatName("keyboard_hide_pressed.svg") },
                    ];
                }
            },
        },
        user: {
            verticalOffset: Env.broadcastPanelY.user,
            height: 0.084,
            submenus: {
                clientProfile: {
                    width: 0.240,
                    height: 0.076,
                    offsetLeft: -0.588 / 2 + 0.240 / 2,
                    offsetTop: -0.084 / 2 - 0.076 / 2 - 0.004,
                    thickness: 0.002,
                    outlineColor: "#5F5862",
                    item: {
                        width: 0.240,
                        height: 0.052,
                        colorLayout: {
                            common: { borderThickness: 0 },
                            normalState: { color: "#00000000" },
                            hoverState: { color: "#FFFFFF1F" },
                            pressedState: { color: "#FFFFFF0F" },
                        },
                        text: {
                            fontSize: Font.F20,
                            fontWeight: "500",
                            color: "#FFFFFF",
                            width: 0.240 - 0.076,
                            height: 0.052,
                            left: 0.076,
                            textWrapping: TextWrapping.Ellipsis,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            textHorizontalAlignment: HorizontalAlignment.Left,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                    signOutItem: {
                        image: {
                            width: 0.052,
                            height: 0.052,
                            left: 0.016,
                            top: 0.000,
                            get src() {
                                return Env.relativeBroadcastNavigationName("actions-logout.svg");
                            },
                        },
                    },
                },
            },
        },
        messagePanel: {
            height: 0.096,
            text: {
                width: Env.broadcastMenuWidth,
                padding: {
                    left: 0.032,
                    right: 0.032,
                    top: 0.016,
                    bottom: 0.016
                },
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "normal"
            }
        },
        relatedPanel: {
            width: 0.588,
            height: 0.904,
            root: {
                background: "#241D26",
                cornerRadius: 0.032
            },
            header: {
                background: "#36333C",
                height: 0.064,
                caption: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                },
            },
            closeButton: {
                width: 0.052,
                height: 0.052,
                top: 0.006,
                right: 0.006,
                get normalImg() {
                    return Env.relativeBroadcastHelpName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastHelpName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastHelpName("close_pressed.svg");
                },
            },
            stub: {
                caption: {
                    color: "#FFFFFF",
                    fontSize: Font.F36,
                    fontWeight: "700",
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                    top: 0.329,
                    height: 0.042,
                },
                description: {
                    color: "#B8B0BC",
                    fontSize: Font.F24,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                    top: 0.387,
                    height: 0.028,
                },
            },
            scrollView: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.008,
                        top: 0,
                        bottom: 0.008
                    },
                },
                speed: 2
            },
            stackPanel: {
                spacing: 0.024,
            },
            broadcast: {
                width: 0.540,
                height: 0.160,
                cornerRadius: 0.008,
                color: {
                    normal: "#00000000",
                    hover: "#4F4552",
                },
                skeleton: {
                    image: {
                        // background: "#241D26",
                        background: "rgba(255, 255, 255, 0.08)",
                        width: 0.262,
                        height: 0.160,
                        cornerRadius: 0.008,
                    },
                    texts: {
                        line1: {
                            width: 0.160,
                            height: 0.020,
                            left: 0.278,
                            top: 0.008,
                            background: "rgba(255, 255, 255, 0.08)",
                        },
                        line2: {
                            width: 0.250,
                            height: 0.020,
                            left: 0.278,
                            top: 0.052,
                            background: "rgba(255, 255, 255, 0.08)",
                        },
                    },
                },
                modelNickname: {
                    color: "#FFFFFF",
                    fontSize: Font.F28,
                    fontWeight: "700",
                    resizeToFit: true,
                    textWrapping: TextWrapping.Ellipsis,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    left: 0.278,
                    top: 0.008,
                    width: 0.254,
                    height: 0.032,
                },
                textStatus: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: true,
                    textWrapping: TextWrapping.WordWrapEllipsis,
                    maxLines: 3,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Top,
                    left: 0.278,
                    top: 0.052,
                    width: 0.254,
                    height: 0.072,
                },
                imageRectangle: {
                    width: 0.262,
                    height: 0.160,
                    cornerRadius: 0.008,
                },
                gradient: {
                    width: 0.262,
                    height: 0.160,
                    get image() {
                        return Env.relativeBroadcastRelatedName("thumbnail_gradient.svg");
                    },
                },
                favoriteButton: {
                    colorLayout: {
                        left: 0.218,
                        top: 0.116,
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        width: 0.036,
                        height: 0.036,
                        useArc: true,
                        cornerRadiusPx: 0.018,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                    },
                    children: {
                        width: 0.036,
                        height: 0.036,
                        get uncheckedImage() {
                            return Env.relativeBroadcastRelatedName("favorite_off.svg");
                        },
                        get checkedImage() {
                            return Env.relativeBroadcastRelatedName("favorite_on.svg");
                        },
                        get disabledImage() {
                            return Env.relativeBroadcastRelatedName("favorite_disabled.svg");
                        },
                    },
                },
                // favorite: {
                //     left: 0.218,
                //     top: 0.116,
                //     width: 0.036,
                //     height: 0.036,
                //     get uncheckedImage() {
                //         return Env.relativeBroadcastRelatedName("favorite_unchecked.svg");
                //     },
                //     get checkedImage() {
                //         return Env.relativeBroadcastRelatedName("favorite_checked.svg");
                //     },
                // },
                labels: {
                    top: 0.008,
                    left: 0.008,
                    status: {
                        cornerRadius: 0.004,
                        icon: {
                            get image() {
                                return Env.relativeLobbyName("glasses.svg");
                            },
                            width: 0.024,
                            height: 0.024,
                            padding: {
                                left: 0.006,
                                top: 0,
                                bottom: 0,
                                right: 0,
                            },
                        },
                        customPadding: {
                            leftWithIcon: 0.004,
                            leftWithoutIcon: 0.008,
                        },
                        text: {
                            fontSize: Font.F14,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            padding: {
                                left: 0.000,
                                top: 0.000,
                                right: 0.008,
                                bottom: 0.000,
                            },
                        },
                        away: "#564D5B",
                        live: "#0C9B56",
                        private: "#F18333",
                        offline: "#0000007F",
                    },
                    viewers: {
                        icon: {
                            get image() {
                                return Env.relativeBroadcastRelatedName("viewers_icon.svg");
                            },
                            width: 0.024,
                            height: 0.024,
                            padding: {
                                left: 0.002,
                            },
                        },
                        paddingLeft: 0.006,
                        cornerRadius: 0.004,
                        height: 0.024,
                        background: "#0000007F",
                        text: {
                            height: 0.024,
                            fontSize: Font.F14,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            verticalAlignment: VerticalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.004,
                                top: 0,
                                right: 0.008,
                                bottom: 0,
                            },
                        },
                    },
                    resolution: {
                        left: 0.008,
                        top: 0.038,
                        cornerRadius: 0.004,
                        height: 0.024,
                        background: "#FF2C56",
                        text: {
                            fontSize: Font.F14,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            verticalAlignment: VerticalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.0085,
                                right: 0.0085,
                            },
                        },
                    },
                    mask: {
                        get image() {
                            return Env.relativeLobbyName("mask.svg");
                        },
                        width: 0.036,
                        height: 0.036,
                        left: 0.008,
                        top: 0.116,
                    },
                    spyNow: {
                        right: 0.286,
                        top: 0.008,
                        cornerRadius: 0.004,
                        height: 0.024,
                        background: "#8464DD",
                        icon: {
                            get image() {
                                return Env.relativeLobbyName("spy_now_icon.svg");
                            },
                            padding: {
                                left: 0.006,
                                right: 0.006,
                            },
                            width: 0.032,
                            height: 0.024,
                        },
                        text: {
                            fontSize: Font.F14,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            resizeToFit: true,
                            verticalAlignment: VerticalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                            padding: {
                                left: 0.008,
                                right: 0.034,
                            },
                        },
                    },
                },
            },
        },
        privateModePanel: {
            height: 0.816,
            verticalOffset: Env.broadcastPanelY.privateModeSelector,
            headerHeight: 0.064,
            headerBackground: "#36333C",
            messageZ: 0.04,
            spacing: 0.016,
            header: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "bold",
                width: 0.305,
                height: 0.032,
                horizontalAlignment: HorizontalAlignment.Center,
                horizontalTextAlignment: HorizontalAlignment.Center,
                resizeToFit: true
            },
            backButton: {
                rectangleLayout: {
                    width: 0.052,
                    height: 0.052,
                    left: 0.006,
                    top: 0.006,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    cornerRadiusPx: 0.026,
                    useArc: true,
                    common: { borderThickness: 0 },
                    normalState: { color: "transparent" },
                    hoverState: { color: "#FFFFFF1A" },
                    pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                },
                get img() {
                    return Env.relativeBroadcastModeName("back_arrow.svg");
                },
            },
            element: {
                common: {
                    width: 0.556,
                    height: 0.352,
                    cornerRadius: 0.016,
                    price: {
                        height: 0.036,
                        left: 0.032,
                        top: 0.257,
                    },
                    background: "#36333C",
                    featurePanelHeight: 0.14,
                    button: {
                        imageLayout: {
                            width: 0.224,
                            height: 0.064,
                            left: 0.300,
                            top: 0.256,
                            cornerRadiusPx: 0.016,
                            horizontalAlignment: HorizontalAlignment.Left,
                            verticalAlignment: VerticalAlignment.Top,
                            normalState: { color: "#F18333" },
                            hoverState: { color: "#B85D1B" },
                            pressedState: { color: "#B85D1B" },
                            disabledState: { color: "#332936" },
                        },
                        textLayout: {
                            common: {
                                fontSize: Font.F22,
                                fontWeight: "700",
                                color: "#FFFFFF",
                                resizeToFit: true,
                                textWrapping: TextWrapping.Clip,
                                textHorizontalAlignment: HorizontalAlignment.Center,
                                textVerticalAlignment: VerticalAlignment.Center,
                            },
                        }
                    },
                },
                textPrivate: {
                    icon: {
                        get url() {
                            return Env.relativeBroadcastModeName("private_mode_icon_classic.svg");
                        },
                        width: 0.072,
                        height: 0.072,
                        left: 0.032,
                        top: 0.032,
                    },
                },
                voicePrivate: {
                    icon: {
                        get url() {
                            return Env.relativeBroadcastModeName("private_mode_icon_immersive.svg");
                        },
                        width: 0.072,
                        height: 0.072,
                        left: 0.032,
                        top: 0.032,
                    },
                },
            },
            style: {
                header: {
                    left: 0.032,
                    top: 0.120,
                    color: "#FFFFFF",
                    fontSize: Font.F36,
                    fontWeight: "700",
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    verticalTextAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                },
                feature: {
                    left: 0.032,
                    top: 0.168,
                    color: "#FFFFFF",
                    fontSize: Font.F22,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    verticalTextAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                },
                price: {
                    color: "#FFFFFF",
                    fontSize: Font.F32,
                    fontWeight: "400",
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    verticalTextAlignment: VerticalAlignment.Center,
                    padding: {
                        right: 0.008,
                    },
                    resizeToFit: true,
                },
                currency: {
                    width: 0.026,
                    height: 0.026,
                    get img() {
                        return Env.relativeBroadcastNavigationName("currency.svg");
                    },
                },
                priceLabel: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    verticalTextAlignment: VerticalAlignment.Center,
                    padding: {
                        left: 0.012,
                    },
                    resizeToFit: true,
                },
                minDuration: {
                    left: 0.032,
                    top: 0.297,
                    color: "rgba(255, 255, 255, 0.72)",
                    fontSize: Font.F22,
                    fontWeight: "500",
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    horizontalTextAlignment: HorizontalAlignment.Left,
                    verticalTextAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                },
            }
        },
        modelProfile: {
            width: 0.588,
            height: 0.904,
            top: 0.008,
            left: 0.024,
            right: 0.024,
            cornerRadius: 0.032,
            headerMarginTop: 0.016,
            headerHeight: 0.064,
            headerBackground: "#36333C",
            headerPadding: 0.006,
            photoStatusContainerHeight: 0.184,
            spacing: 0.008,
            checkMyVideosButton: {
                panel: {
                    width: 0.540,
                    height: 0.064 + 0.040,
                },
                imageLayout: {
                    width: 0.540,
                    height: 0.064,
                    get normalImg() {
                        return Env.relativeLobbyName("check_my_videos_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeLobbyName("check_my_videos_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeLobbyName("check_my_videos_pressed.svg");
                    },
                },
                textLayout: {
                    common: {
                        fontSize: Font.F22,
                        fontWeight: "700",
                        color: "white",
                        resizeToFit: true,
                        textWrapping: TextWrapping.Clip,
                    }
                },
            },
            status: {
                fontSize: Font.F18,
                fontWeight: "bold",
                color: "#FFFFFF",
                padding: {
                    left: 0.008,
                    top: 0.0035,
                    right: 0.008,
                    bottom: 0.0035,
                },
                cornerRadius: 0.004,
                resizeToFit: true,
                background: {
                    away: "#564D5B",
                    live: "#0C9B56",
                    private: "#F18333",
                    offline: "#0000007F",
                },
            },
            scrollView: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.008,
                        top: 0,
                        bottom: 0.008
                    },
                },
                speed: 2
            },
            photo: {
                diameter: 0.164,
                top: 0.016,
                outlineDiameter: 0.176,
                outlineThickness: 0.003,
            },
            name: {
                color: "#FFFFFF",
                fontSize: Font.F32,
                fontWeight: "700",
                resizeToFit: true,
                textWrapping: TextWrapping.Ellipsis
            },
            header: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
            },
            info: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                width: 0.476,
                fontWeight: "500",
                resizeToFit: true,
                textWrapping: TextWrapping.WordWrapEllipsis
            },
            section: {
                color: "#FFFFFF",
                fontSize: Font.F20,
                fontWeight: "normal",
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Top,
                textVerticalAlignment: VerticalAlignment.Top,
                resizeToFit: true,
                textWrapping: TextWrapping.WordWrap,
                padding: {
                    left: 0.024,
                },
            },
            sectionHeader: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "bold",
                resizeToFit: true,
                textWrapping: TextWrapping.WordWrap,
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Top,
                textVerticalAlignment: VerticalAlignment.Top,
                padding: {
                    left: 0.024,
                    top: 0.032,
                    bottom: 0.012,
                }
            },
            tag: {
                states: [
                    { state: "common", style: { color: "#5C4F61" } },
                    { state: "normal", style: { color: "#5C4F61" } },
                    { state: "hover", style: { color: "#7C6F81" } },
                    { state: "pressed", style: { color: "#2787FA" } },
                    { state: "highlighted", style: { color: "#DD5F43" } },
                ],
                tagHeight: 0.024,
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "bold",
                    resizeToFit: true,
                },
                tagPadding: {
                    top: 0.01,
                    right: 0.016,
                    bottom: 0.01,
                    left: 0.016
                },
                cornerRadiusPx: 0.07,
                useArc: true,
                icon: {
                    width: 0.024,
                    height: 0.024,
                    image(img) {
                        return Env.relativeBroadcastModelName(`tag-${img}.svg`);
                    },
                    padding: {
                        top: 0.01,
                        right: 0.008,
                        bottom: 0.01,
                        left: 0
                    },
                }
            },
            viewMoreButton: {
                colorLayout: {
                    width: 0.132,
                    height: 0.044,
                    cornerRadiusPx: 0.07,
                    useArc: true,
                    normalState: { color: "#2787FA" },
                    hoverState: { color: "#13427A" },
                    pressedState: { color: "#60A7FC" },
                    disabledState: { color: "#332936" },
                },
                textLayout: {
                    common: {
                        color: "#FFFFFF",
                        fontSize: Font.F20,
                        fontWeight: "bold",
                        resizeToFit: true,
                    },
                    disabled: { color: "#B1A3B7" }
                },
            },
            post: {
                bottom: 0.032,
                text: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    resizeToFit: true,
                    fontWeight: "500",
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textWrapping: TextWrapping.WordWrap,
                    padding: {
                        left: 0.024,
                        top: 0.016,
                        right: 0.024,
                    },
                },
                header: {
                    left: 0.024,
                    bottom: 0.016,
                    image: {
                        diameter: 0.048,
                    },
                    text: {
                        color: "#FFFFFF",
                        fontSize: Font.F20,
                        width: 0.46,
                        padding: { left: 0.016 },
                        fontWeight: "700",
                        horizontalAlignment: HorizontalAlignment.Left,
                        textHorizontalAlignment: HorizontalAlignment.Left,
                        textWrapping: TextWrapping.Ellipsis,
                    }
                }
            },
            lock: {
                width: 0.120,
                height: 0.120,
                get lockImg() {
                    return Env.relativeBroadcastModelName("lock.svg");
                },
            },
            lockText: {
                fontSize: Font.F24,
                fontWeight: "bold",
                color: "#FFFFFF",
                horizontalTextAlignment: HorizontalAlignment.Center,
                horizontalAlignment: HorizontalAlignment.Center,
                resizeToFit: true,
                padding: {
                    top: 0.016
                },
            },
            closeButtonLayout: {
                width: 0.058,
                height: 0.052,
                padding: { right: 0.006 },
                get normalImg() {
                    return Env.relativeBroadcastModelName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastModelName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastModelName("close_pressed.svg");
                },
            },
            backButtonLayout: {
                width: 0.058,
                height: 0.052,
                padding: { left: 0.006 },
                get normalImg() {
                    return Env.relativeBroadcastModelName("back_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastModelName("back_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastModelName("back_pressed.svg");
                },
            }
        },
        voiceToText: {
            get modelUrl() {
                return Env.relativeName("model.tar.gz");
            },
            animationPanel: {
                width: 0.284,
                height: 0.008,
                circleBackground: "#877B8E",
                barBackground: "#FFFFFF",
                waveformColor: "#FFFFFF",
                idleHeight: 0.009,
                waveformPanelSpacing: 0.004,
                waveformElementWidth: 0.008,
                waveformElementMinHeight: 0.008,
                waveformElementMaxHeight: 0.112,
                waveformElementRadius: 0.004,
                mask: {
                    get image() {
                        return Env.relativeBroadcastChatName("voice_to_text_idle_mask.svg");
                    }
                },
                header: {
                    color: "#FFFFFF",
                    fontSize: Font.F28,
                    fontWeight: "bold",
                    top: 0.024,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                time: {
                    color: "#B1A3B7",
                    fontSize: Font.F24,
                    top: 0.288,
                    horizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
            },
            infoPanel: {
                header: {
                    color: "#FFFFFF",
                    fontSize: Font.F28,
                    fontWeight: "bold",
                    left: 0.024,
                    top: 0.032,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                line1: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    left: 0.024,
                    top: 0.13,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                line2: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    left: 0.024,
                    top: 0.178,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                dontShow: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    left: 0.08,
                    top: 0.242,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                dontShowToggle: {
                    left: 0.016,
                    top: 0.23,
                    width: 0.052,
                    height: 0.052,
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastChatName("checkbox_unchecked.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastChatName("checkbox_unchecked.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastChatName("checkbox_checked.svg");
                        },
                        get pressedHoverImg() {
                            return Env.relativeBroadcastChatName("checkbox_checked.svg");
                        },
                    }
                },
                closeButton: {
                    left: 0.528,
                    top: 0.008,
                    width: 0.052,
                    height: 0.052,
                    imageLayout: {
                        get normalImg() {
                            return Env.relativeBroadcastChatName("close_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeBroadcastChatName("close_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeBroadcastChatName("close_pressed.svg");
                        },
                    }
                },
                okButton: {
                    left: 0.016,
                    top: 0.296,
                    imageLayout: {
                        width: 0.556,
                        height: 0.064,
                        padding: 0.016,
                        verticalAlignment: VerticalAlignment.Bottom,
                        cornerRadiusPx: 0.016,
                        normalState: { color: "#2787FA" },
                        hoverState: { color: "#13427A" },
                        pressedState: { color: "#60A7FC" },
                    },
                    textLayout: {
                        common: { color: "#FFFFFF", fontSize: Font.F22, fontWeight: "bold", resizeToFit: true },
                        disabled: { color: "#4D4D4D", fontSize: Font.F22, fontWeight: "bold" }
                    }
                },
                error: {
                    color: "#FFFFFF",
                    fontSize: Font.F28,
                    fontWeight: "bold",
                    left: 0.096,
                    top: 0.16,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    resizeToFit: true,
                },
                micIcon: {
                    get image() {
                        return Env.relativeBroadcastChatName("mic_big.svg");
                    },
                    get error() {
                        return Env.relativeBroadcastChatName("voice_to_text_error.svg");
                    },
                    width: 0.104,
                    height: 0.104,
                    left: 0.242,
                    top: 0.048
                }
            }
        },
        complimentDialog: {
            distance: Env.complimentDistance,
            width: 0.588,
            height: 0.904,
            cornerRadius: 0.032,
            header: {
                background: "#FFFFFF14",
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "bold",
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
            },
            grid: {
                rows: ["64*", "240*", "60*", "52*", "168*", "320*"],
                columns: ["1*"]
            },
            pfp: {
                diameter: 0.164,
            },
            pfpContainer: {
                diameter: 0.176,
                thickness: 0.003,
                borderColor: "#564D5B"
            },
            total: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "bold",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
            },
            split: {
                color: "#FFFFFF",
                fontSize: Font.F20,
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
            },
            splitButton: {
                width: 0.02,
                height: 0.02,
                get normalImg() {
                    return Env.relativeNotificationCenterName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeNotificationCenterName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeNotificationCenterName("close_pressed.svg");
                },
                get pressedHoverImg() {
                    return Env.relativeNotificationCenterName("close_pressed.svg");
                },
            },
            message: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "500",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Bottom,
                textVerticalAlignment: VerticalAlignment.Bottom,
                resizeToFit: true,
            },
            request: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "500",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
                background: {
                    gradient: { x0: 0, y0: 0.5, x1: 1, y1: 0.5 },
                    stops: [
                        { offset: 0, color: "#F026AB" },
                        { offset: 1, color: "#2787FA" },
                    ]
                },
                cornerRadius: 0.016,
                width: 0.46,
                height: 0.088,
                padding: {
                    left: 0.02,
                    top: 0.024,
                    right: 0.02,
                    bottom: 0.024
                }
            },
            username: {
                color: "#FFFFFF",
                fontSize: Font.F32,
                fontWeight: "700",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Bottom,
                textVerticalAlignment: VerticalAlignment.Bottom,
                resizeToFit: true,
            },
            buttonHeader: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "bold",
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
            },
            icon: {
                width: 0.052,
                height: 0.052,
                get image() {
                    return Env.relativeBroadcastModeName("private_mode_icon_classic.svg");
                },
            },
            buttonGrid: {
                layout: { rows: ["1*"], columns: ["1*", "1*", "1*", "1*"] },
                width: 0.43514,
                height: 0.1545,
                spacing: 0.018
            },
            valueButton: {
                height: 0.14,
                width: 0.123,
                rotation: 3,
                imageLayout: {
                    cornerRadiusPx: 0.016,
                    common: { color: "#FFFFFF14", borderColor: "#2787FA", borderThickness: 0.001 },
                    pressedState: { color: "#1D4370" },
                    hoverState: { color: "#1D4370" },
                },
                gridLayout: {
                    rows: ["68*", "40*", "40*"],
                    columns: ["1*"]
                },
                tokensBackground: "#2787FA",
                valueTokens: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: true,
                },
                valuePercentage: {
                    color: "#FFFFFF",
                    fontSize: Font.F32,
                    fontWeight: "700",
                    resizeToFit: true,
                    states: [
                        {
                            state: "common", style: {
                                color: "#FFFFFF",
                                fontSize: Font.F32,
                                fontWeight: "700",
                                resizeToFit: true,
                            },
                        },
                        {
                            state: "normal", style: {
                                color: "#8E8793",
                            },
                        },
                        {
                            state: "hover", style: {
                                color: "#FFFFFF",
                            },
                        },
                        {
                            state: "pressed", style: {
                                color: "#FFFFFF",
                            },
                        }
                    ]
                },
                valuePlaceholder: {
                    color: "#8E8793",
                    fontSize: Font.F24,
                    fontWeight: "bold",
                    resizeToFit: true,
                },
                icon: {
                    width: 0.064,
                    height: 0.064,
                    image(idx) {
                        return Env.relativeBroadcastComplimentName(`tip${idx}.svg`);
                    },
                },
                input: {
                    height: 0.028,
                    horizontalAlignment: HorizontalAlignment.Center,
                    cursorLayout: {
                        width: 0.002,
                        height: 0.028,
                    },
                    states: [
                        {
                            state: "common",
                            style: {
                                isCursorEnabled: false,
                                textStyle: {
                                    fontSize: Font.F24,
                                    fontWeight: "700",
                                    color: "white",
                                    resizeToFit: true,
                                    textWrapping: TextWrapping.WordWrap,
                                    textHorizontalAlignment: HorizontalAlignment.Center,
                                    horizontalAlignment: HorizontalAlignment.Center,
                                },
                                placeholderStyle: {
                                    fontSize: Font.F24,
                                    fontWeight: "700",
                                    color: "#B1A3B7",
                                    resizeToFit: true,
                                    textHorizontalAlignment: HorizontalAlignment.Center,
                                    horizontalAlignment: HorizontalAlignment.Center,
                                },
                                backgroundStyle: {
                                    borderThickness: 0
                                },
                                cursorStyle: {
                                    color: "white",
                                    borderThickness: 0,
                                }
                            }
                        },
                        {
                            state: "focused",
                            style: {
                                isCursorEnabled: true,
                            }
                        },
                        {
                            state: "toggled",
                            style: {
                                isCursorEnabled: true,
                            }
                        },
                        {
                            state: "toggledHover",
                            style: {
                                isCursorEnabled: true,
                            }
                        },
                        {
                            state: "toggledPressed",
                            style: {
                                isCursorEnabled: true,
                            }
                        }
                    ],
                    maxLines: 8,
                }
            },
            payButton: {
                height: 0.08,
                width: 0.556,
                padding: {
                    bottom: 0.016,
                },
                imageLayout: {
                    cornerRadiusPx: 0.016,
                    common: {
                        color: "#2787FA"
                    },
                    pressedState: { color: "#6BAFFF" },
                    hoverState: { color: "#6BAFFF" },
                },
                textLayout: {
                    common: {
                        color: "#FFFFFF",
                        fontSize: Font.F24,
                        fontWeight: "bold"
                    }
                }
            },
            closeButton: {
                width: 0.052,
                height: 0.052,
                verticalAlignment: VerticalAlignment.Top,
                horizontalAlignment: HorizontalAlignment.Right,
                top: 0.008,
                right: 0.008,
                get normalImg() {
                    return Env.relativeBroadcastComplimentName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastComplimentName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastComplimentName("close_pressed.svg");
                },
            },
            keyboard: {
                position: {
                    left: 0.4,
                    top: 0.175,
                }
            }
        },
        complimentMessageDialog: {
            width: 0.4,
            height: 0.219,
            cornerRadius: 0.032,
            top: 0.04,
            borderColor: "#5F5862",
            borderThickness: 0.002,
            grid: {
                columns: ["1*"],
                rows: ["1*", "1*"]
            },
            icon: {
                width: 0.064,
                height: 0.064,
                get success() {
                    return Env.relativeBroadcastComplimentName("success.svg");
                },
                get fail() {
                    return Env.relativeBroadcastComplimentName("fail.svg");
                },
            },
            text: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                textHorizontalAlignment: HorizontalAlignment.Center,
            }
        },
        dragAndDrop: Env._menuDragAndDrop,
        helpPanel: {
            width: 0.424,
            height: 0.904,
            root: {
                background: "#241D26",
                cornerRadius: 0.032
            },
            header: {
                background: "#36333C",
                height: 0.064,
                caption: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    horizontalAlignment: HorizontalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Center,
                    verticalAlignment: VerticalAlignment.Center,
                    textVerticalAlignment: VerticalAlignment.Center,
                    resizeToFit: true,
                },
            },
            introHeader: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
                padding: { left: 0.04 }
            },
            sectionHeader: {
                color: "#FFFFFF",
                fontSize: Font.F24,
                fontWeight: "700",
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
            },
            sectionText: {
                color: "#FFFFFF",
                fontSize: Font.F18,
                fontWeight: "500",
                horizontalAlignment: HorizontalAlignment.Left,
                textHorizontalAlignment: HorizontalAlignment.Left,
                verticalAlignment: VerticalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                resizeToFit: true,
                padding: { top: 0.01 }
            },
            highlightedText: {
                background: "#2787FA",
                fontWeight: "700",
                backgroundRadius: 0.008,
                backgroundPadding: {
                    horizontal: 0.005,
                    vertical: 0.001
                }
            },
            sectionSpacing: 0,
            closeButton: {
                width: 0.052,
                height: 0.052,
                top: 0.006,
                right: 0.006,
                get normalImg() {
                    return Env.relativeBroadcastHelpName("close_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastHelpName("close_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastHelpName("close_pressed.svg");
                },
            },
            controllerImage: {
                get img() {
                    return Env.relativeBroadcastHelpName("controller.svg");
                },
                width: 0.224,
                height: 0.262,
                top: 0.143,
                left: 0.078,
            },
            controller: {
                text: {
                    fontWeight: "700",
                    fontSize: Font.F18,
                    color: "#FFFFFF",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textVerticalAlignment: VerticalAlignment.Top,
                    positions: {
                        select: { left: 0.016, top: 0.161 },
                        lobby: { left: 0.016, top: 0.198 },
                        tip: { left: 0.016, top: 0.277 },
                        drag: { left: 0.016, top: 0.356 },
                        prevNext: { left: 0.226, top: 0.119 },
                        zoom: { left: 0.302, top: 0.174 },
                        reset: { left: 0.307, top: 0.2275 },
                        recenter: { left: 0.330, top: 0.270 },
                    }
                },
                longPressText: {
                    fontWeight: "400",
                    fontSize: Font.F14,
                    color: "#2787FA",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    textVerticalAlignment: VerticalAlignment.Top,
                    positions: {
                        lobby: { left: 0.016, top: 0.243 },
                        tip: { left: 0.016, top: 0.322 },
                        prevNext: { left: 0.226, top: 0.140 },
                        recenter: { left: 0.330, top: 0.291 },
                    }
                },
                icons: {
                    width: 0.02,
                    height: 0.024,
                    get leftRight() {
                        return Env.relativeBroadcastHelpName("left_right.svg");
                    },
                    get upDown() {
                        return Env.relativeBroadcastHelpName("up_down.svg");
                    },
                    get press() {
                        return Env.relativeBroadcastHelpName("press.svg");
                    },
                    get longPress() {
                        return Env.relativeBroadcastHelpName("long_press.svg");
                    },
                    positions: {
                        prevNext: { left: 0.202, top: 0.119 },
                        zoom: { left: 0.278, top: 0.174 },
                        reset: { left: 0.283, top: 0.222 },
                        recenter: { left: 0.306, top: 0.270 },
                    }
                }
            },
            infographics: {
                width: 0.114,
                height: 0.168,
                get dragImg() {
                    return Env.relativeBroadcastHelpName("help_drag_and_drop.svg");
                },
                get closeImg() {
                    return Env.relativeBroadcastHelpName("help_close_menu.svg");
                },
                dragSection: {
                    image: {
                        left: 0.047,
                        top: 0.459,
                    },
                    left: 0.177,
                    top: 0.471,
                },
                closeSection: {
                    image: {
                        left: 0.047,
                        top: 0.681,
                    },
                    left: 0.177,
                    top: 0.706,
                },
            },
        },
        messengerPanel: {
            position: { x: 0, y: Env.panel904_Y, z: Env.menuDistance },
        },
        messengerChatListPanel: {
            position: { x: -0.588 / 2 - 0.004 - 0.424 / 2, y: Env.panel904_Y, z: Env.menuDistance },
        },
    },
    spinner: {
        size: 0.096,
        position: { x: 0, y: Env.spinnerY, z: Env.dialogsDistance + 0.01 },
        get path() {
            return Env.relativeBroadcastName("spinner.png");
        },
    },
    zoom: {
        min: -5,
        max: 12.5,
        speed: 10
    },
    controller: {
        longPressDuration: 1000,
        // thumbstickThreshold: {x: 0.2, y: 0.4},
        thumbstickThreshold: { x: 0.2, y: 0.4 },
        icons: {
            get tip() {
                return Env.relativeBroadcastTipsName("send_custom_tip.svg");
            },
            get lobby() {
                return Env.relativeBroadcastNavigationName("home_normal.svg");
            },
            get recenter() {
                return Env.relativeLobbyName("actions_recenter.svg");
            },
            get next() {
                return Env.relativeBroadcastNavigationName("next_broadcast_normal.svg");
            },
            get previous() {
                return Env.relativeBroadcastNavigationName("prev_broadcast_normal.svg");
            },
        }
    },
    progressBar: {
        width: 0.400,
        height: 0.096,
        background: "#241D26",
        color: "#2787FA",
        cornerRadius: 0.032,
        position: { x: 0, y: 0, z: Env.dialogsDistance - 0.05 },
        lerpTime: 500,
        spacing: 0.008,
        icon: {
            width: 0.052,
            height: 0.052
        },
        text: {
            fontSize: Font.F24,
            fontWeight: "500",
            color: "#FFFFFF",
            resizeToFit: true
        }
    },
    relatedBroadcastsCarousel: {
        menu: {
            width: 0.120,
            height: 0.120,
            yMinimize: 0.320 / 2 + 0.096 + 0.096 / 2,
            yMaximize: 0.320 / 2 + 3 * 0.096 + 0.096 / 2,
            visibilityButton: {
                width: 0.096,
                height: 0.096,
                get normalImg() {
                    return Env.relativeBroadcastCarouselName("visibility_button_normal.svg");
                },
                get hoverImg() {
                    return Env.relativeBroadcastCarouselName("visibility_button_hover.svg");
                },
                get pressedImg() {
                    return Env.relativeBroadcastCarouselName("visibility_button_pressed.svg");
                },
            },
        },
        itemsCount: 6,
        radius: {
            x: 0.850,
            z: 0.032 * 3,
        },
        centerPosition: { x: 0, y: 2.5 - 1.23, z: 1.5 + 0.032 * 3 },
        keyAngles: [
            0, // invisible
            35.500,
            57.076,
            90.000,
            180.000 - 57.076,
            180.000 - 35.500,
            180.000, // invisible
        ],
        keyScales: [
            0.4, // invisible
            0.6,
            0.8,
            1.0,
            0.8,
            0.6,
            0.4, // invisible
        ],
        positions: [
            {
                angleInDegrees: 90,
                scale: 1,
                transparency: 1,
            },
            {
                angleInDegrees: 180 - 57.076,
                scale: 0.8,
                transparency: 0.5,
            },
            {
                angleInDegrees: 57.076,
                scale: 0.8,
                transparency: 0.5,
            },
            {
                angleInDegrees: 180 - 35.5,
                scale: 0.6,
                transparency: 0.25,
            },
            {
                angleInDegrees: 35.5,
                scale: 0.6,
                transparency: 0.25,
            },
            {
                angleInDegrees: 180,
                scale: 0.4,
                transparency: 0,
            },
            {
                angleInDegrees: 0,
                scale: 0.4,
                transparency: 0,
            },
        ],
        item: {
            width: 0.528,
            height: 0.320,
            meshPitchInDegrees: 30,
        },
    },
};
Env.videoClip = {
    menu: {
        width: 0.800,
        height: 0.445,
        gapBetweenPanels: 0.005,
        background: "#241D26",
        cornerRadius: 0.032,
        position: {
            center: { x: 0, y: Env.broadcastY, z: Env.menuDistance },
            xAngle: 0,
        },
        dragAndDrop: Env._menuDragAndDrop,
        mainPanel: {
            verticalOffset: -0.904 / 2 + 0.272 / 2,
            height: 0.272,
            gridLine1: {
                layout: {
                    rows: ["0.052m"],
                    //columns: ["auto", "1*", "0.052m"], << "auto" doesn't work with adaptWidthToChildren
                    columns: ["0.052m", "1*", "0.052m"],
                },
                width: 0.768,
                height: 0.052,
                left: 0.016,
                top: 0.016,
                infoButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("info_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("info_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("info_pressed.svg");
                    },
                },
                title: {
                    color: "#FFFFFF",
                    fontSize: Font.F24,
                    fontWeight: "700",
                    // resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    // verticalAlignment: VerticalAlignment.Top,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Ellipsis,
                    padding: {
                        left: 0.016,
                        right: 0.016,
                    },
                },
                helpButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("help_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("help_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("help_pressed.svg");
                    },
                },
            },
            gridLine2: {
                layout: {
                    rows: ["0.052m"],
                    //columns: ["auto", "1*", "0.052m"], << "auto" doesn't work with adaptWidthToChildren
                    columns: [
                        "0.052m", "0.008m", "0.052m", "0.008m", "0.052m",
                        "0.0585m*", "0.016m", "0.008m", "0.206m", "0.016m", "0.195m", "0.0445m*", "0.052m",
                        // "0.0305m", "0.016m", "0.008m", "0.192m", "0.016m", "0.195m", "0.0305m",
                        // "0.052m", "0.008m", "0.052m", "0.008m", "0.052m",
                    ],
                },
                width: 0.768,
                height: 0.052,
                left: 0.016,
                top: 0.076,
                exitXrButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("exit_xr_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("exit_xr_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("exit_xr_pressed.svg");
                    },
                },
                leaveButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("leave_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("leave_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("leave_pressed.svg");
                    },
                },
                // infoButton: {
                //     width: 0.052,
                //     height: 0.052,
                //     horizontalAlignment: HorizontalAlignment.Left,
                //     verticalAlignment: VerticalAlignment.Top,
                //     inactiveInfoPanel: {
                //         get normalImg() {
                //             return Env.relativeVideoClipMainName("info_normal.svg");
                //         },
                //         get hoverImg() {
                //             return Env.relativeVideoClipMainName("info_hover.svg");
                //         },
                //         get pressedImg() {
                //             return Env.relativeVideoClipMainName("info_pressed.svg");
                //         },
                //     },
                //     activeInfoPanel: {
                //         get normalImg() {
                //             return Env.relativeVideoClipMainName("info_pressed.svg");
                //         },
                //         get hoverImg() {
                //             return Env.relativeVideoClipMainName("info_hover.svg");
                //         },
                //         get pressedImg() {
                //             return Env.relativeVideoClipMainName("info_pressed.svg");
                //         },
                //     },
                // },
                libraryButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("library_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("library_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("library_pressed.svg");
                    },
                },
                status: {
                    width: 0.016,
                    height: 0.016,
                    color: {
                        away: "#564D5B",
                        live: "#0C9B56",
                        private: "#F18333",
                        offline: "#0000007F",
                    },
                },
                modelNickname: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Ellipsis,
                },
                liveShowButton: {
                    onlineWidth: 0.195,
                    offlineWidth: 0.176,
                    imageLayout: {
                        height: 0.052,
                        cornerRadiusPx: 0.016,
                        common: {
                            color: "#5A515E",
                        },
                        hoverState: {
                            color: "#7F7383",
                        },
                        pressedState: {
                            color: "#68606B"
                        },
                    },
                    textLayout: {
                        common: {
                            color: "#FFFFFF",
                            fontSize: Font.F20,
                            fontWeight: "700",
                            resizeToFit: true,
                            textHorizontalAlignment: HorizontalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
                heartButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("heart_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("heart_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("heart_pressed.svg");
                    },
                },
                bookmarkButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("bookmark_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("bookmark_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("bookmark_pressed.svg");
                    },
                },
                muteButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    enabledImageLayout: {
                        get normalImg() {
                            return Env.relativeVideoClipMainName("unmuted_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeVideoClipMainName("unmuted_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeVideoClipMainName("unmuted_pressed.svg");
                        }
                    },
                    disabledImageLayout: {
                        get normalImg() {
                            return Env.relativeVideoClipMainName("muted_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeVideoClipMainName("muted_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeVideoClipMainName("muted_pressed.svg");
                        }
                    },
                },
            },
            gridLine3: {
                layout: {
                    rows: ["0.052m"],
                    columns: ["0.088m", "0.016m", "1*", "0.016m", "0.088m"],
                    // columns: ["0.110m", "1*", "0.110m"],
                },
                width: 0.768,
                height: 0.052,
                left: 0.016,
                top: 0.144,
                leftText: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: false,
                    // horizontalAlignment: HorizontalAlignment.Left,
                    // textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                },
                rightText: {
                    color: "#FFFFFF",
                    fontSize: Font.F20,
                    fontWeight: "500",
                    resizeToFit: false,
                    // horizontalAlignment: HorizontalAlignment.Left,
                    // textHorizontalAlignment: HorizontalAlignment.Right,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                },
                slider: {
                    height: 0.012,
                    background: {
                        color: "#5A515E",
                    },
                    foreground: {
                        color: "#FFFFFF",
                        minWidth: 0.012,
                    },
                },
            },
            gridLine4: {
                layout: {
                    rows: ["0.052m"],
                    columns: ["0.016m", "0.290m", "0.052m", "0.016m", "0.052m", "0.016m", "0.052m", "0.222m", "0.016m", "0.052m", "0.016m"],
                },
                layoutWithoutMessenger: {
                    rows: ["0.052m"],
                    columns: ["0.016m", "0.290m", "0.052m", "0.016m", "0.052m", "0.016m", "0.052m", "0.290m", "0.000m", "0.000m", "0.016m"],
                },
                width: 0.800,
                height: 0.052,
                left: 0.000,
                top: 0.204,
                guestPanel: {
                    left: 0.000,
                    top: 0.000,
                    width: 0.280,
                    height: 0.052,
                },
                clientPanel: {
                    left: 0.000,
                    top: 0.000,
                    maxWidth: 0.280,
                    height: 0.052,
                },
                rewindButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("rewind_backward_15_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("rewind_backward_15_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("rewind_backward_15_pressed.svg");
                    },
                    get disabledImg() {
                        return Env.relativeVideoClipMainName("rewind_backward_15_disabled.svg");
                    },
                },
                playButton: {
                    width: 0.052,
                    height: 0.052,
                    playLayout: {
                        // width: 0.052,
                        // height: 0.052,
                        // horizontalAlignment: HorizontalAlignment.Left,
                        // verticalAlignment: VerticalAlignment.Top,
                        get normalImg() {
                            return Env.relativeVideoClipMainName("play_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeVideoClipMainName("play_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeVideoClipMainName("play_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeVideoClipMainName("play_disabled.svg");
                        },
                    },
                    pauseLayout: {
                        // horizontalAlignment: HorizontalAlignment.Left,
                        // verticalAlignment: VerticalAlignment.Top,
                        get normalImg() {
                            return Env.relativeVideoClipMainName("pause_normal.svg");
                        },
                        get hoverImg() {
                            return Env.relativeVideoClipMainName("pause_hover.svg");
                        },
                        get pressedImg() {
                            return Env.relativeVideoClipMainName("pause_pressed.svg");
                        },
                        get disabledImg() {
                            return Env.relativeVideoClipMainName("pause_disabled.svg");
                        },
                    },
                },
                fastForwardButton: {
                    width: 0.052,
                    height: 0.052,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Top,
                    get normalImg() {
                        return Env.relativeVideoClipMainName("rewind_forward_15_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeVideoClipMainName("rewind_forward_15_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeVideoClipMainName("rewind_forward_15_pressed.svg");
                    },
                    get disabledImg() {
                        return Env.relativeVideoClipMainName("rewind_forward_15_disabled.svg");
                    },
                },
                getTokensButton: {
                    imageLayout: {
                        width: 0.135,
                        height: 0.052,
                        cornerRadiusPx: 0.016,
                        common: {
                            color: "#0C9B56",
                        },
                        hoverState: {
                            color: "#0A713F",
                        },
                        pressedState: {
                            color: "#0B5E36"
                        },
                    },
                    textLayout: {
                        common: {
                            color: "#FFFFFF",
                            fontSize: Font.F20,
                            fontWeight: "700",
                            resizeToFit: true,
                            textHorizontalAlignment: HorizontalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
            },
        },
        recommendedVideosPanel: {
            verticalOffset: -0.904 / 2 - 0.005 - 0.168 / 2,
            height: 0.168,
            rotation: 30,
            title: {
                color: "#FFFFFF",
                fontSize: Font.F20,
                fontWeight: "700",
                resizeToFit: true,
                horizontalAlignment: HorizontalAlignment.Center,
                verticalAlignment: VerticalAlignment.Top,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.Ellipsis,
                padding: {
                    left: 0.012,
                    right: 0.012,
                    top: 0.014,
                },
            },
            scrollView: {
                height: 0.116,
                colors: {
                    background: "transparent",
                    bar: "#FFFFFF33",
                    hoverBar: "#FFFFFF33",
                    pressedBar: "#FFFFFF33",
                },
                horizontalBar: {
                    padding: {
                        left: 0.024,
                        top: 0.0010,
                        bottom: 0.006,
                        right: 0.024,
                    },
                    size: 0.008
                },
                speed: 2,
            },
            item: {
                width: 0.165,
                height: 0.100,
                cornerRadius: 0.016,
                spacing: 0.016,
                hover: {
                    thickness: 0.004,
                    color: "#2787FA",
                },
                // outlineRectangle: {
                //   width: 0.254,
                //   height: 0.254,
                //   left0: 0.024,
                //   left1: 0.016,
                //   top: 0.024,
                //   cornerRadius: 0.008,
                //   activeThickness: 0.004,
                //   hoverColor: "#2787FA",
                // },
                // overlayActiveRectangle: {
                //   background: "rgba(26, 22, 28, 0.56)",
                // },
                // currentEnvironmentMark: {
                //   width: 0.064,
                //   height: 0.064,
                //   get img() { return Env.relativeEnvironmentDialogName("current_environment.svg"); },
                // },
                // loadableEnvironmentMark: {
                //   width: 0.064,
                //   height: 0.064,
                //   get img() { return Env.relativeEnvironmentDialogName("loadable_environment.svg"); },
                // },
                // loadingMark: {
                //   width: 0.064,
                //   height: 0.064,
                //   get img() { return Env.relativeEnvironmentDialogName("loading.png"); },
                //   periodMillis: 1000,
                // },
                // isNewMark: {
                //   width: 0.018,
                //   height: 0.018,
                //   top: 0.016,
                //   right: 0.012,
                //   get img() { return Env.relativeCommonName("is_new_mark.svg"); },
                // },
                // caption: {
                //   color: "#FFFFFF",
                //   fontSize: Font.F24,
                //   fontWeight: "500",
                //   resizeToFit: true,
                //   background: "black",
                //   horizontalAlignment: HorizontalAlignment.Left,
                //   verticalAlignment: VerticalAlignment.Top,
                //   textHorizontalAlignment: HorizontalAlignment.Center,
                //   textWrapping: TextWrapping.Ellipsis,
                //   textVerticalAlignment: VerticalAlignment.Center,
                //   top: 0.294,
                //   left: 0.024,
                //   width: 0.254,
                // },
            },
        },
        submenus: {
            ellipsis: {
                offset: {
                    x: 0.358,
                    y: 0.272 / 2 + 0.172 / 2 + 0.005,
                },
            },
            volume: {
                offset: {
                    x: 0.800 / 2 + 0.005 + 0.224 / 2,
                    y: 0.272 / 2 - 0.102,
                },
            },
            clientProfile: {
                offset: {
                    x: -0.800 / 2 + 0.032 + 0.240 / 2,
                    y: 0.272 / 2 - 0.204 + 0.008 + 0.068 / 2,
                },
            },
        },
        infoPanel: {
            width: 0.588,
            height: 0.904,
            header: {
                height: 0.064,
                background: "#36333C",
                caption: {
                    fontSize: Font.F24,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    resizeToFit: true,
                    padding: {
                        left: 0.076,
                        right: 0.076,
                    },
                },
                closeButtonLayout: {
                    width: 0.058,
                    height: 0.052,
                    padding: { right: 0.006 },
                    get normalImg() {
                        return Env.relativeBroadcastModelName("close_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastModelName("close_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastModelName("close_pressed.svg");
                    },
                },
            },
            scrollViewer: {
                colors: {
                    background: "transparent",
                    bar: "#333333",
                    hoverBar: "#272727",
                    pressedBar: "#E6E6E6",
                },
                verticalBar: {
                    size: 0.006,
                    padding: {
                        left: 0.008,
                        right: 0.008,
                        top: 0,
                        bottom: 0.008
                    },
                },
                speed: 2,
                modelProfileContainer: {
                    // width: 0.540,
                    // height: 0.128,
                    colorLayout: {
                        // left: 0.016,
                        // top: 0.016,
                        // horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        width: 0.540,
                        height: 0.080,
                        cornerRadiusPx: 0.016,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "#3C353E" },
                        pressedState: { color: "#332E35" },
                        // toggledState: { color: "#332E35" },
                    },
                    avatar: {
                        photoStatusContainerHeight: 0.064,
                        photo: {
                            diameter: 0.052,
                            left: 0.008,
                            top: 0.032,
                            outlineDiameter: 0.064,
                            outlineThickness: 0.003,
                        },
                        status: {
                            fontSize: Font.F14,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            padding: {
                                left: 0.012,
                                top: 0.006,
                                right: 0.012,
                                bottom: 0.006,
                            },
                            cornerRadius: 0.004,
                            resizeToFit: true,
                            background: {
                                away: "#564D5B",
                                live: "#0C9B56",
                                private: "#F18333",
                                offline: "#0000007F",
                            },
                        },
                    },
                    modelNickname: {
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        left: 0.080,
                        top: 0.010,
                        fontSize: Font.F28,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        resizeToFit: true,
                    },
                    watchShowText: {
                        horizontalAlignment: HorizontalAlignment.Left,
                        verticalAlignment: VerticalAlignment.Top,
                        left: 0.080,
                        top: 0.045,
                        fontSize: Font.F20,
                        fontWeight: "500",
                        color: "#B8B0BC",
                        resizeToFit: true,
                    },
                },
                videoClipDescription: {
                    fontSize: Font.F36,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    width: 0.540,
                    resizeToFit: true,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textWrapping: TextWrapping.WordWrap,
                    padding: {
                        top: 0.040,
                    },
                },
                videoClipAdded: {
                    fontSize: Font.F20,
                    fontWeight: "500",
                    color: "#B8B0BC",
                    width: 0.540,
                    left: 0.024,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textWrapping: TextWrapping.Clip,
                    padding: {
                        top: 0.016,
                        bottom: 0.016,
                    },
                },
                videoClipTagsCaption: {
                    fontSize: Font.F28,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    width: 0.540,
                    left: 0.024,
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textWrapping: TextWrapping.Clip,
                    padding: {
                        top: 0.040,
                        bottom: 0.012,
                    },
                },
                tags: {
                    width: 0.540,
                    unselectedTagsPanel: {
                        header: {
                            fontSize: Font.F32,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            horizontalAlignment: HorizontalAlignment.Left,
                            resizeToFit: true,
                            padding: {
                                top: 0.04,
                                bottom: 0.012,
                            },
                        },
                        tag: {
                            text: {
                                color: "#FFFFFF",
                                fontSize: Font.F20,
                                fontWeight: "500",
                                height: 0.024,
                                resizeToFit: true,
                                horizontalAlignment: HorizontalAlignment.Left,
                                horizontalTextAlignment: HorizontalAlignment.Left,
                                padding: {
                                    left: 0.012,
                                    right: 0.012,
                                    top: 0.008,
                                    bottom: 0.008,
                                },
                            },
                            layout: {
                                states: [
                                    {
                                        state: "common", style: {
                                            color: "rgba(255, 255, 255, 0.08)",
                                            paddingTopPx: 0.004,
                                            paddingBottomPx: 0.004,
                                            paddingLeftPx: 0.004,
                                            paddingRightPx: 0.004,
                                        }
                                    },
                                    { state: "hover", style: { color: "rgba(255, 255, 255, 0.3)" } },
                                    { state: "pressed", style: { color: "#6BAFFF" } },
                                    { state: "tagged", style: { color: "#2787FA" } },
                                    { state: "disabled", style: { color: "#5A515E" } },
                                ],
                                cornerRadiusPx: 0.020,
                                useArc: true,
                            },
                            clearAllLayout: {
                                states: [
                                    {
                                        state: "common", style: {
                                            color: "transparent",
                                            paddingTopPx: 0.004,
                                            paddingBottomPx: 0.004,
                                            paddingLeftPx: 0.004,
                                            paddingRightPx: 0.004,
                                        }
                                    },
                                    { state: "hover", style: { color: "rgba(255, 255, 255, 0.3)" } },
                                    { state: "pressed", style: { color: "rgba(255, 255, 255, 0.08)" } },
                                ],
                                cornerRadiusPx: 0.07,
                                useArc: true,
                            },
                            height: 0.040,
                            margin: 0.008,
                        },
                    },
                },
                gaps: {
                    height24: 0.024,
                },
                separator: {
                    width: 0.540,
                    height: 0.001,
                    background: "#5F5862",
                },
            },
        },
        helpPanel: {
            width: 0.588,
            height: 0.904,
            header: {
                height: 0.064,
                background: "#36333C",
                caption: {
                    fontSize: Font.F24,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    resizeToFit: true,
                    padding: {
                        left: 0.076,
                        right: 0.076,
                    },
                },
                closeButtonLayout: {
                    width: 0.058,
                    height: 0.052,
                    padding: { right: 0.006 },
                    get normalImg() {
                        return Env.relativeBroadcastModelName("close_normal.svg");
                    },
                    get hoverImg() {
                        return Env.relativeBroadcastModelName("close_hover.svg");
                    },
                    get pressedImg() {
                        return Env.relativeBroadcastModelName("close_pressed.svg");
                    },
                },
            },
            // mainGrid: {
            //     rows: ["0.064m", "1*"],
            //     columns: ["1*"]
            // },
            controllerImage: {
                get img() { return Env.relativeBroadcastHelpName("video_controller.svg"); },
                width: 0.224,
                height: 0.262,
                left: 0.159,
                top: 0.147,
            },
            dragImage: {
                get img() { return Env.relativeBroadcastHelpName("video_help_drag_and_drop.svg"); },
                width: 0.114,
                height: 0.168,
                left: 0.128,
                top: 0.463,
            },
            closeMenuImage: {
                get img() { return Env.relativeBroadcastHelpName("video_help_close_menu.svg"); },
                width: 0.114,
                height: 0.168,
                left: 0.128,
                top: 0.685,
            },
            dragSection: {
                left: 0.258,
                top: 0.475,
            },
            closeSection: {
                left: 0.258,
                top: 0.710,
            },
            labels: {
                text: {
                    // fontWeight: "700",
                    // fontSize: Font.F18,
                    // color: "#FFFFFF",
                    // resizeToFit: true,
                    // horizontalAlignment: HorizontalAlignment.Left,
                    // textHorizontalAlignment: HorizontalAlignment.Left,
                    // verticalAlignment: VerticalAlignment.Top,
                    // textVerticalAlignment: VerticalAlignment.Top,
                    positions: {
                        select: { left: 0.095, top: 0.165 },
                        lobby: { left: 0.095, top: 0.202 },
                        playPause: { left: 0.095, top: 0.281 },
                        drag: { left: 0.095, top: 0.338 },
                        forwardRewind: { left: 0.307, top: 0.128 },
                        zoom: { left: 0.386, top: 0.1765 },
                        reset: { left: 0.391, top: 0.2245 },
                        recenter: { left: 0.414, top: 0.267 },
                        // tip: {left: 0.02, top: 0.22},
                        // prevNext: {left: 0.228, top: 0.055},
                    }
                },
                longPressText: {
                    // fontWeight: "400",
                    // fontSize: Font.F14,
                    // color: "#2787FA",
                    // resizeToFit: true,
                    // horizontalAlignment: HorizontalAlignment.Left,
                    // textHorizontalAlignment: HorizontalAlignment.Left,
                    // verticalAlignment: VerticalAlignment.Top,
                    // textVerticalAlignment: VerticalAlignment.Top,
                    positions: {
                        lobby: { left: 0.095, top: 0.247 },
                        // tip: {left: 0.02, top: 0.262},
                        // prevNext: {left: 0.228, top: 0.075},
                        recenter: { left: 0.414, top: 0.288 },
                    }
                },
                icons: {
                    // width: 0.02,
                    // height: 0.024,
                    // get leftRight() {
                    //     return Env.relativeBroadcastHelpName("left_right.svg");
                    // },
                    // get upDown() {
                    //     return Env.relativeBroadcastHelpName("up_down.svg");
                    // },
                    // get press() {
                    //     return Env.relativeBroadcastHelpName("press.svg");
                    // },
                    // get longPress() {
                    //     return Env.relativeBroadcastHelpName("long_press.svg");
                    // },
                    positions: {
                        forwardRewind: { left: 0.283, top: 0.123 },
                        zoom: { left: 0.362, top: 0.171 },
                        reset: { left: 0.367, top: 0.219 },
                        recenter: { left: 0.390, top: 0.267 },
                    }
                }
            },
        },
        // messengerPanel: {
        //     position: {x: 0, y: Env.panel904_Y, z: Env.menuDistance},
        // },
        messengerChatListPanel: {
            position: { x: -0.588 / 2 - 0.004 - 0.424 / 2, y: Env.panel904_Y, z: Env.menuDistance },
        },
    },
    lockedVideoPanel: {
        width: 2.500,
        height: 1.500,
        position: { x: 0, y: 0, z: Env.screenDistance },
        cover: {
            blur: 24,
            overlayColor: "rgba(0, 0, 0, 0.80)",
        },
        purchase: {
            top: 0.374,
            title: {
                width: 1.988,
                fontSize: Font.F40,
                fontWeight: "700",
                color: "#FFFFFF",
                resizeToFit: true,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.WordWrap,
            },
            model: {
                height: 0.064,
                profilePhoto: {
                    photoStatusContainerHeight: 0.064,
                    photo: {
                        diameter: 0.052,
                        outlineDiameter: 0.064,
                        outlineThickness: 0.003,
                    },
                    status: {
                        fontSize: Font.F40,
                        fontWeight: "700",
                        color: "#FFFFFF",
                        padding: {
                            left: 0.012,
                            top: 0.006,
                            right: 0.012,
                            bottom: 0.006,
                        },
                        cornerRadius: 0.004,
                        resizeToFit: true,
                        background: {
                            away: "#564D5B",
                            live: "#0C9B56",
                            private: "#F18333",
                            offline: "#343434",
                        },
                    },
                },
                modelNickname: {
                    // width: 0.200,
                    fontSize: Font.F28,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                    padding: {
                        left: 0.016,
                    },
                },
            },
            price: {
                height: 0.072,
                value: {
                    // width: 0.200,
                    fontSize: Font.F80,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    resizeToFit: true,
                    horizontalAlignment: HorizontalAlignment.Left,
                    verticalAlignment: VerticalAlignment.Center,
                    textHorizontalAlignment: HorizontalAlignment.Left,
                    textVerticalAlignment: VerticalAlignment.Center,
                    textWrapping: TextWrapping.Clip,
                    padding: {
                        right: 0.020,
                    },
                },
                currencyImage: {
                    width: 0.072,
                    height: 0.072,
                    get src() { return Env.relativeCommonName("token_icon.svg"); },
                },
            },
            unlockPanel: {
                width: 0.374,
                height: 0.208,
                unlockButton: {
                    width: 0.374,
                    height: 0.096,
                    get normalImg() { return Env.relativeVideoClipMainName("unlock_button_normal.svg"); },
                    get hoverImg() { return Env.relativeVideoClipMainName("unlock_button_hover.svg"); },
                    get pressedImg() { return Env.relativeVideoClipMainName("unlock_button_pressed.svg"); },
                },
                leaveButton: {
                    rectangleLayout: {
                        width: 0.374,
                        height: 0.096,
                        top: 0.112,
                        horizontalAlignment: HorizontalAlignment.Center,
                        verticalAlignment: VerticalAlignment.Top,
                        cornerRadiusPx: 0.016,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                    },
                    textLayout: {
                        common: {
                            fontSize: Font.F36,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            textWrapping: TextWrapping.Clip,
                            textHorizontalAlignment: HorizontalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
            },
            buyPanel: {
                width: 0.320,
                height: 0.208,
                buyButton: {
                    width: 0.320,
                    height: 0.096,
                    imageLayout: {
                        get normalImg() { return Env.relativeVideoClipMainName("buy_button_normal.svg"); },
                        get hoverImg() { return Env.relativeVideoClipMainName("buy_button_hover.svg"); },
                        get pressedImg() { return Env.relativeVideoClipMainName("buy_button_pressed.svg"); },
                    },
                    textLayout: {
                        common: {
                            fontSize: Font.F36,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            textWrapping: TextWrapping.Clip,
                            textHorizontalAlignment: HorizontalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
                cancelButton: {
                    rectangleLayout: {
                        width: 0.320,
                        height: 0.096,
                        top: 0.112,
                        horizontalAlignment: HorizontalAlignment.Center,
                        verticalAlignment: VerticalAlignment.Top,
                        cornerRadiusPx: 0.016,
                        common: { borderThickness: 0 },
                        normalState: { color: "transparent" },
                        hoverState: { color: "rgba(255, 255, 255, 0.12)" },
                        pressedState: { color: "rgba(255, 255, 255, 0.06)" },
                    },
                    textLayout: {
                        common: {
                            fontSize: Font.F36,
                            fontWeight: "700",
                            color: "#FFFFFF",
                            textWrapping: TextWrapping.Clip,
                            textHorizontalAlignment: HorizontalAlignment.Center,
                            textVerticalAlignment: VerticalAlignment.Center,
                        },
                    },
                },
            },
        },
        final: {
            finalImage: {
                width: 0.104,
                height: 0.104,
                get src() { return Env.relativeVideoClipMainName("final_ok.svg"); },
            },
            finalLine1: {
                width: 0.300,
                fontSize: Font.F40,
                fontWeight: "700",
                color: "#FFFFFF",
                resizeToFit: true,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.Clip,
            },
            finalLine2: {
                width: 0.300,
                fontSize: Font.F36,
                fontWeight: "700",
                color: "#B8B0BC",
                resizeToFit: true,
                textHorizontalAlignment: HorizontalAlignment.Center,
                textVerticalAlignment: VerticalAlignment.Center,
                textWrapping: TextWrapping.Clip,
            },
        },
        verticalGaps: {
            gap48: 0.048,
            gap32: 0.032,
            // gap16: 0.016,
            gap12: 0.012,
        },
    }
};
Env.notificationCenter = {
    maxNumberOfMessages: 3,
    position: { x: 0, y: Env.notificationCenterY, z: Env.notificationCenterDistance },
    gapBetweenPanels: 0.004,
    margin: 0.016,
    fontSize: Font.F24,
    fontWeight: "500",
    textColor: "#FFFFFF",
    timeout: {
        infoMs: 3000,
        warningMs: 10000,
        errorMs: 30000
    },
    background: {
        width: 0.600,
        height: 0.084,
        backgroundColor: "#241D26",
        cornerRadius: 0.032,
        thickness: 0.002,
        borderColor: "#5F5862",
    },
    closeButtonLayout: {
        width: 0.052,
        height: 0.052,
        get normalImg() {
            return Env.relativeNotificationCenterName("close_normal.svg");
        },
        get hoverImg() {
            return Env.relativeNotificationCenterName("close_hover.svg");
        },
        get pressedImg() {
            return Env.relativeNotificationCenterName("close_pressed.svg");
        },
    },
    icon: {
        width: 0.052,
        height: 0.052,
        get info() {
            return Env.relativeNotificationCenterName("information.svg");
        },
        get warning() {
            return Env.relativeNotificationCenterName("warning.svg");
        },
        get error() {
            return Env.relativeNotificationCenterName("error.svg");
        },
    }
};
Env.keyboard = {
    width: 0.588,
    height: Env.keyboardHeight,
    background: "#241D26",
    cornerRadius: 0.032,
    thickness: 0.002,
    outlineColor: "#5F5862",
    keyboardCornerRadius: 0.016,
    horizontalSpacing: 0.004,
    verticalSpacing: 0.004,
    padding: 0.016,
    buttonLayout: {
        width: 0.052,
        height: 0.058,
        cornerRadiusPx: 0.008,
        common: {
            color: "#5A515E",
        },
        hoverState: {
            color: "#7F7383",
        },
        pressedState: {
            color: "#68606B"
        }
    },
    spaceLayout(width) {
        const layout = Object.assign({}, Env.keyboard.buttonLayout);
        layout.width = width;
        return layout;
    },
    emojiButtonLayout: {
        width: 0.052,
        height: 0.058,
        cornerRadiusPx: 0.008,
        common: {
            color: "transparent",
        },
        hoverState: {
            color: "#3C353E",
        },
        pressedState: {
            color: "#332E35"
        }
    },
    specialButtonLayout(width, hasPadding) {
        return {
            width: (width ?? 0.052) + (hasPadding ? 0.012 : 0),
            height: 0.058,
            cornerRadiusPx: 0.008,
            common: {
                color: "#36333C",
            },
            hoverState: {
                color: "#7F7383",
            },
            pressedState: {
                color: "#68606B"
            },
            toggledState: {
                color: "#68606B"
            },
            toggledPressedState: {
                color: "#68606B"
            },
            toggledHoverState: {
                color: "#68606B"
            },
            padding: hasPadding ? { right: 0.012 } : undefined
        };
    },
    enterButtonLayout(width) {
        return {
            width: width ?? 0.08,
            height: 0.058,
            cornerRadiusPx: 0.008,
            common: {
                color: "#2787FA"
            },
            hoverState: {
                color: "#6BAFFF"
            },
            pressedState: {
                color: "#499CFF"
            }
        };
    },
    pageButtonLayout: (isSelected, position) => {
        const layout = {
            width: 0.058 + (position === undefined ? 0 : (position === "left" ? 0.103 : 0.035)),
            height: 0.058,
            useArc: true,
            cornerRadiusPx: 0.024,
            common: {
                color: isSelected ? "#5A515E" : "transparent",
            },
            hoverState: {
                color: isSelected ? "#7F7383" : "#3C353E",
            },
            pressedState: {
                color: isSelected ? "#68606B" : "#332E35"
            },
            padding: position === undefined ? 0.005 : (position === "left" ? {
                left: 0.108,
                top: 0.005,
                right: 0.005,
                bottom: 0.005
            } : { left: 0.005, top: 0.005, right: 0.04, bottom: 0.005 })
        };
        return layout;
    },
    textLayout: {
        fontSize: Font.F24,
        color: "#FFFFFF",
        fontWeight: "400",
        resizeToFit: true
    },
    emojiTextLayout: {
        fontSize: Font.F24,
        color: "#FFFFFF",
        fontWeight: "400",
        resizeToFit: true
    },
    icons: {
        get shift() {
            return Env.relativeKeyboardName("shift_normal.svg");
        },
        get shiftPressed() {
            return Env.relativeKeyboardName("shift_pressed.svg");
        },
        get shiftLock() {
            return Env.relativeKeyboardName("shift_lock.svg");
        },
        get emoji() {
            return Env.relativeKeyboardName("emoji.svg");
        },
        get next() {
            return Env.relativeKeyboardName("next.svg");
        },
        get backspace() {
            return Env.relativeKeyboardName("backspace.svg");
        },
        get send() {
            return Env.relativeKeyboardName("send.svg");
        },
    },
    commonLayout(symbolLayoutCallback, emojiLayoutCallback, sendCallback) {
        return [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p",],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l",],
            [{
                    image: Env.keyboard.icons.shift,
                    shiftImage: Env.keyboard.icons.shiftPressed,
                    capsImage: Env.keyboard.icons.shiftLock,
                    keyCode: 16,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, "z", "x", "c", "v", "b", "n", "m", {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08)
                }],
            [{
                    text: "&+=",
                    shiftText: "&+=",
                    capsText: "&+=",
                    callback: symbolLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, {
                    image: Env.keyboard.icons.emoji,
                    callback: emojiLayoutCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(),
                    isClickKey: true
                }, ",", {
                    text: " ",
                    keyCode: 32,
                    buttonLayout: Env.keyboard.spaceLayout(0.164)
                }, ".", "?", {
                    image: Env.keyboard.icons.send,
                    callback: sendCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true
                }]
        ];
    },
    loginLayout(symbolLayoutCallback, nextCallback) {
        return [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p",],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l",],
            [{
                    image: Env.keyboard.icons.shift,
                    shiftImage: Env.keyboard.icons.shiftPressed,
                    capsImage: Env.keyboard.icons.shiftLock,
                    keyCode: 16,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, "z", "x", "c", "v", "b", "n", "m", {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08)
                }],
            [{
                    text: "&+=",
                    shiftText: "&+=",
                    capsText: "&+=",
                    callback: symbolLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, "@", ",", {
                    text: " ",
                    keyCode: 32,
                    buttonLayout: Env.keyboard.spaceLayout(0.164),
                    isClickKey: true
                }, ".", "?", {
                    image: Env.keyboard.icons.next,
                    callback: nextCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true
                }]
        ];
    },
    commonSymbolLayout(textLayoutCallback, emojiLayoutCallback, sendCallback) {
        return [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            ["-", "/", ":", ";", "(", ")", "$", "€", "£", "\""],
            ["[", "]", "{", "}", "#", "%", "^", "*", "+", "="],
            ["_", "\\", "|", "~", "<", ">", "!", "\'", "`", {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout()
                }],
            [{
                    text: "abc",
                    shiftText: "abc",
                    capsText: "abc",
                    callback: textLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, {
                    image: Env.keyboard.icons.emoji,
                    callback: emojiLayoutCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(),
                    isClickKey: true
                }, ",", {
                    text: " ",
                    keyCode: 32,
                    buttonLayout: Env.keyboard.spaceLayout(0.164)
                }, "&", "@", {
                    image: Env.keyboard.icons.send,
                    callback: sendCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true
                }]
        ];
    },
    loginSymbolLayout(textLayoutCallback, nextCallback) {
        return [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            ["-", "/", ":", ";", "(", ")", "$", "€", "£", "\""],
            ["[", "]", "{", "}", "#", "%", "^", "*", "+", "="],
            ["_", "\\", "|", "~", "<", ">", "!", "\'", "`", {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout()
                }],
            [{
                    text: "abc",
                    shiftText: "abc",
                    capsText: "abc",
                    callback: textLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true
                }, ",", {
                    text: " ",
                    keyCode: 32,
                    buttonLayout: Env.keyboard.spaceLayout(0.22)
                }, "&", "@", {
                    image: Env.keyboard.icons.next,
                    callback: nextCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true
                }]
        ];
    },
    emojiLayout1(textLayoutCallback, page2Callback, page3Callback, sendCallback) {
        return [
            ["\u{1F60A}", "\u{1F609}", "\u{1F60F}", "\u{1F618}", "\u{1F60D}", "\u{1F607}", "\u{1F911}", "\u{1F62E}", "\u{1F9D0}", "\u{1F917}"],
            ["\u{1F92B}", "\u{1F61C}", "\u{1F602}", "\u{1F923}", "\u{1F622}", "\u{1F608}", "\u{1F60E}", "\u{1F92F}", "\u{1F449}", "\u{1F44C}"],
            ["\u{270C}\u{FE0F}", "\u{1F44B}", "\u{1F44F}", "\u{1F64F}", "\u{1F446}", "\u{1F932}", "\u{1F595}", "\u{1F596}", "\u{1F918}", "\u{270A}"],
            ["\u{1F919}", "\u{1F44D}", "\u{1F44E}", "\u{1F91F}", "\u{1F4AA}", "\u{1F648}", "\u{1F649}", "\u{1F64A}", "\u{1F984}", "\u{1F4A9}"],
            [
                {
                    text: "abc",
                    shiftText: "abc",
                    capsText: "abc",
                    callback: textLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "1",
                    callback: () => {
                    },
                    buttonLayout: Env.keyboard.pageButtonLayout(true, "left"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "2",
                    callback: page2Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "3",
                    callback: page3Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false, "right"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(undefined, true),
                },
                {
                    image: Env.keyboard.icons.send,
                    callback: sendCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true,
                }
            ]
        ];
    },
    emojiLayout2(textLayoutCallback, page1Callback, page3Callback, sendCallback) {
        return [
            ["\u{1F32D}", "\u{1F351}", "\u{1F956}", "\u{1F36D}", "\u{1F4A6}", "\u{1F377}", "\u{1F336}\u{FE0F}", "\u{1F525}", "\u{26A1}", "\u{1F386}"],
            ["\u{1F4A5}", "\u{2728}", "\u{1F483}", "\u{1F4A3}", "\u{1F389}", "\u{1F30B}", "\u{1F4A8}", "\u{2668}\u{FE0F}", "\u{1F321}\u{FE0F}", "\u{1F485}"],
            ["\u{1F444}", "\u{1F48B}", "\u{1F445}", "\u{1F440}", "\u{2764}\u{FE0F}", "\u{1F346}", "\u{1F34C}", "\u{1F369}", "\u{1F32E}", "\u{1F352}"],
            ["\u{1F937}\u{1F3FC}\u{200D}\u{2640}\u{FE0F}", "\u{1F481}\u{1F3FC}\u{200D}\u{2640}\u{FE0F}", "\u{1F646}\u{1F3FC}\u{200D}\u{2640}\u{FE0F}", "\u{1F4A4}", "\u{231B}", "\u{23F3}", "\u{1F3AF}", "\u{1F6CC}", "\u{1F40D}", "\u{264B}"],
            [
                {
                    text: "abc",
                    shiftText: "abc",
                    capsText: "abc",
                    callback: textLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "1",
                    callback: page1Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false, "left"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "2",
                    callback: () => {
                    },
                    buttonLayout: Env.keyboard.pageButtonLayout(true),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "3",
                    callback: page3Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false, "right"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(undefined, true),
                },
                {
                    image: Env.keyboard.icons.send,
                    callback: sendCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true,
                }
            ]
        ];
    },
    emojiLayout3(textLayoutCallback, page1Callback, page2Callback, sendCallback) {
        return [
            ["\u{1F680}", "\u{1F459}", "\u{1F3F3}\u{FE0F}\u{200D}\u{1F308}", "\u{2B50}", "\u{1F31F}", "\u{1F337}", "\u{1F490}", "\u{1F381}", "\u{1F4AF}", "\u{1F48E}"],
            ["\u{1F451}", "\u{1F3C6}", "\u{1F4B5}", "\u{1F4B8}", "\u{1F4B0}", "\u{1F4B3}", "\u{1F947}"],
            [{
                    text: "", callback: () => {
                    }, buttonLayout: { width: 0.052, height: 0.058, common: { color: "transparent" } }
                }],
            [{
                    text: "", callback: () => {
                    }, buttonLayout: { width: 0.052, height: 0.058, common: { color: "transparent" } }
                }],
            [
                {
                    text: "abc",
                    shiftText: "abc",
                    capsText: "abc",
                    callback: textLayoutCallback,
                    buttonLayout: Env.keyboard.specialButtonLayout(0.08),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "1",
                    callback: page1Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false, "left"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "2",
                    callback: page2Callback,
                    buttonLayout: Env.keyboard.pageButtonLayout(false),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    text: "3",
                    callback: () => {
                    },
                    buttonLayout: Env.keyboard.pageButtonLayout(true, "right"),
                    isClickKey: true,
                    textStyle: this.textLayout,
                },
                {
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout(undefined, true),
                },
                {
                    image: Env.keyboard.icons.send,
                    callback: sendCallback,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.enterButtonLayout(),
                    isClickKey: true,
                }
            ]
        ];
    },
    tipsLayout(okCallback) {
        return [
            ["1", "2", "3"],
            ["4", "5", "6"],
            ["7", "8", "9"],
            [{
                    image: Env.keyboard.icons.backspace,
                    keyCode: 8,
                    imgWidth: 0.04,
                    imgHeight: 0.04,
                    buttonLayout: Env.keyboard.specialButtonLayout()
                }, "0", {
                    text: "OK",
                    shiftText: "OK",
                    capsText: "OK",
                    callback: okCallback,
                    buttonLayout: Env.keyboard.enterButtonLayout(0.052),
                    isClickKey: true
                }],
        ];
    }
};
Env.environment = {
    defaultIcon: {
        get img() {
            return "default_env_icon.png";
        }, // Not "relative"!
    },
    getAbsUrl(relativeUrl) {
        return Env.relativeEnvironmentName(relativeUrl);
    },
};
Env.xmasCalendar = {
    get sceneUrl() {
        return Env.relativeXmasCalendarName("calendar.glb");
    },
};
